const replaceHTMLAttributes = (
  htmlString,
  attributeName,
  replacementString,
) => {
  // Create a regular expression pattern to match the attribute value
  const regex = new RegExp(`${attributeName}=["'](.*?)["']`, "g");

  // Use the `replace` method to replace the attribute values
  const modifiedHTML = htmlString.replace(
    regex,
    `${attributeName}="${replacementString}"`,
  );

  return modifiedHTML;
};

var removeHTMLAttributes = (htmlString, attributeName) => {
  // Create a regular expression pattern to match the attribute value
  const regex = new RegExp(`${attributeName}=["'](.*?)["']`, "g");

  // Use the `replace` method to replace the attribute values
  const modifiedHTML = htmlString.replace(regex, "");

  return modifiedHTML;
};

var triggerEvent = (element, name, data = {}) => {
  window.events = window.events || {};
  if (!window.events[name]) {
    window.events[name] = debounce((element, name, data) => {
      element.dispatchEvent(
        new CustomEvent(name, {
          bubbles: true,
          detail: data,
        }),
      );
    }, 300);
  }
  window.events[name](element, name, data);
};

var delegate = (parent, eventName, childSelector, callback) => {
  if (typeof childSelector === "function") {
    callback = childSelector;
    childSelector = null;
  }
  const selector = childSelector
    ? childSelector
    : "." + [...parent.classList].join(".").replaceAll(":", "\\:");
  parent.addEventListener(eventName, (event) => {
    const target = event.target.closest(selector);
    if (target) {
      callback(event, target);
    }
  });
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

var trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function (e) {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("model-viewer")
    .forEach((model) => model.modelViewerUI?.pause());
}

function pauseThisMedia(media) {
  if (media.tagName === "VIDEO") {
    media.pause();
  } else if (media.tagName === "IFRAME") {
    if (media.classList.contains("js-youtube")) {
      media.contentWindow.postMessage(
        JSON.stringify({ event: "command", func: "stopVideo", args: [] }),
        "*",
      );
    } else if (media.classList.contains("js-vimeo")) {
      media.contentWindow.postMessage('{"method":"pause"}', "*");
    }
  } else if (media.tagName === "MODEL-VIEWER") {
    media.modelViewerUI?.pause();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

// Scroll lock manager with reference counting
var scrollLockManager = {
  lockedBy: new Set(),
  scrollY: 0,
  /** @type {'fixed' | 'overflow' | null} */
  lockMode: null,

  /**
   * Read current page scroll from all common scrolling roots.
   * @returns {number}
   */
  getCurrentScrollY() {
    return window.scrollY
      || window.pageYOffset
      || document.documentElement.scrollTop
      || document.body.scrollTop
      || 0;
  },

  /**
   * Restore scroll position for both body-scrolling and window-scrolling pages.
   * @param {number} top
   */
  restoreScrollY(top) {
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlBehavior = html.style.scrollBehavior;
    const prevBodyBehavior = body.style.scrollBehavior;

    // Override theme-level `scroll-smooth` so lock/unlock never animates.
    html.style.scrollBehavior = "auto";
    body.style.scrollBehavior = "auto";

    document.documentElement.scrollTop = top;
    document.body.scrollTop = top;
    window.scrollTo(0, top);

    requestAnimationFrame(() => {
      html.style.scrollBehavior = prevHtmlBehavior;
      body.style.scrollBehavior = prevBodyBehavior;
    });
  },

  /**
   * @param {Element} element
   * @param {{ mode?: 'fixed' | 'overflow' }} [options]
   */
  lock(element, options = {}) {
    if (this.lockedBy.size === 0) {
      this.scrollY = this.getCurrentScrollY();
      this.lockMode = options.mode === "overflow" ? "overflow" : "fixed";

      if (this.lockMode === "overflow") {
        document.documentElement.style.overflow = "hidden";
        document.body.style.overflow = "hidden";
        this.restoreScrollY(this.scrollY);
      } else {
        document.body.style.position = "fixed";
        document.body.style.top = `-${this.scrollY}px`;
        document.body.style.width = "100%";
      }
    }

    this.lockedBy.add(element);
    element.dataset.scrollY = String(this.scrollY);
  },

  unlock(element) {
    this.lockedBy.delete(element);

    if (this.lockedBy.size === 0) {
      if (this.lockMode === "overflow") {
        document.documentElement.style.overflow = "";
        document.body.style.overflow = "";
        const currentScroll = this.getCurrentScrollY();
        if (Math.abs(currentScroll - this.scrollY) > 1) {
          this.restoreScrollY(this.scrollY);
        }
      } else {
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        this.restoreScrollY(this.scrollY);
      }
      this.lockMode = null;
    }
  },

  isLocked() {
    return this.lockedBy.size > 0;
  },

  clear() {
    this.lockedBy.clear();
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    this.lockMode = null;
  }
};

// Maintain backward compatibility
/**
 * @param {Element} element
 * @param {{ mode?: 'fixed' | 'overflow' }} [options]
 */
function lockScrollForThis(element, options = {}) {
  scrollLockManager.lock(element, options);
}

function unlockScrollForThis(element) {
  scrollLockManager.unlock(element);
}

function preventDefault(e) {
  e.preventDefault();
}

function handleImageError(imgElement) {
  imgElement.classList.add("hidden");
  const fallback = imgElement.parentElement.querySelector(".fallback");
  fallback.classList.remove("hidden");
}

function getPathWithoutQuery(url) {
  return new URL(url, window.location.origin).pathname;
}
function replaceNodeWithNodeList(nodeToReplace, nodeList) {
  if (!(nodeList instanceof NodeList) && !Array.isArray(nodeList)) {
    throw new Error("Second argument must be a NodeList or an array of nodes");
  }

  const parent = nodeToReplace.parentNode;
  if (!parent) {
    throw new Error("Cannot replace a node that is not in the DOM");
  }

  const fragment = document.createDocumentFragment();

  // If it's an array, we need to iterate differently
  if (Array.isArray(nodeList)) {
    nodeList.forEach((node) => fragment.appendChild(node));
  } else {
    // NodeList is array-like but not an array, so we use this method
    fragment.append(...nodeList);
  }

  parent.replaceChild(fragment, nodeToReplace);
}

function toggleButtonState(button, state) {
  switch (state) {
    case "loading":
      if (button.dataset.state == "loading") return;
      button.setAttribute("aria-disabled", true);
      button.dataset.state = "loading";
      break;

    case "error":
      button.dataset.state = "error";
      button.removeAttribute("aria-disabled");
      navigator.vibrate(100);
      setTimeout(() => button.removeAttribute("data-state"), 3000);
      break;

    case "success":
      button.dataset.state = "success";
      button.removeAttribute("aria-disabled");
      navigator.vibrate(100);
      setTimeout(() => button.removeAttribute("data-state"), 3000);
      break;
  }
}

function updateLabels() {
  const labels = document.querySelectorAll("drawer accordion-content label");
  labels.forEach((label) => {
    const attr = label.getAttribute("for");
    const input = label.querySelector("input");
    if (input) input.setAttribute("id", attr);
    label.setAttribute("for", attr);
    label.control = input;
  });
}

function getVisibleHeight(element) {
  // Get the element's bounding rectangle
  const rect = element.getBoundingClientRect();

  // Get viewport height
  const viewportHeight =
    window.innerHeight || document.documentElement.clientHeight;

  // Calculate top and bottom edges relative to viewport
  const elementTop = rect.top;
  const elementBottom = rect.bottom;

  // Element is completely above or below viewport
  if (elementTop >= viewportHeight || elementBottom <= 0) {
    return 0;
  }

  // Element is partially visible
  if (elementTop < 0) {
    // Element is clipped at top
    return Math.min(elementBottom, viewportHeight);
  }

  if (elementBottom > viewportHeight) {
    // Element is clipped at bottom
    return viewportHeight - elementTop;
  }

  // Element is fully visible
  return rect.height;
}

// fix childMenu positions
var fixChildMenuPositions = () => {
  const childMenus = document.querySelectorAll("._headerChildMenu");
  const isRTL = document.body.style.direction === "rtl";
  const windowWidth = window.innerWidth;

  childMenus.forEach((childMenu) => {
    let isOffScreen = false;
    const childMenuRect = childMenu.getBoundingClientRect();

    // Check if the child menu itself is off-screen
    if (isRTL) {
      isOffScreen = childMenuRect.left < 0;
    } else {
      isOffScreen = childMenuRect.right > windowWidth;
    }

    // If child menu is not off-screen, check its grandchild menus
    if (!isOffScreen) {
      const grandChildMenus = childMenu.querySelectorAll(
        "._headerGrandChildMenu",
      );
      grandChildMenus.forEach((grandChildMenu) => {
        // Temporarily make the grandchild menu visible for accurate measurements
        const originalDisplay = grandChildMenu.style.display;
        grandChildMenu.style.display = "block";
        grandChildMenu.style.visibility = "hidden";

        const grandChildMenuRect = grandChildMenu.getBoundingClientRect();

        // Restore original display
        grandChildMenu.style.display = originalDisplay;
        grandChildMenu.style.visibility = "";

        if (isRTL) {
          if (grandChildMenuRect.left < 0) isOffScreen = true;
        } else {
          if (grandChildMenuRect.right > windowWidth) isOffScreen = true;
        }
      });
    }

    if (isOffScreen) {
      childMenu.setAttribute("data-offscreen", "true");
    } else {
      childMenu.removeAttribute("data-offscreen");
    }
  });
};

/** @type {AbortController | null} */
let menuPositionAbort = null;

/**
 * Bind resize / DOMContentLoaded listeners for submenu overflow correction.
 * Idempotent; pagehide aborts so bfcache pageshow can re-bind.
 */
function initMenuPositionListeners() {
  if (menuPositionAbort) return;
  if (typeof window === "undefined" || typeof document === "undefined") return;

  menuPositionAbort = new AbortController();
  const { signal } = menuPositionAbort;
  window.addEventListener("resize", fixChildMenuPositions, { passive: true, signal });
  if (document.readyState === "loading") {
    window.addEventListener("DOMContentLoaded", fixChildMenuPositions, { signal });
  } else {
    fixChildMenuPositions();
  }
  window.addEventListener(
    "pagehide",
    () => {
      menuPositionAbort?.abort();
      menuPositionAbort = null;
    },
    { once: true, signal },
  );
}

initMenuPositionListeners();

// bfcache restore: pagehide tears listeners down; re-bind on pageshow
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    initMenuPositionListeners();
  }
});


function initImageTextSliders() {
  document.querySelectorAll('.js-image-text-toggle').forEach((el) => {
    el.addEventListener('click', () => {
      el.classList.toggle('active');
    });
  });
}

['DOMContentLoaded', 'shopify:section:load'].forEach((event) => {
  document.addEventListener(event, initImageTextSliders);
});

var normalize = (str) => str?.toString().trim().toLowerCase() || '';

/**
 * Run callback when main thread is idle to reduce Total Blocking Time (Lighthouse).
 * Uses requestIdleCallback when available, with setTimeout fallback and timeout cap.
 * @param {() => void} callback - Work to run during idle time
 * @param {{ timeout?: number }} [options] - Optional timeout in ms (default 2000)
 */
function scheduleIdle(callback, options = {}) {
  const timeout = options.timeout ?? 2000;
  if (typeof requestIdleCallback !== 'undefined') {
    const id = requestIdleCallback(callback, { timeout });
    return () => cancelIdleCallback(id);
  }
  const id = setTimeout(callback, 1);
  return () => clearTimeout(id);
}

function isCartMutationLocked() {
  return window.__electricCartMutationInFlight === true;
}

function setCartMutationLock(isLocked) {
  const locked = Boolean(isLocked);
  window.__electricCartMutationInFlight = locked;
  document.documentElement.toggleAttribute('data-cart-mutating', locked);

  const cartInteractionRoots = [
    ...document.querySelectorAll('cart-dynamic'),
    ...document.querySelectorAll('drawer-element#cart-drawer drawer'),
  ];

  cartInteractionRoots.forEach((element) => {
    if (!element) return;
    element.toggleAttribute('data-cart-mutating', locked);
    element.setAttribute('aria-busy', locked ? 'true' : 'false');
  });
}

function scheduleCartCountVerification(expectedItemCount, onMismatch, delay = 1000) {
  if (window.__electricCartCountVerificationTimeout) {
    window.clearTimeout(window.__electricCartCountVerificationTimeout);
  }

  window.__electricCartCountVerificationTimeout = window.setTimeout(async () => {
    try {
      const cartUrl = window.routes?.cart_url || '/cart';
      const response = await fetch(/\.js(\?|$)/.test(cartUrl) ? cartUrl : `${cartUrl}.js`);
      if (!response.ok) return;

      const cart = await response.json();
      if (typeof expectedItemCount === 'number' && cart.item_count !== expectedItemCount) {
        onMismatch?.(cart);
      }
    } catch (_error) {
      // Silent verification fallback
    } finally {
      window.__electricCartCountVerificationTimeout = null;
    }
  }, delay);
}

(function () {
/**
 * ViewportZoomGuard — detect pinch-zoom via visualViewport and drop compositor
 * pressure while zoomed (iOS Safari WebContent jetsam under layer/backing-store
 * growth). Sets `html[data-viewport-zoomed]` for CSS; pauses autoplay media.
 *
 * Never disables zoom (accessibility). Threshold is slightly above 1 to ignore
 * floating-point noise from visualViewport.scale.
 *
 * @fires viewport:zoom-change - detail: { zoomed: boolean, scale: number }
 * @see https://bugs.webkit.org/show_bug.cgi?id=305622
 * @see https://github.com/electricmaybe/voldt/pull/297
 */

const ZOOM_ATTR = 'data-viewport-zoomed';
const ZOOM_THRESHOLD = 1.01;
const SCALE_EPSILON = 0.002;

/** @type {AbortController | null} */
let abortController = null;
/** @type {boolean} */
let isZoomed = false;
/** @type {number} */
let lastReportedScale = 1;
/** @type {Set<HTMLMediaElement>} */
const pausedByGuard = new Set();

/**
 * @returns {number}
 */
function readScale() {
  try {
    const vv = window.visualViewport;
    if (vv && typeof vv.scale === 'number' && Number.isFinite(vv.scale)) {
      return vv.scale;
    }
  } catch {
    // visualViewport can throw in rare embed contexts
  }
  return 1;
}

/**
 * Pause playing videos/audio while zoomed; remember which to resume.
 * @private
 */
function pauseHeavyMedia() {
  try {
    const media = document.querySelectorAll('video, audio');
    for (const el of media) {
      if (!(el instanceof HTMLMediaElement)) continue;
      if (el.paused || el.ended) continue;
      try {
        el.pause();
        pausedByGuard.add(el);
        el.dataset.viewportZoomPaused = 'true';
      } catch {
        // Ignore media that reject pause
      }
    }
  } catch {
    // DOM may be unavailable during teardown
  }
}

/**
 * Resume media the guard paused (only if still marked and still in document).
 * @private
 */
function resumePausedMedia() {
  for (const el of pausedByGuard) {
    try {
      if (!el.isConnected) {
        pausedByGuard.delete(el);
        continue;
      }
      if (el.dataset.viewportZoomPaused === 'true') {
        delete el.dataset.viewportZoomPaused;
        const playPromise = el.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      }
    } catch {
      // Autoplay policies may block resume; ignore
    }
    pausedByGuard.delete(el);
  }
}

/**
 * Apply or clear zoomed state on <html>.
 * @param {boolean} zoomed
 * @param {number} scale
 * @private
 */
function setZoomedState(zoomed, scale) {
  if (zoomed === isZoomed && Math.abs(scale - lastReportedScale) < SCALE_EPSILON) {
    return;
  }

  const root = document.documentElement;
  isZoomed = zoomed;
  lastReportedScale = scale;

  if (zoomed) {
    root.setAttribute(ZOOM_ATTR, '');
    pauseHeavyMedia();
  } else {
    root.removeAttribute(ZOOM_ATTR);
    resumePausedMedia();
  }

  try {
    root.dispatchEvent(
      new CustomEvent('viewport:zoom-change', {
        detail: { zoomed, scale },
        bubbles: true,
      }),
    );
  } catch {
    // CustomEvent unavailable in ancient engines — ignore
  }
}

/**
 * Re-read scale and sync attribute.
 * @private
 */
function syncFromViewport() {
  const scale = readScale();
  setZoomedState(scale >= ZOOM_THRESHOLD, scale);
}

/**
 * Start listening to visualViewport + window resize fallback.
 * Idempotent; safe to call once from the main bundle.
 */
function initViewportZoomGuard() {
  if (abortController) return;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  abortController = new AbortController();
  const { signal } = abortController;

  const scheduleSync = (() => {
    let rafId = 0;
    return () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        syncFromViewport();
      });
    };
  })();

  const vv = window.visualViewport;
  if (vv) {
    vv.addEventListener('resize', scheduleSync, { passive: true, signal });
    vv.addEventListener('scroll', scheduleSync, { passive: true, signal });
  }

  // Fallback when visualViewport is missing or only window resize fires
  window.addEventListener('resize', scheduleSync, { passive: true, signal });
  window.addEventListener('orientationchange', scheduleSync, { passive: true, signal });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') scheduleSync();
  }, { signal });

  // Initial sync after first paint
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromViewport, { once: true, signal });
  } else {
    syncFromViewport();
  }

  window.addEventListener(
    'pagehide',
    () => {
      abortController?.abort();
      abortController = null;
      pausedByGuard.clear();
    },
    { once: true, signal },
  );
}

initViewportZoomGuard();

// bfcache restore: pagehide tears listeners down; re-bind on pageshow
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    initViewportZoomGuard();
  }
});
})();
/**
 * @fileoverview Core Web Components for Electric Maybe Shopify Theme
 * @description This file contains all the foundational web components used throughout the theme.
a
 * Each component follows modern web standards with proper lifecycle management,
 * accessibility features, and performance optimizations.
 *
 * @author Electric Maybe
 * @version 3.0.0
 * @license MIT
 */


/**
 * No-op: theme uses native loading="lazy". Kept so existing callers (cart, search, rebuy, etc.) do not throw.
 * @param {Element} [_container] - Unused.
 */
function unveilLazyloadIn(_container) {}
if (typeof window !== 'undefined') {
  window.unveilLazyloadIn = unveilLazyloadIn;
}

/**
 * Containers tagged with [data-lazysizes-unveil]: when they enter viewport, call unveilLazyloadIn (no-op).
 * @param {ParentNode} [root=document] - Scope to scan for tagged containers
 */
function observeTaggedLazyContainers(root = document) {
  if (typeof window === 'undefined' || !root?.querySelectorAll) return;
  const targets = root.querySelectorAll('[data-lazysizes-unveil]');
  if (!targets.length) return;

  if (!window.__lazyUnveilObserver && 'IntersectionObserver' in window) {
    window.__lazyUnveilObserver = new IntersectionObserver((entries, observer) => {
      for (let i = 0; i < entries.length; i++) {
        const entry = entries[i];
        if (!entry.isIntersecting) continue;
        unveilLazyloadIn(entry.target);
        observer.unobserve(entry.target);
      }
    }, { rootMargin: '300px 0px' });
  }

  for (let i = 0; i < targets.length; i++) {
    const target = targets[i];
    if (target.dataset.lazyUnveilBound === 'true') continue;
    target.dataset.lazyUnveilBound = 'true';

    if (window.__lazyUnveilObserver) {
      window.__lazyUnveilObserver.observe(target);
    } else {
      unveilLazyloadIn(target);
    }
  }
}

/**
 * Normalize invalid image sizes attributes generated by external scripts.
 * Some third-party scripts can set sizes="0px", which hurts PSI audits.
 * This guard keeps valid values and rewrites only clearly invalid ones.
 * @param {ParentNode} [root=document] - Scope to scan for images.
 */
function sanitizeInvalidImageSizes(root = document) {
  if (typeof window === 'undefined' || !root?.querySelectorAll) return;

  const images = root.querySelectorAll('img[sizes], source[sizes]');
  for (let i = 0; i < images.length; i++) {
    const node = images[i];
    const sizes = (node.getAttribute('sizes') || '').toLowerCase().replace(/\s+/g, '');
    if (!sizes) continue;
    if (sizes !== '0' && sizes !== '0px' && !sizes.includes(',0px')) continue;

    // For 1x/2x srcset we can safely drop sizes; for responsive width sources use a stable fallback.
    const srcset = node.getAttribute('srcset') || '';
    const hasWidthDescriptors = /\s\d+w(?:,|$)/.test(srcset);

    if (hasWidthDescriptors) {
      const width = Number(node.getAttribute('width')) || 0;
      if (width > 0) {
        node.setAttribute('sizes', `${width}px`);
      }
    } else {
      node.removeAttribute('sizes');
    }
  }
}

/**
 * Observe image elements and sanitize invalid sizes values when they mutate.
 * @param {ParentNode} [root=document] - Scope to observe.
 */
function observeInvalidImageSizes(root = document) {
  if (typeof window === 'undefined' || typeof MutationObserver === 'undefined') return;
  if (!root || root.__sizesSanitizerBound) return;
  root.__sizesSanitizerBound = true;

  sanitizeInvalidImageSizes(root);

  const observer = new MutationObserver((mutations) => {
    for (let i = 0; i < mutations.length; i++) {
      const mutation = mutations[i];

      if (mutation.type === 'attributes' && mutation.attributeName === 'sizes' && mutation.target) {
        sanitizeInvalidImageSizes(mutation.target.parentNode || root);
        continue;
      }

      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        for (let j = 0; j < mutation.addedNodes.length; j++) {
          const node = mutation.addedNodes[j];
          if (node?.nodeType === 1) {
            sanitizeInvalidImageSizes(node);
          }
        }
      }
    }
  });

  observer.observe(root, {
    attributes: true,
    attributeFilter: ['sizes'],
    childList: true,
    subtree: true
  });
}

if (typeof document !== 'undefined') {
  const initTaggedLazyObservers = () => {
    observeTaggedLazyContainers(document);
    observeInvalidImageSizes(document.body || document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTaggedLazyObservers, { once: true });
  } else {
    initTaggedLazyObservers();
  }

  document.addEventListener('shopify:section:load', (event) => {
    observeTaggedLazyContainers(event?.target || document);
    sanitizeInvalidImageSizes(event?.target || document);
  });
}

/**
 * LayerManager - Manages z-index stacking context for overlays
 * @class
 * @description Provides dynamic z-index management for modals, drawers, and other overlay elements
 */
class LayerManager {
  constructor() {
    this.layers = [];
    this.baseZIndex = {
      dropdown: 100,    // z-[100]
      sticky: 150,      // z-[150]
      drawer: 200,      // z-[200]
      modal: 300,       // z-[300]
      notification: 400,// z-[400]
      debug: 9999       // z-[9999]
    };
    this.animatingLayers = new Set();
  }

  /**
   * Push a new layer onto the stack with parent tracking
   * @param {string} id - Unique identifier for the layer
   * @param {string} type - Type of layer (modal, drawer, etc.)
   * @param {HTMLElement} element - The element to manage
   * @param {string} parentId - Optional parent layer ID
   * @returns {number} The calculated z-index for this layer
   */
  push(id, type, element, parentId = null) {
    // Remove if already exists (to move to top)
    this.remove(id);

    // Find parent layer if specified
    let parentLayer = null;
    let baseZ = this.baseZIndex[type] || this.baseZIndex.drawer;

    if (parentId) {
      parentLayer = this.layers.find(l => l.id === parentId);
      if (parentLayer) {
        // Child should be above parent by at least 100
        baseZ = Math.max(baseZ, parentLayer.zIndex + 100);
      }
    }

    // Find the highest z-index in use
    const highestZ = this.layers.reduce((max, layer) => {
      return Math.max(max, layer.zIndex);
    }, baseZ - 1);

    // New layer goes above everything else
    const zIndex = Math.max(baseZ, highestZ + 10);

    // Add to stack with parent reference
    this.layers.push({
      id,
      type,
      element,
      zIndex,
      parentId,
      children: []
    });

    // Update parent's children list
    if (parentLayer) {
      parentLayer.children.push(id);
    }

    // Apply z-index
    if (element) {
      element.style.zIndex = zIndex;
      element.dataset.layerZIndex = zIndex;
    }

    return zIndex;
  }

  /**
   * Mark a layer as animating (delays z-index removal)
   */
  startAnimating(id) {
    this.animatingLayers.add(id);
  }

  /**
   * Mark animation as complete and remove if pending
   */
  stopAnimating(id) {
    this.animatingLayers.delete(id);

    // Check if this layer was marked for removal
    const layer = this.layers.find(l => l.id === id);
    if (layer && layer.pendingRemoval) {
      this.remove(id, true);
    }
  }

  /**
   * Remove a layer from the stack
   * @param {string} id - Unique identifier for the layer
   * @param {boolean} immediate - Force immediate removal even if animating
   */
  remove(id, immediate = false) {
    const index = this.layers.findIndex(l => l.id === id);
    if (index === -1) return;

    const layer = this.layers[index];

    // If layer is animating and not forced, mark for removal later
    if (this.animatingLayers.has(id) && !immediate) {
      layer.pendingRemoval = true;
      return;
    }

    // Remove children first
    if (layer.children && layer.children.length > 0) {
      layer.children.forEach(childId => this.remove(childId, immediate));
    }

    // Remove from parent's children list
    if (layer.parentId) {
      const parent = this.layers.find(l => l.id === layer.parentId);
      if (parent && parent.children) {
        parent.children = parent.children.filter(childId => childId !== id);
      }
    }

    // Clear z-index
    if (layer.element) {
      layer.element.style.zIndex = '';
      delete layer.element.dataset.layerZIndex;
    }

    // Remove from stack
    this.layers.splice(index, 1);
  }

  /**
   * Get the current parent context (topmost modal or drawer)
   */
  getCurrentContext() {
    // Find the topmost modal or drawer that could be a parent
    for (let i = this.layers.length - 1; i >= 0; i--) {
      const layer = this.layers[i];
      if (layer.type === 'modal' || layer.type === 'drawer') {
        return layer.id;
      }
    }
    return null;
  }

  /**
   * Get the topmost layer
   * @returns {Object|null} The topmost layer or null
   */
  getTop() {
    return this.layers[this.layers.length - 1] || null;
  }

  /**
   * Check if a specific layer is on top
   * @param {string} id - Unique identifier for the layer
   * @returns {boolean} True if the layer is on top
   */
  isOnTop(id) {
    const top = this.getTop();
    return top && top.id === id;
  }

  /**
   * Debug: Log current layer stack (no-op in production)
   */
  debug() {
    this.layers.forEach(() => {});
  }

  /**
   * Clear all layers
   */
  clear() {
    this.layers.forEach(layer => {
      if (layer.element) {
        layer.element.style.zIndex = '';
        delete layer.element.dataset.layerZIndex;
      }
    });
    this.layers = [];
    this.animatingLayers.clear();
  }
}

// Global instance
window.layerManager = window.layerManager || new LayerManager();

/**
 * @typedef {Object} ComponentInfo
 * @property {string} name - Component name
 * @property {string} tag - HTML tag name
 * @property {string} purpose - What the component does
 * @property {string[]} features - Key features
 * @property {string} usage - Basic usage example
 */

/**
 * @const {ComponentInfo[]} COMPONENTS
 * @description List of all web components defined in this file
 */
const COMPONENTS = [
  {
    name: 'MenuDrawer',
    tag: '<menu-drawer>',
    purpose: 'Mobile navigation drawer with submenu support',
    features: ['Focus trapping', 'Reduced motion support', 'Viewport height management'],
    usage: '<menu-drawer><details>...</details></menu-drawer>'
  },
  {
    name: 'ElectricModal',
    tag: '<electric-modal>',
    purpose: 'Modern modal system with single container approach',
    features: ['ESC key support', 'Focus trapping', 'Dynamic content loading', 'Single container for proper z-index'],
    usage: '<button data-modal-trigger="modal-id">...</button><template data-modal-content="modal-id">...</template>'
  },
  {
    name: 'SectionFetcher',
    tag: '<section-fetcher>',
    purpose: 'Dynamic content loading for sections',
    features: ['URL parameter tracking', 'Intersection observer', 'Debounced fetching'],
    usage: '<section-fetcher data-section-id="..." data-url="...">...</section-fetcher>'
  },
  {
    name: 'DrawerTrigger',
    tag: '<drawer-trigger>',
    purpose: 'Button that triggers a drawer to open/close',
    features: ['Automatic drawer targeting via data-target attribute'],
    usage: '<drawer-trigger data-target="drawer-id">...</drawer-trigger>'
  },
  {
    name: 'SectionFetcherTrigger',
    tag: '<section-fetcher-trigger>',
    purpose: 'Element that triggers a section-fetcher to fetch content on hover',
    features: ['Hover-based triggering', 'Keyboard accessibility', 'Configurable delay'],
    usage: '<section-fetcher-trigger data-target="section-fetcher-id" data-delay="300">...</section-fetcher-trigger>'
  },
  {
    name: 'DrawerElement',
    tag: '<drawer-element>',
    purpose: 'Slide-out drawer container with animations',
    features: ['Smooth animations', 'Scroll locking', 'Focus management'],
    usage: '<drawer-element><drawer>...</drawer></drawer-element>'
  },

  {
    name: 'ElectricTab',
    tag: '<electric-tab>',
    purpose: 'Accessible tab switching functionality with WCAG 2.1 AA compliance',
    features: ['Keyboard navigation (Arrow keys, Home, End)', 'Screen reader announcements', 'Focus management', 'Custom events', 'CSS class management', 'No auto-scroll on load'],
    usage: '<electric-tab><button data-tab-button data-tab-index="0">...</button><div data-tab-content data-tab-index="0">...</div></electric-tab>'
  }
];

/**
 * @const {Object} FEATURES
 * @description Key features implemented across all components
 */
const FEATURES = {
  performance: [
    'Passive event listeners for scroll/touch events',
    'Debounced network requests',
    'Intersection observer for lazy loading',
    'Proper cleanup in disconnectedCallback',
    'Memory leak prevention'
  ],
  accessibility: [
    'ARIA attributes and roles',
    'Keyboard navigation support',
    'Focus trapping and management',
    'Screen reader compatibility',
    'Reduced motion support'
  ]
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
    
    // Listen for search events to close drawer
    this.boundSearchOpenedHandler = this.#handleSearchOpened.bind(this);
    document.addEventListener('search:opened', this.boundSearchOpenedHandler);
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button:not(.dropdown-trigger)").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement =
      event.target.parentElement.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement =
      detailsElement.parentElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    const input = summaryElement.querySelector("input");
    if (input) input.checked = !input.checked;

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 1);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    // this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(`overflow-hidden`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut(e) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.parentElement.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement =
      detailsElement.parentElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 1) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.parentElement.closest("details[open]")) {
          trapFocus(
            detailsElement.parentElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  /**
   * Handle search opened event by closing the drawer
   * @param {CustomEvent} event - The search opened event
   * @private
   */
  #handleSearchOpened(event) {
    // Check if drawer is open and close it
    if (this.mainDetailsToggle && this.mainDetailsToggle.hasAttribute('open')) {
      const summaryElement = this.mainDetailsToggle.querySelector('summary');
      this.closeMenuDrawer(event, summaryElement);
    }
  }

  /**
   * Cleanup event listeners when element is removed
   */
  disconnectedCallback() {
    if (this.boundSearchOpenedHandler) {
      document.removeEventListener('search:opened', this.boundSearchOpenedHandler);
    }
  }
}

if (!customElements.get("menu-drawer")) {
  customElements.define("menu-drawer", MenuDrawer);
}


/**
 * ElectricModal - Modern modal system with single container approach
 * @class
 * @extends HTMLElement
 * @description Creates a single modal container that handles all modal interactions
 */
class ElectricModal extends HTMLElement {
  constructor() {
    super();
    this.modal = null;
    this.backdrop = null;
    this.content = null;
    this.previousFocus = null;
    this.isOpen = false;
    this.scrollPosition = 0;
    this.boundEventHandler = null;
  }

  connectedCallback() {
    // Only create one instance globally
    if (!window.electricModal) {
      window.electricModal = this;
      this.init();
    }
  }

  disconnectedCallback() {
    if (window.electricModal === this) {
      window.electricModal = null;
      this.cleanup();
    }
  }

  init() {
    this.createModalContainer();
    this.setupTriggers();
    this.setupKeyboardListeners();
  }

  cleanup() {
    // Remove event listeners
    if (this.boundEventHandler) {
      document.removeEventListener('click', this.boundEventHandler);
    }
    document.removeEventListener('keydown', this.handleKeydown);

    // Remove modal container
    if (this.modal) {
      this.modal.remove();
    }
  }

  createModalContainer() {
    // Create modal HTML structure
    const modalHTML = `
      <div
        id="electric-modal-container"
        class="fixed inset-0 hidden"
        role="dialog"
        aria-modal="true"
      >
        <!-- Backdrop -->
        <div
          class="electric-modal-backdrop fade-in fixed inset-0 bg-black/50"
          data-modal-close
        ></div>

        <!-- Modal container -->
        <div class="electric-modal-container fixed inset-0 overflow-y-auto p-4 sm:p-6 pointer-events-none">
          <div class="electric-modal-content-container h-full">
            <!-- Modal content -->
            <div
              class="electric-modal-content slide-up-sm relative bg-white shadow-xl pointer-events-auto mx-auto top-1/2 -translate-y-1/2 h-auto max-w-full max-h-full overflow-hidden"
              role="document"
            >
              <!-- Content will be inserted here -->
            </div>
          </div>
        </div>
      </div>
    `;

    // Add to body
    document.body.insertAdjacentHTML('beforeend', modalHTML);

    // Cache elements
    this.modal = document.getElementById('electric-modal-container');
    this.container = this.modal.querySelector('.electric-modal-container');
    this.containerInner = this.modal.querySelector('.electric-modal-content-container');
    this.backdrop = this.modal.querySelector('.electric-modal-backdrop');
    this.content = this.modal.querySelector('.electric-modal-content');

    // Setup backdrop click handler
    this.backdrop.addEventListener('click', () => this.close('backdrop'));
  }

  setupTriggers() {
    // Use event delegation for modal triggers
    this.boundEventHandler = (e) => {
      const trigger = e.target.closest('[data-modal-trigger]');
      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();

      const modalId = trigger.dataset.modalTrigger;
      const data = this.collectTriggerData(trigger);

      this.open(modalId, data);
    };

    document.addEventListener('click', this.boundEventHandler);
  }

  setupKeyboardListeners() {
    this.handleKeydown = (e) => {
      if (!this.isOpen) return;

      if (e.key === 'Escape') {
        this.close('escape');
      }

      // Focus trap
      if (e.key === 'Tab') {
        this.handleTabKey(e);
      }
    };

    document.addEventListener('keydown', this.handleKeydown);
  }

  collectTriggerData(trigger) {
    const data = {};

    // Collect all data-modal-* attributes
    Array.from(trigger.attributes).forEach(attr => {
      if (attr.name.startsWith('data-modal-') && attr.name !== 'data-modal-trigger') {
        const key = attr.name.replace('data-modal-', '');
        data[key] = attr.value;
      }
    });

    // Also collect data-content-class if present on trigger
    if (trigger.hasAttribute('data-content-class')) {
      data.contentClass = trigger.getAttribute('data-content-class');
    }

    return data;
  }

  /**
   * IRL modals use overflow lock so touch scrolling works inside the panel on iOS.
   * @param {string} modalId
   * @returns {'fixed' | 'overflow'}
   * @private
   */
  #resolveScrollLockMode(modalId) {
    const template = document.querySelector(`template[data-modal-content="${modalId}"]`);
    if (template?.innerHTML.includes('irl-modal-panel')) {
      return 'overflow';
    }
    return 'fixed';
  }

  async open(modalId, data = {}) {
    if (this.isOpen) {
      return;
    }

    /** @type {'fixed' | 'overflow'} */
    const scrollLockMode = this.#resolveScrollLockMode(modalId);

    try {
      // Store current focus
      this.previousFocus = document.activeElement;

      // Lock scroll before any async layout work so the page stays put
      this.lockBodyScroll(scrollLockMode);

      // Use LayerManager to handle z-index with parent tracking
      const layerId = `modal-${modalId}`;
      if (window.layerManager) {
        const parentContext = window.layerManager.getCurrentContext();
        window.layerManager.push(layerId, 'modal', this.modal, parentContext);
        this.modal.dataset.layerId = layerId;
        this.currentModalId = layerId;

        // Mark as animating (for fade in)
        window.layerManager.startAnimating(layerId);
      }

      // Load content
      await this.loadContent(modalId, data);

      // Make modal visible but invisible (for layout calculations)
      this.modal.classList.remove('hidden');
      this.modal.style.opacity = '0';
      this.modal.style.pointerEvents = 'none';
      
      // Force layout calculation - multiple frames to ensure layout is settled
      await new Promise(resolve => requestAnimationFrame(resolve));
      this.modal.offsetHeight; // Force reflow
      await new Promise(resolve => requestAnimationFrame(resolve));
      
      // Wait for images to load (affects layout)
      await this.waitForImages(this.content);

      // Force final layout recalculation
      this.modal.offsetHeight; // Force reflow again after images
      await new Promise(resolve => requestAnimationFrame(resolve));

      // Dispatch content-loaded event - components can now manipulate content
      const contentLoadedEvent = this.dispatchEvent('modal:content-loaded', { 
        modalId, 
        data, 
        content: this.content 
      });
      
      if (contentLoadedEvent.defaultPrevented) {
        this.unlockBodyScroll();
        this.modal.classList.add('hidden');
        this.modal.style.opacity = '';
        this.modal.style.pointerEvents = '';
        return;
      }

      // Wait for navigation to complete (async operations in event handlers)
      await new Promise(resolve => requestAnimationFrame(resolve));
      await new Promise(resolve => requestAnimationFrame(resolve));
      this.modal.offsetHeight; // Force reflow after navigation

      // Now show and animate the modal
      this.modal.style.opacity = '';
      this.modal.style.pointerEvents = '';
      await new Promise(resolve => requestAnimationFrame(resolve));
      this.modal.classList.add('modal-open');

      // Set state
      this.isOpen = true;

      // Focus management
      this.trapFocus();

      // Animation complete
      if (window.layerManager && layerId) {
        // Small delay to ensure animation has started
        setTimeout(() => {
          window.layerManager.stopAnimating(layerId);
        }, 300);
      }

      // Dispatch event
      this.dispatchEvent('modal:open', { modalId, data });

    } catch (error) {
      this.unlockBodyScroll();
      this.modal?.classList.add('hidden');
      this.modal.style.opacity = '';
      this.modal.style.pointerEvents = '';
      this.content.innerHTML = '';
      if (window.layerManager && this.modal?.dataset.layerId) {
        window.layerManager.remove(this.modal.dataset.layerId);
        delete this.modal.dataset.layerId;
      }
    }
  }

  async loadContent(modalId, data) {
    // Show loading state
    this.content.innerHTML = `
      <div class="p-8 text-center">
        <div class="inline-block w-6 h-6 border-2 border-gray-300 border-t-gray-900 rounded-full animate-spin"></div>
        <p class="mt-2 text-sm text-gray-600">Loading...</p>
      </div>
    `;

    // Check if there's a template element for this modal
    const template = document.querySelector(`template[data-modal-content="${modalId}"]`);

    // Check for data-bottom-on-mobile and remove padding if present
    if (this.container && template && template.hasAttribute('data-bottom-on-mobile')) {
      this.container.classList.add('max-md:p-0');
      this.containerInner.classList.add('max-md:items-end');
      this.content.classList.add('max-md:pt-6', 'max-md:rounded-t-lg', 'max-md:w-full');
    }

    if (template && template.hasAttribute('data-content-class')) {
      this.content.classList.add(template.getAttribute('data-content-class').replaceAll(' ', ','));
    }

    // Apply content class from trigger data if provided
    if (data.contentClass) {
      const classes = data.contentClass.split(' ').filter(c => c.trim());
      this.content.classList.add(...classes);
    }

    if (template) {
      // Use template content
      this.content.innerHTML = template.innerHTML;

      // Replace any template variables with data
      this.replaceTemplateVariables(data);

      const aspectRatio = this.content.dataset?.aspectRatio;
      if (aspectRatio) {
        this.content.style.aspectRatio = aspectRatio;
      }

      // Check for section-fetcher and load content if present
      const sectionFetcher = this.content.querySelector('section-fetcher');
      if (sectionFetcher) {
        await sectionFetcher.checkAndFetch?.();
      }

    } else {
      // Try to find existing modal content
      const existingModal = document.querySelector(`[data-modal-id="${modalId}"]`);

      const aspectRatio = existingModal.dataset?.aspectRatio;
      if (aspectRatio) {
        this.content.style.aspectRatio = aspectRatio;
      }

      if (existingModal) {
        this.content.innerHTML = existingModal.innerHTML;
      } else {
        // Fallback content
        this.content.innerHTML = `
          <div class="p-6">
            <h3 class="text-lg font-medium mb-4">Modal</h3>
            <p class="text-gray-600 mb-6">Modal content for "${modalId}"</p>
            <div class="flex justify-end">
              <button
                type="button"
                class="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                data-modal-close
              >
                Close
              </button>
            </div>
          </div>
        `;
      }
    }

    // Setup close buttons
    this.setupCloseButtons();
  }

  /**
   * Wait for images in content to load (affects layout calculations)
   * @param {HTMLElement} container - Container element to check for images
   * @returns {Promise<void>}
   * @private
   */
  async waitForImages(container) {
    const images = container.querySelectorAll('img');
    if (images.length === 0) return;

    const imagePromises = Array.from(images).map(img => {
      if (img.complete) return Promise.resolve();
      return new Promise((resolve, reject) => {
        img.onload = resolve;
        img.onerror = resolve; // Resolve even on error to not block
        // Timeout after 500ms to not wait forever
        setTimeout(resolve, 500);
      });
    });

    await Promise.all(imagePromises);
  }

  replaceTemplateVariables(data) {
    Object.keys(data).forEach(key => {
      const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
      this.content.innerHTML = this.content.innerHTML.replace(regex, data[key] || '');
    });
  }

  setupCloseButtons() {
    const closeButtons = this.content.querySelectorAll('[data-modal-close]');
    closeButtons.forEach(button => {
      button.addEventListener('click', () => this.close('button'));
    });
  }

  close(reason = 'programmatic') {
    if (!this.isOpen) return;

    try {
      // Dispatch closing event (cancelable)
      const closingEvent = this.dispatchEvent('modal:closing', { reason });
      if (closingEvent.defaultPrevented) return;

      const layerId = this.modal.dataset.layerId;

      // Mark as animating for close animation
      if (window.layerManager && layerId) {
        window.layerManager.startAnimating(layerId);
      }

      // Remove animation classes
      this.modal.classList.remove('modal-open');

      // Wait for fade out animation (if any)
      const animationDuration = 300; // milliseconds
      setTimeout(() => {
        // Hide modal
        this.modal.classList.add('hidden');

        // Animation complete - now remove from LayerManager
        if (window.layerManager && layerId) {
          window.layerManager.stopAnimating(layerId);
          window.layerManager.remove(layerId);
          delete this.modal.dataset.layerId;
        }

        // Restore body scroll
        this.unlockBodyScroll();

        // Restore focus
        if (this.previousFocus && this.previousFocus.focus) {
          // Use setTimeout to avoid scroll issues
          setTimeout(() => {
            if (this.previousFocus && typeof this.previousFocus.focus === 'function') {
              this.previousFocus.focus({ preventScroll: true });
            }
          }, 0);
        }

        // Clear content
        this.content.innerHTML = '';

        // Reset content classes to base state (remove dynamically added classes)
        this.content.className = 'electric-modal-content slide-up-sm relative bg-white shadow-xl pointer-events-auto mx-auto top-1/2 -translate-y-1/2 h-auto max-w-full max-h-full overflow-hidden';
        
        // Reset container classes if they were modified
        if (this.container) {
          this.container.classList.remove('max-md:p-0');
        }
        if (this.containerInner) {
          this.containerInner.classList.remove('max-md:items-end');
        }

        // Clean up inline styles
        this.modal.style.opacity = '';
        this.modal.style.pointerEvents = '';
        if (this.content.style.aspectRatio) {
          this.content.style.aspectRatio = '';
        }

        // Set state
        this.isOpen = false;
        this.currentModalId = null;

        // Dispatch closed event
        this.dispatchEvent('modal:closed', { reason });
      }, animationDuration);

    } catch (error) {
      // Force cleanup on error
      this.modal.classList.add('hidden');
      this.isOpen = false;
    }
  }

  /**
   * @param {'fixed' | 'overflow'} [mode]
   */
  lockBodyScroll(mode) {
    if (typeof lockScrollForThis === 'function') {
      const resolvedMode = mode
        ?? (this.content.querySelector('.irl-modal-card') ? 'overflow' : 'fixed');
      lockScrollForThis(this.modal, { mode: resolvedMode });
    } else {
      // Fallback if helpers not available
      this.scrollPosition = window.scrollY;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.width = '100%';
    }
  }

  unlockBodyScroll() {
    if (typeof unlockScrollForThis === 'function') {
      unlockScrollForThis(this.modal);
    } else {
      // Fallback if helpers not available
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (this.scrollPosition) {
        window.scrollTo(0, this.scrollPosition);
      }
    }
  }

  trapFocus() {
    const focusableElements = this.content.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    if (focusableElements.length > 0) {
      focusableElements[0].focus({ preventScroll: true });
    }
  }

  handleTabKey(e) {
    const focusableElements = this.content.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus({ preventScroll: true });
      }
    } else {
      if (document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus({ preventScroll: true });
      }
    }
  }

  dispatchEvent(name, detail = {}) {
    const event = new CustomEvent(name, {
      detail,
      bubbles: true,
      cancelable: name === 'modal:closing' || name === 'modal:content-loaded'
    });

    document.dispatchEvent(event);
    return event;
  }

  // Public API methods
  static open(modalId, data = {}) {
    if (window.electricModal) {
      return window.electricModal.open(modalId, data);
    }
  }

  static close(reason = 'programmatic') {
    if (window.electricModal) {
      return window.electricModal.close(reason);
    }
  }

  static isOpen() {
    return window.electricModal ? window.electricModal.isOpen : false;
  }
}
if (!customElements.get("electric-modal")) {
  customElements.define("electric-modal", ElectricModal);
}

// Initialize one instance globally
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('electric-modal')) {
      const modal = document.createElement('electric-modal');
      document.body.appendChild(modal);
    }
  });
} else {
  // DOM is already loaded
  if (!document.querySelector('electric-modal')) {
    const modal = document.createElement('electric-modal');
    document.body.appendChild(modal);
  }
}


class SectionFetcher extends HTMLElement {
  static observedAttributes = [
    "data-url",
    "data-section-id",
    "data-selector",
    "data-animate",
    "data-fire-event",
    "data-onload",
    "data-load-on-event",
  ];

  constructor() {
    super();
    this.handlePopState = this.handlePopState.bind(this);
    this.debouncedCheckAndFetch = this.debounce(
      this.checkAndFetch.bind(this),
      250,
    );
    this.intersectionObserver = null;
  }

  connectedCallback() {
    this.setupInitialState();
    this.addEventListeners();
    this.reWriteData();
    if (this.dataset.onload === "true") {
      this.setupIntersectionObserver();
    }
  }

  disconnectedCallback() {
    this.removeEventListeners();
    this.removeIntersectionObserver();
  }

  setupIntersectionObserver() {
    const options = {
      rootMargin: "0px 0px 800px 0px",
      threshold: 0,
    };

    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && this.dataset.onload === "true") {
          queueMicrotask(() => this.checkAndFetch(true));
          this.removeIntersectionObserver();
        }
      });
    }, options);

    this.intersectionObserver.observe(this);
  }

  removeIntersectionObserver() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue || name !== "data-url") return;
    this.debouncedCheckAndFetch(false, true);
  }

  setupInitialState() {
    const defaultUrl = new URL(window.location.href);
    defaultUrl.searchParams.delete("section_id");
    this.dataset.url = this.dataset.url || defaultUrl.toString();
    this.lastFetchedUrl = this.dataset.url || window.location.href;
  }

  addEventListeners() {
    if (!this.disablePopEvents) {
      window.addEventListener("popstate", this.handlePopState, {
        passive: true,
      });
    }
    if (this.dataset.loadOnEvent) {
      window.addEventListener(this.dataset.loadOnEvent, this.handlePopState, {
        passive: true,
      });
    }
  }

  removeEventListeners() {
    window.removeEventListener("popstate", this.handlePopState);
    if (this.dataset.loadOnEvent) {
      window.removeEventListener(this.dataset.loadOnEvent, this.handlePopState);
    }
  }

  handlePopState() {
    this.dataset.url = this.buildFetchUrl(window.location.href);
    this.debouncedCheckAndFetch(false);
  }

  async checkAndFetch(isInitialLoad = true, isAttributeChange) {
    const currentUrl = new URL(this.dataset.url, window.location.origin);
    const dataUrl = new URL(this.lastFetchedUrl, window.location.origin);

    const relevantParams = new Set([
      "sort_by",
      "page",
      "q",
      ...Array.from(dataUrl.searchParams.keys()).filter((key) =>
        key.startsWith("filter."),
      ),
      ...Array.from(currentUrl.searchParams.keys()).filter((key) =>
        key.startsWith("filter."),
      ),
    ]);

    let shouldFetch = isInitialLoad;

    for (const param of relevantParams) {
      const currentValues = currentUrl.searchParams.getAll(param);
      const dataValues = dataUrl.searchParams.getAll(param);

      if (param === "page" && currentValues[0] == 1 && dataValues.length === 0)
        return;

      if (JSON.stringify(currentValues) !== JSON.stringify(dataValues)) {
        shouldFetch = true;
        dataUrl.searchParams.delete(param); // Remove all existing values for this param
        currentValues.forEach((value) => {
          dataUrl.searchParams.append(param, value); // Add each value individually
        });
      }
    }

    if (shouldFetch) {
      const newUrl = dataUrl.toString();
      const fetchUrl = this.buildFetchUrl(newUrl);

      if (fetchUrl !== this.lastFetchedUrl) {
        this.lastFetchedUrl = fetchUrl;
        await this.fetchAndReplaceContent(fetchUrl, isAttributeChange);
        return true;
      }
    }
  }

  buildFetchUrl(url) {
    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set("section_id", this.dataset.sectionId);
    return fetchUrl.toString();
  }

  keepData() {
    if (!this.dataset.toKeep) return;
    window.temporaryDatas = window.temporaryDatas || {};
    window.temporaryDatas[this.id] = {};
    this.dataset.toKeep.split(",").forEach((data) => {
      window.temporaryDatas[this.id][data] = this.dataset[data];
    });
    setTimeout(() => (window.temporaryDatas = {}), 3000);
  }

  reWriteData() {
    if (!window.temporaryDatas || !window.temporaryDatas[this.id]) return;
    Object.entries(window.temporaryDatas[this.id]).forEach(([key, value]) => {
      this.dataset[key] = value;
    });
  }

  async fetchAndReplaceContent(url, isAttributeChange) {
    try {
      this.keepData();
      let newContent;
      if (
        window.temporaryFeeds &&
        window.temporaryFeeds[this.id] &&
        window.temporaryFeeds[this.id][this.dataset.url]
      ) {
        newContent = this.parseHTML(
          window.temporaryFeeds[this.id][this.dataset.url],
        );
        this.dataset.animate = "false";
      }

      if (!newContent) {
        const response = await this.fetchWithRetry(url);
        const html = await response.text();
        newContent = this.parseHTML(html);
        if (newContent === null) {
          this.remove();
          return;
        }
      }

      // Check if we should preserve the section-fetcher wrapper
      const preserveWrapper = this.dataset.preserveWrapper == "true"; // default to true
      
      if (Array.isArray(newContent)) {
        // If newContent is an array of elements, inject them
        if (preserveWrapper) {
          // Inject into section-fetcher
          this.innerHTML = '';
          newContent.forEach(node => {
            this.appendChild(node.cloneNode(true));
          });
        } else {
          // Remove section-fetcher and append to parent
          const parent = this.parentNode;
          if (parent) {
            newContent.forEach(node => {
              parent.insertBefore(node.cloneNode(true), this);
            });
            this.remove();
          }
        }
      } else if (this.dataset.animate !== "false") {
        await this.animateTransition(newContent);
      } else {
        if (preserveWrapper) {
          // Inject content into section-fetcher
          this.innerHTML = '';
          if (newContent instanceof DocumentFragment) {
            this.appendChild(newContent);
          } else if (newContent.nodeType === Node.ELEMENT_NODE) {
            // If it's a single element, append its children or the element itself
            if (newContent.children.length > 0) {
              Array.from(newContent.children).forEach(child => {
                this.appendChild(child.cloneNode(true));
              });
            } else {
              this.appendChild(newContent.cloneNode(true));
            }
          }
        } else {
          this.replaceWith(newContent);
        }
      }

      this.fireCustomEvent(newContent);
      return true;
    } catch (error) {
      // Error surfaced via return false / caller
    }
  }

  async fetchWithRetry(url, retries = 3) {
    for (let i = 0; i < retries; i++) {
      try {
        const response = await fetch(url);
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);
        return response;
      } catch (error) {
        if (i === retries - 1) throw error;
        await new Promise((resolve) =>
          setTimeout(resolve, 1000 * Math.pow(2, i)),
        );
      }
    }
  }

  parseHTML(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    
    // First try to find element with data-section-id or data-section attribute
    let section = doc.querySelector(`[data-section-id="${this.dataset.sectionId}"]`) ??
      doc.querySelector(`[data-section="${this.dataset.sectionId}"]`);
    
    if (section) {
      return section;
    }
    
    // If not found, try to find .shopify-section wrapper (Shopify wraps sections when fetched)
    const shopifySection = doc.querySelector('.shopify-section');
    if (shopifySection) {
      // Extract only product-card elements if they exist
      const productCards = shopifySection.querySelectorAll('product-card');
      if (productCards.length > 0) {
        // Return array of product-card elements
        return Array.from(productCards);
      }
      
      // If no product-cards, return all children
      if (shopifySection.children.length > 0) {
        return Array.from(shopifySection.children);
      }
      
      // If no children but has innerHTML, use that
      if (shopifySection.innerHTML) {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = shopifySection.innerHTML;
        return wrapper;
      }
      return shopifySection;
    }
    
    // If still not found, try to get body content
    const body = doc.body;
    if (body) {
      // Try to find product-card elements in body
      const productCards = body.querySelectorAll('product-card');
      if (productCards.length > 0) {
        return Array.from(productCards);
      }
      
      // Otherwise return body children
      if (body.children.length > 0) {
        return Array.from(body.children);
      }
      
      // Last resort: return body content as a wrapper div
      if (body.innerHTML) {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = body.innerHTML;
        return wrapper;
      }
    }
    
    return null;
  }

  async animateTransition(newContent) {
    await this.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 100,
    }).finished;

    const preserveWrapper = this.dataset.preserveWrapper == "true"; // default to true
    
    if (Array.isArray(newContent)) {
      // If newContent is an array of elements, inject them
      if (preserveWrapper) {
        // Inject into section-fetcher
        this.innerHTML = '';
        newContent.forEach(node => {
          this.appendChild(node.cloneNode(true));
        });
      } else {
        // Remove section-fetcher and append to parent
        const parent = this.parentNode;
        if (parent) {
          newContent.forEach(node => {
            parent.insertBefore(node.cloneNode(true), this);
          });
          this.remove();
        }
      }
    } else if (preserveWrapper) {
      // Inject content into section-fetcher
      this.innerHTML = '';
      if (newContent instanceof DocumentFragment) {
        this.appendChild(newContent);
      } else if (newContent.nodeType === Node.ELEMENT_NODE) {
        // If it's a single element, append its children or the element itself
        if (newContent.children.length > 0) {
          Array.from(newContent.children).forEach(child => {
            this.appendChild(child.cloneNode(true));
          });
        } else {
          this.appendChild(newContent.cloneNode(true));
        }
      }
    } else {
      this.replaceWith(newContent);
    }

    this.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: 100,
    });
  }

  replaceContent(newContent) {
    replaceNodeWithNodeList(this, newContent);
  }

  fireCustomEvent(newContent) {
    if (this.dataset.fireEvent) {
      const event = new CustomEvent(this.dataset.fireEvent, {
        bubbles: true,
        detail: {
          source: this.dataset.id,
          found: newContent.length > 0,
        },
      });
      this.dispatchEvent(event);
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

if (!customElements.get("section-fetcher")) {
  customElements.define("section-fetcher", SectionFetcher);
}


/**
 * DrawerTrigger Web Component
 * 
 * A trigger element that opens/closes a target drawer. Automatically connects
 * to drawer elements and provides proper accessibility attributes and state management.
 * 
 * @example
 * <button is="drawer-trigger" data-target="my-drawer" aria-expanded="false">
 *   Open Menu
 * </button>
 * <drawer-element id="my-drawer">...</drawer-element>
 */
if (!customElements.get("drawer-trigger")) {
customElements.define(
  "drawer-trigger",
  class DrawerTrigger extends HTMLElement {
    constructor() {
      super();
      
      // Initialize properties
      this.targetDrawer = null;
      this.clickHandler = this.#handleClick.bind(this);
      this.keyHandler = this.#handleKeyDown.bind(this);
      
      // Set default ARIA attributes
      this.setAttribute('role', 'button');
      this.setAttribute('tabindex', '0');
      this.setAttribute('aria-expanded', 'false');
      this.setAttribute('aria-haspopup', 'dialog');
    }

    /**
     * Called when the element is connected to the DOM
     * @private
     */
    connectedCallback() {
      this.#connectToTarget();
      this.#bindEvents();
    }

    /**
     * Disconnect the component and clean up resources
     * @private
     */
    disconnectedCallback() {
      this.#disconnectFromTarget();
      this.#unbindEvents();
    }

    /**
     * Connect this trigger to its target drawer
     * @private
     */
    #connectToTarget() {
      const targetId = this.dataset.target;
      if (!targetId) {
        return;
      }

      // Use a small delay to ensure drawer is available
      setTimeout(() => {
        this.targetDrawer = document.getElementById(targetId);
        
        if (!this.targetDrawer) {
          return;
        }

        // Verify it's a drawer element
        if (!this.targetDrawer.matches('drawer-element')) {
          return;
        }

        // Add this trigger to drawer's triggers
        if (!this.targetDrawer.triggers) {
          this.targetDrawer.triggers = new Set();
        }
        this.targetDrawer.triggers.add(this);

        // Update ARIA attributes based on drawer state
        this.#updateAriaAttributes();
        
        // Listen for drawer state changes
        this.targetDrawer.addEventListener('drawer:opening', this.#updateAriaAttributes.bind(this));
        this.targetDrawer.addEventListener('drawer:closing', this.#updateAriaAttributes.bind(this));
        
      }, 100);
    }

    /**
     * Disconnect this trigger from its target drawer
     * @private
     */
    #disconnectFromTarget() {
      if (this.targetDrawer?.triggers) {
        this.targetDrawer.triggers.delete(this);
        
        // Remove event listeners
        this.targetDrawer.removeEventListener('drawer:opening', this.#updateAriaAttributes.bind(this));
        this.targetDrawer.removeEventListener('drawer:closing', this.#updateAriaAttributes.bind(this));
      }
      
      this.targetDrawer = null;
    }

    /**
     * Bind event listeners
     * @private
     */
    #bindEvents() {
      this.addEventListener('click', this.clickHandler);
      this.addEventListener('keydown', this.keyHandler);
    }

    /**
     * Unbind event listeners
     * @private
     */
    #unbindEvents() {
      this.removeEventListener('click', this.clickHandler);
      this.removeEventListener('keydown', this.keyHandler);
    }

    /**
     * Handle click events to toggle drawer
     * @param {Event} event - The click event
     * @private
     */
    #handleClick(event) {
      event.preventDefault();
      
      const targetId = this.dataset.target;
      const isMobileTablet = window.innerWidth < 1024;
      if (targetId === 'cart-drawer') {
        // Start loading cart UI script immediately so it may be ready by the time openDrawer awaits it
        if (typeof loadCartScriptOnce === 'function') loadCartScriptOnce();
        if (isMobileTablet) {
          // Scroll instantly before drawer opens to ensure lockScrollForThis captures scrollY=0
          window.scrollTo({ top: 0, behavior: 'instant' });
        }
      }
      
      if (!this.targetDrawer) {
        return;
      }

      this.#hydrateDeferredDrawerContent();

      if (typeof this.targetDrawer.toggleDrawer === 'function') {
        this.targetDrawer.toggleDrawer(this);
      }
    }

    /**
     * Lazily inject deferred drawer content from a template before first open.
     * @private
     */
    #hydrateDeferredDrawerContent() {
      if (!this.targetDrawer?.hasAttribute('data-deferred-drawer')) return;
      if (this.targetDrawer.dataset.deferredDrawerHydrated === 'true') return;

      const templateId = this.targetDrawer.getAttribute('data-deferred-drawer-template-id');
      if (!templateId) return;

      const template = document.getElementById(templateId);
      if (!(template instanceof HTMLTemplateElement)) return;

      const drawerContentRoot = this.targetDrawer.querySelector('drawer');
      if (!drawerContentRoot) return;

      const deferredFragment = template.content.cloneNode(true);
      drawerContentRoot.appendChild(deferredFragment);
      this.targetDrawer.dataset.deferredDrawerHydrated = 'true';
      template.remove();
    }

    /**
     * Handle keyboard events for accessibility
     * @param {KeyboardEvent} event - The keydown event
     * @private
     */
    #handleKeyDown(event) {
      switch (event.key) {
        case 'Enter':
        case ' ':
          event.preventDefault();
          this.#handleClick(event);
          break;
        case 'Escape':
          // Close drawer if it's open
          if (this.targetDrawer?.isOpen) {
            this.targetDrawer.closeDrawer();
          }
          break;
      }
    }

    /**
     * Update ARIA attributes based on drawer state
     * @private
     */
    #updateAriaAttributes() {
      if (!this.targetDrawer) return;
      
      const isOpen = this.targetDrawer.isOpen || false;
      this.setAttribute('aria-expanded', isOpen.toString());
      
      // Update aria-controls to reference the drawer
      if (this.targetDrawer.id) {
        this.setAttribute('aria-controls', this.targetDrawer.id);
      }
    }

    /**
     * Get the current target drawer element
     * @returns {HTMLElement|null} The target drawer element or null if not connected
     * @public
     */
    getTargetDrawer() {
      return this.targetDrawer;
    }

    /**
     * Check if the trigger is connected to a valid drawer
     * @returns {boolean} True if connected to a valid drawer
     * @public
     */
    isConnected() {
      return this.targetDrawer !== null;
    }

    /**
     * Static method to find all triggers for a specific drawer
     * @param {string} drawerId - The ID of the drawer to find triggers for
     * @returns {DrawerTrigger[]} Array of trigger elements
     * @public
     */
    static getTriggersForDrawer(drawerId) {
      return Array.from(document.querySelectorAll(`drawer-trigger[data-target="${drawerId}"]`));
    }

    /**
     * Static method to validate if an element is a valid drawer trigger
     * @param {HTMLElement} element - The element to validate
     * @returns {boolean} True if the element is a valid drawer trigger
     * @public
     */
    static isValidTrigger(element) {
      return element && 
             element.matches('drawer-trigger') && 
             element.dataset.target &&
             document.getElementById(element.dataset.target);
    }
  }
);
}

/**
 * SectionFetcherTrigger Web Component
 * 
 * A trigger element that fetches content for a target section-fetcher on hover.
 * Similar to drawer-trigger but uses hover events instead of click events.
 * 
 * @example
 * <section-fetcher-trigger data-target="my-section-fetcher" data-delay="300">
 *   Hover to load
 * </section-fetcher-trigger>
 * <section-fetcher id="my-section-fetcher" data-section-id="..." data-url="..."></section-fetcher>
 */
if (!customElements.get("section-fetcher-trigger")) {
customElements.define(
  "section-fetcher-trigger",
  class SectionFetcherTrigger extends HTMLElement {
    #targetFetcher = null;
    #hoverHandler = null;
    #focusHandler = null;
    #blurHandler = null;
    #hoverTimeout = null;
    #hasTriggered = false;
    #abortController = null;

    constructor() {
      super();
      
      // Bind handlers
      this.#hoverHandler = this.#handleHover.bind(this);
      this.#focusHandler = this.#handleFocus.bind(this);
      this.#blurHandler = this.#handleBlur.bind(this);
      
      // Set default ARIA attributes
      this.setAttribute('role', 'button');
      this.setAttribute('tabindex', '0');
      this.setAttribute('aria-haspopup', 'true');
    }

    /**
     * Called when the element is connected to the DOM
     * @private
     */
    connectedCallback() {
      this.#connectToTarget();
      this.#bindEvents();
    }

    /**
     * Disconnect the component and clean up resources
     * @private
     */
    disconnectedCallback() {
      this.#unbindEvents();
      this.#disconnectFromTarget();
    }

    /**
     * Connect this trigger to its target section-fetcher
     * @private
     */
    #connectToTarget() {
      const targetId = this.dataset.target;
      if (!targetId) {
        return;
      }

      // Use a small delay to ensure section-fetcher is available
      setTimeout(() => {
        this.#targetFetcher = document.getElementById(targetId);
        
        if (!this.#targetFetcher) {
          // Try querySelector as fallback
          this.#targetFetcher = document.querySelector(`section-fetcher[data-section-id="${targetId}"]`);
        }
        
        if (!this.#targetFetcher) {
          return;
        }

        // Verify it's a section-fetcher element
        if (!this.#targetFetcher.matches('section-fetcher')) {
          return;
        }

        // Update aria-controls to reference the section-fetcher
        if (this.#targetFetcher.id) {
          this.setAttribute('aria-controls', this.#targetFetcher.id);
        }
      }, 100);
    }

    /**
     * Disconnect this trigger from its target section-fetcher
     * @private
     */
    #disconnectFromTarget() {
      this.#targetFetcher = null;
      this.#hasTriggered = false;
    }

    /**
     * Bind event listeners
     * @private
     */
    #bindEvents() {
      this.addEventListener('mouseenter', this.#hoverHandler);
      this.addEventListener('focus', this.#focusHandler);
      this.addEventListener('blur', this.#blurHandler);
    }

    /**
     * Unbind event listeners
     * @private
     */
    #unbindEvents() {
      this.removeEventListener('mouseenter', this.#hoverHandler);
      this.removeEventListener('focus', this.#focusHandler);
      this.removeEventListener('blur', this.#blurHandler);
      this.#clearHoverTimeout();
    }

    /**
     * Clear the hover timeout
     * @private
     */
    #clearHoverTimeout() {
      if (this.#hoverTimeout) {
        clearTimeout(this.#hoverTimeout);
        this.#hoverTimeout = null;
      }
    }

    /**
     * Handle hover events to trigger fetch
     * @param {Event} event - The mouseenter event
     * @private
     */
    #handleHover(event) {
      if (!this.#targetFetcher || this.#hasTriggered) {
        return;
      }

      // Get delay from data-delay attribute (default: 0ms)
      const delay = parseInt(this.dataset.delay || '0', 10);

      // Clear any existing timeout
      this.#clearHoverTimeout();

      // Set timeout to trigger fetch after delay
      this.#hoverTimeout = setTimeout(() => {
        this.#triggerFetch();
      }, delay);
    }

    /**
     * Handle focus events for keyboard accessibility
     * @param {Event} event - The focus event
     * @private
     */
    #handleFocus(event) {
      // Trigger on focus for keyboard users (no delay)
      if (!this.#targetFetcher || this.#hasTriggered) {
        return;
      }
      this.#triggerFetch();
    }

    /**
     * Handle blur events
     * @param {Event} event - The blur event
     * @private
     */
    #handleBlur(event) {
      // Clear timeout if user moves away before delay completes
      this.#clearHoverTimeout();
    }

    /**
     * Trigger the section-fetcher to fetch content
     * @private
     */
    #triggerFetch() {
      if (!this.#targetFetcher || this.#hasTriggered) {
        return;
      }

      // Check if section-fetcher has a checkAndFetch method
      if (typeof this.#targetFetcher.checkAndFetch === 'function') {
        this.#hasTriggered = true;
        this.setAttribute('aria-busy', 'true');
        
        // Trigger the fetch
        this.#targetFetcher.checkAndFetch(true, false).then(() => {
          this.removeAttribute('aria-busy');
          this.setAttribute('aria-expanded', 'true');
          
          // Dispatch custom event
          this.dispatchEvent(new CustomEvent('section-fetcher:triggered', {
            bubbles: true,
            detail: { 
              trigger: this,
              fetcher: this.#targetFetcher
            }
          }));
        }).catch(() => {
          this.removeAttribute('aria-busy');
          this.#hasTriggered = false; // Allow retry on error
        });
      }
    }

    /**
     * Get the current target section-fetcher element
     * @returns {HTMLElement|null} The target section-fetcher element or null if not connected
     * @public
     */
    getTargetFetcher() {
      return this.#targetFetcher;
    }

    /**
     * Check if the trigger is connected to a valid section-fetcher
     * @returns {boolean} True if connected to a valid section-fetcher
     * @public
     */
    isConnected() {
      return this.#targetFetcher !== null;
    }

    /**
     * Reset the trigger to allow fetching again
     * @public
     */
    reset() {
      this.#hasTriggered = false;
      this.removeAttribute('aria-busy');
      this.removeAttribute('aria-expanded');
    }
  }
);
}

/** One-time load of cart.js for cart drawer (script URL from window.theme.cart_script_url). */
let cartScriptLoadPromise = null;
function loadCartScriptOnce() {
  if (!window.theme?.cart_script_url) return Promise.resolve();
  if (cartScriptLoadPromise) return cartScriptLoadPromise;
  cartScriptLoadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = window.theme.cart_script_url;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => {
      cartScriptLoadPromise = null;
      reject(new Error("Cart script failed to load"));
    };
    document.head.appendChild(script);
  });
  return cartScriptLoadPromise;
}

// Define drawer-element custom element with position-aware animations
if (!customElements.get("drawer-element")) {
customElements.define(
  "drawer-element",
  class DrawerElement extends HTMLElement {
    constructor() {
      super();
      this.drawer = this.querySelector("drawer");
      this.overlay = this.querySelector(".js-overlay");
      this.keepHeader = false;
      this.isOpen = false;
      this.animationDuration =
        parseInt(this.dataset.animationDuration) || window.animation.duration;
      
      // Get position information from data attributes
      this.positionMobile = this.dataset.positionMobile || 'right';
      this.positionDesktop = this.dataset.positionDesktop || 'right';
      
      // Initialize resize handler
      this.resizeHandler = null;
      this.resizeTimeout = null;

      this.bindEvents();
      
      // Listen for search events to close drawer
      this.boundSearchOpenedHandler = this.#handleSearchOpened.bind(this);
      document.addEventListener('search:opened', this.boundSearchOpenedHandler);
    }

    /**
     * Called when the element is connected to the DOM
     * @private
     */
    connectedCallback() {
      // Ensure drawer is properly initialized
      if (!this.drawer) {
        return;
      }

      // Set initial state
      this.isOpen = false;
      this.keepHeader = false;

      // Remove the CSS transform classes that might conflict with JS animations
      const removeToOpenClasses = this.drawer.getAttribute('data-remove-to-open');
      if (removeToOpenClasses) {
        const classesToRemove = removeToOpenClasses.trim().split(/\s+/);
        classesToRemove.forEach(cls => {
          this.drawer.classList.remove(cls);
        });
      }

      // Set initial transform based on position using JS instead of CSS
      const currentPosition = this.#getCurrentPosition();
      this.drawer.style.transform = this.#getInitialTransform(currentPosition);
      this.drawer.style.visibility = "hidden";

      // Ensure the drawer element is properly positioned
      this.style.display = 'none';

      // Cart drawer: open 500ms after cart:adding only when cart already has items;
      // when cart is empty, wait for cart:added so we don't show "cart is empty" then flash update
      if (this.id === 'cart-drawer') {
        this.cartAddingTimeoutId = null;
        this.boundCartAddingHandler = () => {
          const isCartPage = window.theme?.templateName === 'cart' ||
                             window.location.pathname === '/cart' ||
                             window.location.pathname.startsWith('/cart?');
          if (isCartPage) return;
          if (this.isOpen) return;
          if (this.cartAddingTimeoutId) return; // already scheduled
          // Preload cart script so electric-cart-upsell-tabs is defined before refetch sets innerHTML (product page / empty-cart path)
          loadCartScriptOnce();
          const cartUrl = (typeof routes !== 'undefined' && routes?.cart_url) ? routes.cart_url : (window.routes?.cart_url || '/cart');
          fetch(`${cartUrl}.js`, { cache: 'no-store' })
            .then((res) => res.ok ? res.json() : null)
            .then((cart) => {
              const itemCount = cart?.item_count ?? -1;
              const scheduledTimeout = !!(cart && cart.item_count > 0);
              if (cart && cart.item_count > 0) {
                this.cartAddingTimeoutId = setTimeout(() => {
                  this.cartAddingTimeoutId = null;
                  if (!this.drawer || this.isOpen) return;
                  this.#setCartDrawerLoading(true);
                  this.openDrawer();
                }, 500);
              }
              // When cart is empty or fetch failed: do not open here; cart:added will open the drawer with correct content
            })
            .catch(() => {
              // On fetch error, do not open on timeout—wait for cart:added so we never show empty drawer
            });
        };
        document.addEventListener('cart:adding', this.boundCartAddingHandler);
      }

      // Check for data-load-on-event attribute and set up event listener
      if (this.dataset.loadOnEvent) {
        const eventName = this.dataset.loadOnEvent;

        // Create bound event handler to maintain reference for cleanup
        this.boundEventHandler = async (event) => {
          // Cart drawer: always refetch and clear loading on cart:added (even if already open from cart:adding)
          if (eventName === 'cart:added' && this.id === 'cart-drawer') {
            const source = event.detail?.source ?? 'unknown';
            const isCartPage = window.theme?.templateName === 'cart' ||
                               window.location.pathname === '/cart' ||
                               window.location.pathname.startsWith('/cart?');
            if (this.cartDrawerRefetching) {
              return;
            }
            if (isCartPage) {
              return;
            }
            // product-form / product-card-atc: when drawer already has cart-dynamic, sections update already ran; skip refetch. When drawer has no cart-dynamic (empty-cart initial state), refetch to pull fresh content then open.
            if (source === 'product-form' || source === 'product-card-atc') {
              const drawerHasCartDynamic = this.drawer && this.drawer.querySelectorAll('cart-dynamic').length > 0;
              const drawerHasContent = drawerHasCartDynamic;
              if (drawerHasContent) {
                this.#setCartDrawerLoading(false);
                if (!this.isOpen) this.openDrawer();
                return;
              }
              // Drawer has no cart-dynamic (empty-cart state): refetch cart drawer section to get fresh HTML, then open
              if (this.cartDrawerRefetching) return;
              this.cartDrawerRefetching = true;
              this.#setCartDrawerLoading(true);
              this.#refetchCartSection()
                .then(() => {
                  if (!this.isOpen) this.openDrawer();
                })
                .finally(() => {
                  this.cartDrawerRefetching = false;
                  this.#setCartDrawerLoading(false);
                });
              return;
            }
            this.cartDrawerRefetching = true;
            this.#setCartDrawerLoading(true);
            this.#refetchCartSection()
              .finally(() => {
                this.cartDrawerRefetching = false;
                this.#setCartDrawerLoading(false);
              });
          }
          if (!this.isOpen) {
            this.openDrawer();
          }
        };

        // Add event listener to document
        document.addEventListener(eventName, this.boundEventHandler);
      }

      // For cart drawer, also listen to cart:update events to handle cart becoming empty
      if (this.id === 'cart-drawer') {
        this.boundCartUpdateHandler = async (event) => {
          const drawerAlreadyRefreshed = !!event.detail?.drawerAlreadyRefreshed;
          // If drawer is open, scroll to top and handle cart updates
          if (this.isOpen) {
            if (this.drawer && !drawerAlreadyRefreshed) {
              this.drawer.scrollTo({ top: 0, behavior: 'smooth' });
            }
            const source = event.detail?.source;
            const cart = event.detail?.cart;
            const itemCount = cart?.item_count ?? 0;
            const isRemove = source === 'cart-delete';
            const isEmpty = itemCount === 0;
            const shouldRefetch = cart && (isEmpty || isRemove);
            if (shouldRefetch && !drawerAlreadyRefreshed && !this.cartDrawerRefetching) {
              this.cartDrawerRefetching = true;
              this.#setCartDrawerLoading(true);
              this.#refetchCartSection()
                .finally(() => {
                  this.cartDrawerRefetching = false;
                  this.#setCartDrawerLoading(false);
                });
            }
          }
        };
        
        document.addEventListener('cart:update', this.boundCartUpdateHandler);
      }

      // Listen for search events to close drawer
      if (!this.boundSearchOpenedHandler) {
        this.boundSearchOpenedHandler = this.#handleSearchOpened.bind(this);
        document.addEventListener('search:opened', this.boundSearchOpenedHandler);
      }
    }

    /**
     * Disconnect the component and clean up resources
     * @private
     */
    disconnectedCallback() {
      // Remove resize listener
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
      }

      // Clear any timeouts
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      if (this.id === 'cart-drawer' && this.cartAddingTimeoutId) {
        clearTimeout(this.cartAddingTimeoutId);
        this.cartAddingTimeoutId = null;
      }

      // Remove the data-load-on-event listener if it was added
      if (this.dataset.loadOnEvent && this.boundEventHandler) {
        document.removeEventListener(this.dataset.loadOnEvent, this.boundEventHandler);
      }

      // Remove cart:update listener for cart drawer
      if (this.id === 'cart-drawer' && this.boundCartUpdateHandler) {
        document.removeEventListener('cart:update', this.boundCartUpdateHandler);
      }

      // Remove cart:adding listener for cart drawer
      if (this.id === 'cart-drawer' && this.boundCartAddingHandler) {
        document.removeEventListener('cart:adding', this.boundCartAddingHandler);
      }

      // Remove search event listener
      if (this.boundSearchOpenedHandler) {
        document.removeEventListener('search:opened', this.boundSearchOpenedHandler);
      }

      // Clean up
      this.cleanup();
    }

    /**
     * Bind all event listeners for the drawer component
     * @private
     */
    bindEvents() {
      // Add overlay click listener
      if (this.overlay) {
        this.overlay.addEventListener("click", () => this.closeDrawer());
      }

      // Add event listeners for keyup and focusout
      document.addEventListener("keyup", this.onKeyUp.bind(this));
      
      // Add resize listener to handle position changes
      this.resizeHandler = this.#handleResize.bind(this);
      window.addEventListener('resize', this.resizeHandler);
    }

    /**
     * Handle resize events to update position-based animations
     * @private
     */
    #handleResize() {
      // Debounce resize events
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      
      this.resizeTimeout = setTimeout(() => {
        if (this.isOpen) {
          // Update transform if drawer is open
          const currentPosition = this.#getCurrentPosition();
          this.drawer.style.transform = this.#getOpenTransform(currentPosition);
        }
      }, 100);
    }

    /** Spinner SVG matching ATC buttons (a--icon spinner). */
    static #CART_DRAWER_SPINNER = '<svg class="w-8 h-8 animate-spin text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" opacity="0.25"/><path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" fill="currentColor" opacity="0.75"/></svg>';

    /**
     * Set or clear cart drawer loading state (opacity 30% + floating spinner) for cart-drawer only.
     * @param {boolean} loading - True to show loading state, false to clear
     * @private
     */
    #setCartDrawerLoading(loading) {
      if (this.id !== 'cart-drawer' || !this.drawer) return;
      if (loading) {
        this.drawer.setAttribute('data-cart-drawer-loading', '');
        this.drawer.style.opacity = '0.3'; // override animation fill so loading state is visible
        if (!this.drawer.querySelector('[data-cart-drawer-spinner]')) {
          const overlay = document.createElement('div');
          overlay.setAttribute('data-cart-drawer-spinner', '');
          overlay.className = 'absolute top-0 left-0 p-3 flex items-center justify-center pointer-events-none z-10';
          overlay.innerHTML = DrawerElement.#CART_DRAWER_SPINNER;
          this.drawer.appendChild(overlay);
        }
      } else {
        this.drawer.removeAttribute('data-cart-drawer-loading');
        this.drawer.style.opacity = ''; // restore so animation/CSS can control opacity
        const overlay = this.drawer.querySelector('[data-cart-drawer-spinner]');
        if (overlay) overlay.remove();
      }
    }

    /**
     * Refetch the cart section to update drawer content
     * @returns {Promise<void>}
     * @private
     */
    async #refetchCartSection() {
      try {
        // Fetch the cart drawer section with fresh cart data
        const url = `${window.location.pathname}?section_id=cart--drawer`;
        
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to fetch cart section: ${response.status}`);
        }
        
        const html = await response.text();
        
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Get the drawer element from the fetched HTML
        const newDrawerElement = doc.querySelector('drawer-element[id="cart-drawer"] drawer');
        const currentDrawerElement = this.querySelector('drawer');
        
        if (newDrawerElement && currentDrawerElement) {
          // Replace the drawer content with fresh cart data (loading cleared in caller's finally)
          currentDrawerElement.innerHTML = newDrawerElement.innerHTML;
          // Re-init upsell tabs after content replace (script may already be loaded from openDrawer)
          requestAnimationFrame(() => {
            this.querySelectorAll?.("electric-cart-upsell-tabs").forEach((el) => {
              if (typeof el.init === "function") el.init();
            });
          });
        }
      } catch (error) {
        // refetchCartSection failed - caller may handle
      }
    }

    /**
     * Get the current position based on viewport size
     * @returns {string} Current position for the current viewport
     * @private
     */
    #getCurrentPosition() {
      return window.innerWidth >= 768 ? this.positionDesktop : this.positionMobile;
    }

    /**
     * Get initial transform based on position
     * @param {string} position - The position of the drawer
     * @returns {string} CSS transform value
     * @private
     */
    #getInitialTransform(position) {
      const isMobile = window.innerWidth < 768;
      const actualPosition = isMobile ? this.positionMobile : this.positionDesktop;
      
      switch (actualPosition) {
        case 'left':
          return 'translateX(calc(-100% - 1rem))';
        case 'right':
          return 'translateX(calc(100% + 1rem))';
        case 'bottom-auto':
        case 'bottom-to-top':
        case 'bottom-to-almost-top':
          return 'translateY(3rem) opacity(0)';
        case 'top-to-bottom':
          return 'translateY(-3rem)';
        default:
          return 'translateX(calc(100% + 1rem))';
      }
    }

    /**
     * Get open transform based on position
     * @param {string} position - The position of the drawer
     * @returns {string} CSS transform value
     * @private
     */
    #getOpenTransform(position) {
      const isMobile = window.innerWidth < 768;
      const actualPosition = isMobile ? this.positionMobile : this.positionDesktop;
      
      switch (actualPosition) {
        case 'left':
        case 'right':
        case 'top-to-bottom':
          return 'translate(0, 0)';
        case 'bottom-auto':
        case 'bottom-to-top':
        case 'bottom-to-almost-top':
          return 'translateY(0) opacity(1)';
        default:
          return 'translate(0, 0)';
      }
    }

    /**
     * Get animation keyframes based on position and state
     * @param {string} position - The position of the drawer
     * @param {boolean} isOpening - Whether the drawer is opening
     * @returns {Array} Array of keyframe objects
     * @private
     */
    #getAnimationKeyframes(position, isOpening) {
      const isMobile = window.innerWidth < 768;
      const actualPosition = isMobile ? this.positionMobile : this.positionDesktop;
      
      if (isOpening) {
        // Opening animation
        switch (actualPosition) {
          case 'left':
            return [
              { transform: 'translateX(calc(-100% - 1rem))', opacity: 1 },
              { transform: 'translateX(0)', opacity: 1 }
            ];
          case 'right':
            return [
              { transform: 'translateX(calc(100% + 1rem))', opacity: isMobile ? 1 : 0 },
              { transform: 'translateX(0)', opacity: 1 }
            ];
          case 'bottom-auto':
          case 'bottom-to-top':
          case 'bottom-to-almost-top':
            return [
              { transform: 'translateY(3rem)', opacity: 0 },
              { transform: 'translateY(0)', opacity: 1 }
            ];
          case 'top-to-bottom':
            return [
              { transform: 'translateY(-3rem)', opacity: 1 },
              { transform: 'translateY(0)', opacity: 1 }
            ];
          default:
            return [
              { transform: 'translateX(calc(100% + 1rem))', opacity: isMobile ? 1 : 0 },
              { transform: 'translateX(0)', opacity: 1 }
            ];
        }
      } else {
        // Closing animation
        switch (actualPosition) {
          case 'left':
            return [
              { transform: 'translateX(0)', opacity: 1 },
              { transform: 'translateX(calc(-100% - 1rem))', opacity: 1 }
            ];
          case 'right':
            return [
              { transform: 'translateX(0)', opacity: 1 },
              { transform: 'translateX(calc(100% + 1rem))', opacity: isMobile ? 1 : 0 }
            ];
          case 'bottom-auto':
          case 'bottom-to-top':
          case 'bottom-to-almost-top':
            return [
              { transform: 'translateY(0)', opacity: 1 },
              { transform: 'translateY(3rem)', opacity: 0 }
            ];
          case 'top-to-bottom':
            return [
              { transform: 'translateY(0)', opacity: 1 },
              { transform: 'translateY(-3rem)', opacity: 1 }
            ];
          default:
            return [
              { transform: 'translateX(0)', opacity: 1 },
              { transform: 'translateX(calc(100% + 1rem))', opacity: isMobile ? 1 : 0 }
            ];
        }
      }
    }

    /**
     * Prepare drawer for animation by setting initial state
     * @param {HTMLElement} drawer - The drawer element
     * @param {string} position - The position of the drawer
     * @private
     */
    prepareDrawerForAnimation(drawer, position) {
      drawer.style.visibility = "visible";
      drawer.style.transform = this.#getInitialTransform(position);
    }

    /**
     * Clean up drawer after animation
     * @param {HTMLElement} drawer - The drawer element
     * @param {string} position - The position of the drawer
     * @private
     */
    cleanupDrawerAfterAnimation(drawer, position) {
      if (!this.isOpen) {
        drawer.style.visibility = "hidden";
        drawer.style.transform = this.#getInitialTransform(position);
        // unlockScrollForThis(this)
      }
    }

    /**
     * Get animation options with proper duration and easing
     * @returns {Object} Animation options
     * @private
     */
    getAnimationOptions() {
      return {
        duration: this.animationDuration,
        easing: window.animation.cubicBezier,
        fill: "forwards",
      };
    }

    /**
     * Animation for opening the drawer
     * @returns {Promise} Promise that resolves when animation completes
     * @private
     */
    async openDrawerAnimation() {
      // lockScrollForThis(this)
      const { drawer, overlay } = this;
      const options = this.getAnimationOptions();
      const currentPosition = this.#getCurrentPosition();

      this.prepareDrawerForAnimation(drawer, currentPosition);

      const drawerAnimation = drawer.animate(
        this.#getAnimationKeyframes(currentPosition, true),
        options,
      );

      const overlayAnimation = overlay?.animate(
        [{ opacity: 0 }, { opacity: 0.7 }],
        options,
      );

      await Promise.all([
        drawerAnimation.finished,
        overlayAnimation?.finished,
      ]);

      drawer.style.transform = this.#getOpenTransform(currentPosition);

    }

    /**
     * Animation for closing the drawer
     * @returns {Promise} Promise that resolves when animation completes
     * @private
     */
    async closeDrawerAnimation() {
      const { drawer, overlay } = this;
      const options = this.getAnimationOptions();
      const currentPosition = this.#getCurrentPosition();

      const drawerAnimation = drawer.animate(
        this.#getAnimationKeyframes(currentPosition, false),
        options,
      );

      const overlayAnimation = overlay?.animate(
        [{ opacity: 0.7 }, { opacity: 0 }],
        options,
      );

      await Promise.all([
        drawerAnimation.finished,
        overlayAnimation?.finished,
      ]);

      this.cleanupDrawerAfterAnimation(drawer, currentPosition);
    }

    /**
     * Open the drawer with proper animation
     * @returns {Promise} Promise that resolves when drawer is fully open
     * @private
     */
    async openDrawer() {
      try {
        // Cart drawer: load cart UI bundle before opening so quantity-input, cart-delete, electric-cart-upsell-tabs are defined
        if (this.id === "cart-drawer") {
          try {
            await loadCartScriptOnce();
            if (typeof customElements !== "undefined" && customElements.upgrade) {
              customElements.upgrade(this);
              this.querySelectorAll?.("electric-cart-upsell-tabs").forEach((el) => {
                customElements.upgrade(el);
              });
            }
            this.querySelectorAll?.("electric-cart-upsell-tabs").forEach((el) => {
              if (typeof el.init === "function") el.init();
            });
          } catch (err) {
            // Cart script failed to load
          }
        }

        this.isOpen = true;
        this.keepHeader = true;

        // Use LayerManager to handle z-index with parent tracking
        if (window.layerManager) {
          const drawerId = this.id || `drawer-${Date.now()}`;
          const parentContext = window.layerManager.getCurrentContext();
          window.layerManager.push(drawerId, 'drawer', this, parentContext);
          this.dataset.layerId = drawerId;

          // Mark as animating
          window.layerManager.startAnimating(drawerId);
        }

        // Pin header before scroll-lock so the hamburger stays reachable
        const headerElement = document.querySelector('header-element');
        if (headerElement) {
          if (typeof headerElement.pinForDrawer === 'function') {
            headerElement.pinForDrawer();
          }
          if (typeof headerElement.updateHeaderStickyOffset === 'function') {
            headerElement.updateHeaderStickyOffset();
          }
        }

        // Show the drawer container
        this.style.display = 'block';
        this.classList.remove('hidden');

        // Handle nested drawer height constraints
        this.#constrainNestedDrawerHeight();

        // Lock scroll for this drawer
        if (typeof lockScrollForThis === 'function') {
          lockScrollForThis(this);
        }

        this.storeHeaderState();
        this.addBodyClass();
        this.dispatchEvent(new CustomEvent('drawer:opening', {
          bubbles: true,
          detail: { drawer: this }
        }));
        await this.openDrawerAnimation();

        // Animation complete
        if (window.layerManager && this.dataset.layerId) {
          window.layerManager.stopAnimating(this.dataset.layerId);
        }

        this.focusFirstFocusableElement();

        // Dispatch opened event
        this.dispatchEvent(new CustomEvent('drawer:opened', {
          bubbles: true,
          detail: { drawer: this }
        }));

        // Cart drawer: init upsell tabs after fully open (works for both trigger click and cart:added open)
        if (this.id === "cart-drawer") {
          requestAnimationFrame(() => {
            this.querySelectorAll?.("electric-cart-upsell-tabs").forEach((el) => {
              if (typeof el.init === "function") el.init();
            });
          });
        }
      } catch (error) {
        this.isOpen = false;
        this.keepHeader = false;
        this.style.display = 'none';
      }
    }

    /**
     * Close all child drawers recursively
     * @returns {Promise} Promise that resolves when all child drawers are closed
     * @private
     */
    async #closeChildDrawers() {
      if (!window.layerManager || !this.dataset.layerId) return;

      const currentLayer = window.layerManager.layers.find(
        l => l.id === this.dataset.layerId
      );

      if (!currentLayer || !currentLayer.children || currentLayer.children.length === 0) {
        return;
      }

      // Close all child drawers in parallel and wait for them to complete
      const closePromises = currentLayer.children.map(childId => {
        const childLayer = window.layerManager.layers.find(l => l.id === childId);
        if (childLayer && childLayer.type === 'drawer' && childLayer.element) {
          const childDrawer = childLayer.element;
          // Check if it's a drawer element and is open
          if (childDrawer.isOpen && typeof childDrawer.closeDrawer === 'function') {
            return childDrawer.closeDrawer();
          }
        }
        return Promise.resolve();
      });

      await Promise.all(closePromises);
    }

    /**
     * Close the drawer with proper animation
     * @returns {Promise} Promise that resolves when drawer is fully closed
     * @private
     */
    async closeDrawer() {
      try {
        // Close all child drawers first and wait for them to complete
        await this.#closeChildDrawers();

        this.isOpen = false;
        this.keepHeader = false;

        // Mark as animating before removal
        if (window.layerManager && this.dataset.layerId) {
          window.layerManager.startAnimating(this.dataset.layerId);
        }

        this.removeBodyClass();
        this.dispatchEvent(new CustomEvent('drawer:closing', {
          bubbles: true,
          detail: { drawer: this }
        }));
        await this.closeDrawerAnimation();
        
        // Hide the drawer container first to prevent flash
        this.style.display = 'none';
        
        // Unlock scroll for this drawer
        if (typeof unlockScrollForThis === 'function') {
          unlockScrollForThis(this);
        }
        
        // Restore header state after drawer is hidden and scroll is unlocked
        this.restoreHeaderState();
        this.focusLastFocusedElement();

        // Reset height constraints when closing
        this.#resetHeightConstraints();

        // Animation complete - now remove from LayerManager
        if (window.layerManager && this.dataset.layerId) {
          window.layerManager.stopAnimating(this.dataset.layerId);
          window.layerManager.remove(this.dataset.layerId);
          delete this.dataset.layerId;
        }

        // Dispatch closed event
        this.dispatchEvent(new CustomEvent('drawer:closed', {
          bubbles: true,
          detail: { drawer: this }
        }));
      } catch (error) {
        this.isOpen = true;
        this.keepHeader = true;
      }
    }

    /**
     * Toggle the drawer state
     * @param {HTMLElement} trigger - The element that triggered the toggle
     * @private
     */
    toggleDrawer(trigger) {
      if (this.isOpen) {
        this.closeDrawer();
      } else {
        this.openDrawer();
      }
    }

    /**
     * Store the current header state
     * @private
     */
    storeHeaderState() {
      const header = document.querySelector("header");
      if (header) {
        this.dataset.originalStickyState = header.dataset.sticky;
        // header.dataset.sticky = "false";
      }
    }

    /**
     * Restore the original header state
     * @private
     */
    restoreHeaderState() {
      const header = document.querySelector("header");
      if (header && this.dataset.originalStickyState !== undefined) {
        header.dataset.sticky = this.dataset.originalStickyState;
      }
    }

    /**
     * Add body class for drawer open state
     * @private
     */
    addBodyClass() {
      document.body.classList.add("drawer-open", "overflow-hidden");
    }

    /**
     * Remove body class for drawer open state
     * @private
     */
    removeBodyClass() {
      document.body.classList.remove("drawer-open", "overflow-hidden");
    }

    /**
     * Focus the first focusable element in the drawer
     * @private
     */
    focusFirstFocusableElement() {
      const focusableElements = this.drawer.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }
    }

    /**
     * Focus the last focused element before drawer opened
     * @private
     */
    focusLastFocusedElement() {
      // This would need to be implemented based on your focus management strategy
      // For now, we'll just focus the body
      document.body.focus();
    }

    /**
     * Handle key events for accessibility
     * @param {KeyboardEvent} event - The key event
     * @private
     */
    onKeyUp(event) {
      if (event.key === "Escape" && this.isOpen) {
        this.closeDrawer();
      }
    }

    /**
     * Cleanup method to reset stored states and prevent memory leaks
     * @private
     */
    cleanup() {
      delete this.dataset.originalStickyState;
      
      // Clear resize timeout
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    // Static utility methods for component querying and validation
    static isValidDrawer(element) {
      return element && element.tagName === 'DRAWER-ELEMENT';
    }

    static getDrawerPosition(element) {
      if (!this.isValidDrawer(element)) {
        return null;
      }
      
      return {
        mobile: element.dataset.positionMobile || 'right',
        desktop: element.dataset.positionDesktop || 'right'
      };
    }

    /**
     * Handle search opened event by closing the drawer
     * @param {CustomEvent} event - The search opened event
     * @private
     */
    #handleSearchOpened(event) {
      // Close drawer if it's currently open
      if (this.isOpen) {
        this.closeDrawer();
      }
    }

    /**
     * Constrain nested drawer height to prevent parent drawer bleed-through
     * @private
     */
    #constrainNestedDrawerHeight() {
      // Check if this drawer is nested within another drawer
      const parentDrawer = this.closest('drawer-element');
      
      if (parentDrawer && parentDrawer !== this) {
        // This is a nested drawer - constrain the parent drawer's height
        const parentDrawerElement = parentDrawer.querySelector('drawer');
        if (parentDrawerElement) {
          // Get the current viewport height
          const viewportHeight = window.innerHeight;
          
          // Calculate available height (viewport minus any header offset)
          const headerElement = document.querySelector('header');
          const headerHeight = headerElement ? headerElement.offsetHeight : 0;
          const availableHeight = viewportHeight - headerHeight;
          
          // Apply height constraint to the parent drawer element
          parentDrawerElement.style.maxHeight = `${availableHeight}px`;
          parentDrawerElement.style.height = `${availableHeight}px`;
          
          // Also constrain the parent drawer container
          parentDrawer.style.maxHeight = `${availableHeight}px`;
          parentDrawer.style.height = `${availableHeight}px`;
          
          // Add a class for CSS targeting
          parentDrawer.classList.add('parent-drawer-constrained');
          this.classList.add('nested-drawer-active');
        }
      } else {
        // This is a top-level drawer - ensure no height constraints
        this.drawer.style.maxHeight = '';
        this.drawer.style.height = '';
        this.style.height = '';
        this.style.maxHeight = '';
        this.classList.remove('nested-drawer-constrained');
      }
    }

    /**
     * Reset height constraints for this drawer
     * @private
     */
    #resetHeightConstraints() {
      // Check if this drawer is nested within another drawer
      const parentDrawer = this.closest('drawer-element');
      
      if (parentDrawer && parentDrawer !== this) {
        // Reset constraints on the parent drawer
        const parentDrawerElement = parentDrawer.querySelector('drawer');
        if (parentDrawerElement) {
          parentDrawerElement.style.maxHeight = '';
          parentDrawerElement.style.height = '';
          parentDrawer.style.maxHeight = '';
          parentDrawer.style.height = '';
          parentDrawer.classList.remove('parent-drawer-constrained');
        }
      }
      
      // Reset constraints on this drawer
      this.drawer.style.maxHeight = '';
      this.drawer.style.height = '';
      this.style.height = '';
      this.style.maxHeight = '';
      this.classList.remove('nested-drawer-constrained', 'nested-drawer-active');
    }
  }
);
}

/**
 * AccordionDisclosure - A web component for collapsible accordion sections with sync group support
 * 
 * This component extends the native HTML details element to provide enhanced accordion functionality
 * with smooth animations, keyboard navigation, and sync group support. Can be synchronized with
 * other disclosure elements using the data-sync-group attribute.
 * 
 * @example
 * <details is="accordion-disclosure" data-sync-group="my-group">
 *   <summary>Accordion Title</summary>
 *   <div>Accordion content...</div>
 * </details>
 */


// ElectricTab component - handles tab switching with proper ARIA support
class ElectricTab extends HTMLElement {
  #abortController; // Declare private field
  #isInitialized = false;
  
  constructor() {
    super();
    this.activeTabClass = 'text-primary';
    this.inactiveTabClass = 'text-primary/50';
    this.hiddenContentClass = 'hidden';
    this.#abortController = new AbortController();
    this.collectionId = null;
    this.collectionHandle = null;
  }

  connectedCallback() {
    this.tabButtons = this.querySelectorAll('[data-tab-button]');
    this.tabContents = this.querySelectorAll('[data-tab-content]');
    
    this.tabButtons.forEach(button => {
      button.addEventListener('click', this.#handleTabClick.bind(this), {
        signal: this.#abortController.signal
      });
      button.addEventListener('keydown', this.#handleKeyDown.bind(this), {
        signal: this.#abortController.signal
      });
    });

    // Activate first tab by default without focusing to prevent auto-scroll
    this.#activateTab(0, false);
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  #handleTabClick(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const tabIndex = parseInt(button.dataset.tabIndex, 10);
    this.#activateTab(tabIndex);
  }

  #handleKeyDown(event) {
    const currentIndex = parseInt(event.currentTarget.dataset.tabIndex, 10);
    
    switch (event.key) {
      case 'ArrowLeft':
        event.preventDefault();
        this.#activateTab(Math.max(0, currentIndex - 1), true);
        break;
      case 'ArrowRight':
        event.preventDefault();
        this.#activateTab(Math.min(this.tabButtons.length - 1, currentIndex + 1), true);
        break;
      case 'Home':
        event.preventDefault();
        this.#activateTab(0, true);
        break;
      case 'End':
        event.preventDefault();
        this.#activateTab(this.tabButtons.length - 1, true);
        break;
    }
  }

  #activateTab(tabIndex, shouldFocus = false) {
    // Update tab buttons
    this.tabButtons.forEach((btn, index) => {
      const isActive = index === tabIndex;
      btn.classList.toggle(this.activeTabClass, isActive);
      btn.classList.toggle(this.inactiveTabClass, !isActive);
      btn.setAttribute('aria-selected', isActive.toString());
      // Keep all tabs focusable for keyboard navigation - WCAG 2.1 compliance
      btn.setAttribute('tabindex', '0');
    });

    // Update tab contents
    this.tabContents.forEach((content, index) => {
      const isActive = index === tabIndex;
      content.classList.toggle(this.hiddenContentClass, !isActive);
      content.setAttribute('aria-hidden', (!isActive).toString());
      if (isActive) {
        const rebuySimplify = content.querySelector('electric-rebuy-simplify');
        if (rebuySimplify?.runIfNeeded) rebuySimplify.runIfNeeded();
      }
    });

    // Only focus if explicitly requested (e.g., from keyboard navigation)
    if (shouldFocus) {
      this.tabButtons[tabIndex]?.focus();
    }

    // Announce tab change to screen readers
    this.#announceTabChange(tabIndex);

    // Dispatch custom event for the parent component to handle
    this.dispatchEvent(new CustomEvent('tabChanged', {
      bubbles: true,
      detail: { tabIndex }
    }));
  }

  /**
   * Announce tab change to screen readers
   * @param {number} tabIndex - Index of the activated tab
   * @private
   */
  #announceTabChange(tabIndex) {
    const activeTab = this.tabButtons[tabIndex];
    if (!activeTab) return;

    // Create or get the announcer element
    let announcer = this.querySelector('[aria-live]');
    if (!announcer) {
      announcer = document.createElement('div');
      announcer.setAttribute('aria-live', 'polite');
      announcer.setAttribute('aria-atomic', 'true');
      announcer.className = 'sr-only';
      this.appendChild(announcer);
    }

    // Announce the tab change
    const tabText = activeTab.textContent?.trim() || `Tab ${tabIndex + 1}`;
    announcer.textContent = `Switched to ${tabText} tab`;
  }
}

// Register the custom elements
if (!customElements.get('electric-tab')) {
  customElements.define('electric-tab', ElectricTab);
}

/**
 * ElectricLightbox - Simple full-screen lightbox for images and videos
 * @class
 * @extends HTMLElement
 * @description Creates a singleton lightbox that opens when elements with class 'lightbox' are clicked.
 * Displays content in center with thumbnails at bottom, supports keyboard navigation.
 */
class ElectricLightbox extends HTMLElement {
  constructor() {
    super();
    this.container = null;
    this.mainContent = null;
    this.thumbnailStrip = null;
    this.prevButton = null;
    this.nextButton = null;
    this.closeButton = null;
    this.previousFocus = null;
    this.isOpen = false;
    this.currentIndex = 0;
    this.items = [];
    this.boundClickHandler = null;
    this.boundKeyHandler = null;
  }

  connectedCallback() {
    // Only create one instance globally
    if (!window.electricLightbox) {
      window.electricLightbox = this;
      this.#init();
    }
  }

  disconnectedCallback() {
    if (window.electricLightbox === this) {
      window.electricLightbox = null;
      this.#cleanup();
    }
  }

  /**
   * Open the lightbox at an index, optionally scoped to a product gallery.
   * Prefer this over programmatic .click() on hidden .lightbox triggers
   * (those nodes use visibility:hidden / pointer-events:none; .click() is also
   * trusted and was previously ignored by the gallery items guard).
   *
   * @param {number} index - Zero-based media index
   * @param {HTMLElement} [scopeEl] - Gallery root ([data-product-gallery]) or any descendant
   * @returns {boolean} Whether the lightbox opened
   */
  openAt(index, scopeEl) {
    try {
      if (!this.container) return false;
      if (!Number.isFinite(index) || index < 0) return false;

      const gallery =
        scopeEl?.closest?.('[data-product-gallery], .product-gallery') ||
        (scopeEl?.matches?.('[data-product-gallery], .product-gallery') ? scopeEl : null);

      this.items = [];
      const container = gallery
        ? gallery.querySelector('.product-gallery__lightbox-items')
        : null;
      const lightboxElements = container
        ? container.querySelectorAll('.lightbox')
        : document.querySelectorAll('.lightbox');

      lightboxElements.forEach((element) => {
        const item = this.#extractMediaInfo(element);
        if (item) {
          item.element = element;
          this.items.push(item);
        }
      });

      if (!this.items.length || index >= this.items.length) {
        return false;
      }

      this.#open(index);
      return this.isOpen;
    } catch {
      return false;
    }
  }

  /**
   * Initialize the lightbox component
   * @private
   */
  #init() {
    this.#createContainer();
    this.#setupTriggers();
    this.#setupKeyboardListeners();
  }

  /**
   * Create the lightbox container HTML structure
   * @private
   */
  #createContainer() {
    const lightboxHTML = `
      <style>
        #electric-lightbox-container button[data-active="true"]::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 0;
          right: 0;
          height: 2px;
          background-color: rgb(17, 24, 39); /* gray-900 */
          pointer-events: none;
        }
      </style>
      <div
        id="electric-lightbox-container"
        class="fixed inset-0 hidden bg-white z-[300] flex flex-col"
        role="dialog"
        aria-modal="true"
        aria-label="Lightbox"
      >
        <!-- Close button -->
        <button
          id="electric-lightbox-close"
          type="button"
          class="absolute top-4 right-4 z-30 text-primary hover:opacity-75 p-2 cursor-pointer touch-manipulation"
          aria-label="${window.theme?.translations?.close_lightbox || 'Close lightbox'}"
        >
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>

        <!-- Navigation arrows -->
        <button
          id="electric-lightbox-prev"
          type="button"
          class="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 text-primary hover:opacity-75 p-2 z-20 cursor-pointer touch-manipulation"
          aria-label="${window.theme?.translations?.previous_image || 'Previous image'}"
        >
          <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
        </button>
        <button
          id="electric-lightbox-next"
          type="button"
          class="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 text-primary hover:opacity-75 p-2 z-20 cursor-pointer touch-manipulation"
          aria-label="${window.theme?.translations?.next_image || 'Next image'}"
        >
          <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
          </svg>
        </button>

        <!-- Main content: flex-1 so it never overlaps the thumbnail strip -->
        <div
          id="electric-lightbox-main"
          class="relative z-10 flex flex-1 min-h-0 items-center justify-center px-4 pt-14 pb-4"
        >
          <!-- Content will be inserted here -->
        </div>

        <!-- Thumbnail strip: in-flow footer so taps always hit the buttons -->
        <div
          id="electric-lightbox-thumbnails"
          class="relative z-30 shrink-0 w-full pb-4 md:pb-8 px-4 overflow-x-auto overscroll-x-contain touch-pan-x"
        >
          <div class="flex gap-2 justify-center min-w-min mx-auto">
            <!-- Thumbnails will be inserted here -->
          </div>
        </div>
      </div>
    `;

    // Add to body
    document.body.insertAdjacentHTML('beforeend', lightboxHTML);

    // Cache elements
    this.container = document.getElementById('electric-lightbox-container');
    this.mainContent = document.getElementById('electric-lightbox-main');
    this.thumbnailStrip = this.container.querySelector('#electric-lightbox-thumbnails > div');
    this.prevButton = document.getElementById('electric-lightbox-prev');
    this.nextButton = document.getElementById('electric-lightbox-next');
    this.closeButton = document.getElementById('electric-lightbox-close');

    // Setup button handlers
    this.closeButton.addEventListener('click', () => this.#close());
    this.prevButton.addEventListener('click', () => this.#navigate('prev'));
    this.nextButton.addEventListener('click', () => this.#navigate('next'));
  }

  /**
   * Setup event delegation for lightbox triggers
   * @private
   */
  #setupTriggers() {
    this.boundClickHandler = (e) => {
      const target = e.target;
      // Desktop main slot opens via electric-product-gallery → openAt(); ignore
      // direct trusted clicks on the slot so empty padding never opens the lightbox.
      const inSlot = !!target.closest && target.closest('[data-product-gallery-slot]');
      if (e.isTrusted && inSlot) return;

      // Try multiple strategies to find the lightbox element
      let trigger = target.closest('.lightbox');
      
      // If closest didn't work, check if target itself has the class
      if (!trigger && target.classList.contains('lightbox')) {
        trigger = target;
      }
      
      // If still not found, check parent
      if (!trigger && target.parentElement?.classList.contains('lightbox')) {
        trigger = target.parentElement;
      }
      
      // If still not found, check if target contains a child with the class (e.g., picture > img.lightbox)
      if (!trigger) {
        const childLightbox = target.querySelector('.lightbox');
        if (childLightbox) {
          trigger = childLightbox;
        }
      }
      
      // If still not found, check if we're inside a container with the class by going up the tree
      if (!trigger) {
        let current = target;
        for (let i = 0; i < 5 && current; i++) {
          if (current.classList.contains('lightbox')) {
            trigger = current;
            break;
          }
          current = current.parentElement;
        }
      }
      
      if (!trigger) return;

      // Only open if the user actually clicked ON the trigger or inside it (not on an ancestor that contains .lightbox).
      const clickedOnTrigger = trigger === target || trigger.contains(target);
      if (!clickedOnTrigger) return;

      e.preventDefault();
      e.stopPropagation();

      // Collect lightbox items scoped to trigger's gallery to avoid duplicates
      // (tablet slider and lightbox-items both had .lightbox, causing 2x items)
      this.#collectLightboxItems(trigger);

      const clickedIndex = this.items.findIndex(item => item.element === trigger);
      if (clickedIndex !== -1) {
        this.#open(clickedIndex);
      }
    };

    document.addEventListener('click', this.boundClickHandler, true);
  }

  /**
   * Setup keyboard listeners
   * @private
   */
  #setupKeyboardListeners() {
    this.boundKeyHandler = (e) => {
      if (!this.isOpen) return;

      switch (e.key) {
        case 'Escape':
          this.#close();
          break;
        case 'ArrowRight':
          e.preventDefault();
          this.#navigate('next');
          break;
        case 'ArrowLeft':
          e.preventDefault();
          this.#navigate('prev');
          break;
      }
    };

    document.addEventListener('keydown', this.boundKeyHandler);
  }

  /**
   * Collect lightbox items, scoped to product gallery when applicable to avoid duplicates.
   * Product galleries have both tablet slider and hidden lightbox-items with .lightbox;
   * we only use the canonical lightbox-items container.
   * @param {HTMLElement} [trigger] - The clicked lightbox trigger (used for scoping)
   * @private
   */
  #collectLightboxItems(trigger) {
    this.items = [];
    let container = null;
    const gallery = trigger?.closest?.('.product-gallery');
    if (gallery) {
      container = gallery.querySelector('.product-gallery__lightbox-items');
    }
    const lightboxElements = container
      ? container.querySelectorAll('.lightbox')
      : document.querySelectorAll('.lightbox');

    lightboxElements.forEach((element) => {
      const item = this.#extractMediaInfo(element);
      if (item) {
        item.element = element;
        this.items.push(item);
      }
    });
  }

  /**
   * Extract media information from an element
   * @param {HTMLElement} element - The element to extract info from
   * @returns {Object|null} Media info object or null
   * @private
   */
  #extractMediaInfo(element) {
    // Helper to get high-res image URL
    const getHighResImage = (img) => {
      // pdp-media-window stashes sources while unloaded
      const stashedSrcset = img.getAttribute('data-pdp-srcset');
      if (stashedSrcset) {
        const sources = stashedSrcset.split(',').map((s) => s.trim());
        const largest = sources[sources.length - 1];
        if (largest) {
          const url = largest.split(' ')[0];
          if (url) return url;
        }
      }
      const stashedSrc = img.getAttribute('data-pdp-src');
      if (stashedSrc && !stashedSrc.startsWith('data:')) return stashedSrc;

      // Try srcset first (usually has high-res versions)
      const srcset = img.getAttribute('srcset');
      if (srcset) {
        // Extract the largest size from srcset (staging parity at open)
        const sources = srcset.split(',').map(s => s.trim());
        const largest = sources[sources.length - 1];
        if (largest) {
          const url = largest.split(' ')[0];
          if (url) return url;
        }
      }
      
      // Try data-src (lazy loaded high-res)
      const dataSrc = img.getAttribute('data-src');
      if (dataSrc) return dataSrc;
      
      // Try currentSrc (browser-selected from srcset)
      if (img.currentSrc && img.currentSrc !== img.src) return img.currentSrc;
      
      // Try to get high-res version by removing size constraints from Shopify URLs
      const src = img.src || img.getAttribute('src');
      if (src && !src.startsWith('data:')) {
        // Shopify image URLs often have size parameters like _800x800, remove them for full size
        const highResSrc = src.replace(/_[0-9]+x[0-9]+(?:\.[a-z]+)?(\?|$)/i, '$1');
        return highResSrc;
      }
      
      return src;
    };

    // PRIORITY 1: Check if element itself is a video-player (must check first to avoid matching poster images)
    if (element.tagName === 'VIDEO-PLAYER') {
      return {
        type: 'video',
        videoPlayerElement: element,
        alt: element.getAttribute('aria-label') || ''
      };
    }

    // PRIORITY 2: Check if element contains a video-player (before checking for images)
    const videoPlayer = element.closest('video-player') || element.querySelector('video-player');
    if (videoPlayer) {
      // Store reference to the original video-player element for cloning
      return {
        type: 'video',
        videoPlayerElement: videoPlayer,
        alt: videoPlayer.getAttribute('aria-label') || ''
      };
    }

    // PRIORITY 3: Check if element is an img (but not inside a video-player)
    if (element.tagName === 'IMG') {
      // Make sure this img is not inside a video-player
      if (!element.closest('video-player')) {
        const highResSrc = getHighResImage(element);
        return {
          type: 'image',
          src: highResSrc || element.src || element.getAttribute('src'),
          // Prefer stashed/high-res URL — img.src may be the pdp-media-window placeholder
          thumbnail: highResSrc || element.src || element.getAttribute('src'),
          alt: element.alt || '',
          naturalWidth: element.naturalWidth,
          naturalHeight: element.naturalHeight
        };
      }
    }

    // PRIORITY 4: Check if element is a video
    if (element.tagName === 'VIDEO') {
      return {
        type: 'video',
        src: element.src || element.getAttribute('src'),
        thumbnail: element.poster || element.getAttribute('poster') || '',
        alt: element.getAttribute('aria-label') || '',
        videoElement: element
      };
    }

    // PRIORITY 5: Check if element contains an img (but not inside a video-player)
    const img = element.querySelector('img');
    if (img && !img.closest('video-player')) {
      const highResSrc = getHighResImage(img);
      return {
        type: 'image',
        src: highResSrc || img.src || img.getAttribute('src'),
        // Prefer stashed/high-res URL — img.src may be the pdp-media-window placeholder
        thumbnail: highResSrc || img.src || img.getAttribute('src'),
        alt: img.alt || '',
        naturalWidth: img.naturalWidth,
        naturalHeight: img.naturalHeight
      };
    }

    // Check if element contains a video
    const video = element.querySelector('video');
    if (video) {
      return {
        type: 'video',
        src: video.src || video.getAttribute('src'),
        thumbnail: video.poster || video.getAttribute('poster') || '',
        alt: video.getAttribute('aria-label') || '',
        videoElement: video
      };
    }

    // Check if element has href (linked image)
    const href = element.getAttribute('href');
    if (href) {
      // Check if href points to an image
      if (/\.(jpg|jpeg|png|gif|webp|svg|avif)$/i.test(href)) {
        return {
          type: 'image',
          src: href,
          thumbnail: href,
          alt: element.getAttribute('aria-label') || element.textContent.trim() || ''
        };
      }
    }

    // Check if element has data-src or data-href
    const dataSrc = element.getAttribute('data-src') || element.getAttribute('data-href');
    if (dataSrc) {
      const isVideo = /\.(mp4|webm|ogg)$/i.test(dataSrc);
      return {
        type: isVideo ? 'video' : 'image',
        src: dataSrc,
        thumbnail: element.getAttribute('data-thumbnail') || dataSrc,
        alt: element.getAttribute('aria-label') || element.getAttribute('alt') || ''
      };
    }

    return null;
  }

  /**
   * Open the lightbox at a specific index
   * @param {number} index - Index of the item to display
   * @private
   */
  #open(index) {
    if (this.items.length === 0) return;

    try {
      // Store current focus
      this.previousFocus = document.activeElement;

      // Use LayerManager for z-index management
      const layerId = 'lightbox';
      if (window.layerManager) {
        const parentContext = window.layerManager.getCurrentContext();
        window.layerManager.push(layerId, 'modal', this.container, parentContext);
        this.container.dataset.layerId = layerId;
      }

      // Set current index
      this.currentIndex = index;

      // Show container
      this.container.classList.remove('hidden');
      this.isOpen = true;

      // Hide sticky ATC (z-index sits above lightbox thumbnails on mobile)
      document.body.classList.add('lightbox-open');

      // Lock body scroll
      if (typeof lockScrollForThis === 'function') {
        lockScrollForThis(this.container);
      } else {
        document.body.style.overflow = 'hidden';
      }

      // Update content
      this.#updateContent();
      this.#generateThumbnails();

      // Focus the close button
      this.closeButton.focus();

      // Dispatch event
      this.#dispatchEvent('lightbox:opened', { index, item: this.items[index] });
    } catch (error) {
      // Lightbox open failed
    }
  }

  /**
   * Close the lightbox
   * @private
   */
  #close() {
    if (!this.isOpen) return;

    try {
      // Hide container
      this.container.classList.add('hidden');
      this.isOpen = false;

      document.body.classList.remove('lightbox-open');

      // Unlock body scroll
      if (typeof unlockScrollForThis === 'function') {
        unlockScrollForThis(this.container);
      } else {
        document.body.style.overflow = '';
      }

      // Remove from LayerManager
      if (window.layerManager && this.container.dataset.layerId) {
        window.layerManager.remove(this.container.dataset.layerId);
        delete this.container.dataset.layerId;
      }

      // Restore focus
      if (this.previousFocus && typeof this.previousFocus.focus === 'function') {
        setTimeout(() => {
          this.previousFocus.focus({ preventScroll: true });
        }, 0);
      }

      // Clear content
      this.mainContent.innerHTML = '';
      this.thumbnailStrip.innerHTML = '';

      // Dispatch event
      this.#dispatchEvent('lightbox:closed', {});
    } catch (error) {
      // Lightbox close failed
    }
  }

  /**
   * Navigate to next or previous item
   * @param {string} direction - 'next' or 'prev'
   * @private
   */
  #navigate(direction) {
    if (this.items.length === 0) return;

    if (direction === 'next') {
      this.currentIndex = (this.currentIndex + 1) % this.items.length;
    } else {
      this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
    }

    this.#updateContent();
    this.#updateThumbnailStates();

    // Dispatch event
    this.#dispatchEvent('lightbox:navigated', {
      index: this.currentIndex,
      direction,
      item: this.items[this.currentIndex]
    });
  }

  /**
   * Update the main content area with current item
   * @private
   */
  #updateContent() {
    if (this.items.length === 0 || this.currentIndex < 0 || this.currentIndex >= this.items.length) {
      return;
    }

    const item = this.items[this.currentIndex];
    this.mainContent.innerHTML = '';

    if (item.type === 'image') {
      const img = document.createElement('img');
      img.src = item.src;
      img.alt = item.alt || 'Lightbox image';
      img.className = 'max-w-full max-h-full object-contain';
      img.loading = 'eager';
      this.mainContent.appendChild(img);
    } else if (item.type === 'video') {
      // Clone the original video-player element
      const originalVideoPlayer = item.videoPlayerElement;
      if (!originalVideoPlayer) {
        return;
      }

      // Stable in-flow sizer so absolute poster/video children never collapse the box
      // (and so the flex parent can keep the media centered).
      const wrap = document.createElement('div');
      wrap.className = 'relative max-w-full max-h-full mx-auto shrink-0';
      wrap.style.cssText =
        'aspect-ratio: 4 / 5; height: 100%; width: auto; max-width: 100%; max-height: 100%;';

      const videoPlayer = originalVideoPlayer.cloneNode(true);
      videoPlayer.id = `lightbox-video-${this.currentIndex}-${Date.now()}`;
      videoPlayer.className = 'absolute inset-0 w-full h-full overflow-hidden bg-minimal';
      videoPlayer.style.cssText = '--aspect-ratio: 0.8; height: 100%; width: 100%;';

      const pinVideoFill = (videoEl) => {
        if (!videoEl) return;
        videoEl.classList.remove('w-full', 'h-auto');
        videoEl.classList.remove('object-cover');
        videoEl.classList.add('absolute', 'inset-0', 'w-full', 'h-full', 'object-contain');
        videoEl.style.position = 'absolute';
        videoEl.style.inset = '0';
        videoEl.style.width = '100%';
        videoEl.style.height = '100%';
        videoEl.style.objectFit = 'contain';
        videoEl.style.aspectRatio = '';
      };

      const revealLightboxVideo = () => {
        const videoEl = videoPlayer.querySelector('video');
        if (!videoEl) return;
        pinVideoFill(videoEl);
        videoEl.classList.remove('opacity-0');
        videoEl.classList.add('opacity-100');
        videoEl.style.opacity = '1';
        videoPlayer.querySelectorAll('[data-gallery-video-poster]').forEach((poster) => {
          poster.remove();
        });
      };

      // Size the injected <video> to the box (avoids top→center jump) but keep
      // gallery opacity-0 + poster until playback actually has frames.
      pinVideoFill(videoPlayer.querySelector('template')?.content?.querySelector('video'));
      const existingVideo = videoPlayer.querySelector('video');
      if (existingVideo) {
        pinVideoFill(existingVideo);
        existingVideo.removeAttribute('autoplay');
        existingVideo.pause?.();
        // Keep poster covering until playing if video is still opacity-0
        if (!existingVideo.classList.contains('opacity-0') && existingVideo.style.opacity !== '0') {
          existingVideo.style.opacity = '1';
        }
      }

      videoPlayer.removeAttribute('data-pause-after');
      if (videoPlayer.dataset.pauseAfter) {
        delete videoPlayer.dataset.pauseAfter;
      }
      videoPlayer.removeAttribute('data-play-on-load');

      wrap.appendChild(videoPlayer);
      this.mainContent.appendChild(wrap);

      const lightboxPlayBadge = videoPlayer.querySelector('._playButton > div');
      if (lightboxPlayBadge) {
        lightboxPlayBadge.className =
          'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-16 h-16 rounded-full bg-primary/85 transition-all';
        lightboxPlayBadge.innerHTML = window.icons?.videoPlayOverlay || '';
        lightboxPlayBadge.querySelectorAll('svg').forEach((svg) => {
          svg.style.width = '2.5rem';
          svg.style.height = '2.5rem';
        });
      }

      videoPlayer.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('._videoControls, ._pausePlayButton, ._playButton')) {
            return;
          }
          const video = videoPlayer.querySelector('video');
          if (!video) return;
          if (!event.target.closest('video, video-player, [data-gallery-video-poster]')) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          if (video.paused) {
            video.play().then(revealLightboxVideo).catch(() => {});
          } else {
            video.pause();
          }
        },
        true
      );

      // Gallery clones have no ._playButton — tapping poster should start playback
      const galleryPoster = videoPlayer.querySelector('[data-gallery-video-poster]');
      if (galleryPoster && existingVideo) {
        galleryPoster.classList.remove('pointer-events-none');
        galleryPoster.style.pointerEvents = 'auto';
        galleryPoster.style.cursor = 'pointer';
        galleryPoster.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          existingVideo.play().then(revealLightboxVideo).catch(() => {});
        });
      }

      videoPlayer.addEventListener('playing', revealLightboxVideo, true);
      videoPlayer.addEventListener('loadeddata', () => {
        const video = videoPlayer.querySelector('video');
        if (video && !video.paused) revealLightboxVideo();
      }, true);

      requestAnimationFrame(() => {
        if (customElements.get('video-player')) {
          customElements.upgrade(videoPlayer);
        } else {
          customElements.whenDefined('video-player').then(() => {
            customElements.upgrade(videoPlayer);
          });
        }
      });
    }
  }

  /**
   * Generate thumbnail strip
   * @private
   */
  #generateThumbnails() {
    this.thumbnailStrip.innerHTML = '';

    this.items.forEach((item, index) => {
      const thumbnail = document.createElement('button');
      thumbnail.type = 'button';
      // Maintain aspect ratio instead of forcing square (PDP media is ~4:5)
      let aspectRatio = 0.8;
      if (item.naturalWidth && item.naturalHeight) {
        aspectRatio = item.naturalWidth / item.naturalHeight;
      } else if (item.type === 'video' && item.videoPlayerElement) {
        const style = item.videoPlayerElement.getAttribute('style');
        if (style && style.includes('--aspect-ratio:')) {
          const match = style.match(/--aspect-ratio:\s*([\d.]+)/);
          if (match) {
            aspectRatio = parseFloat(match[1]);
          }
        }
      }
      const height = 64;
      const width = Math.max(40, Math.round(height * aspectRatio));

      thumbnail.className = `shrink-0 transition relative overflow-hidden cursor-pointer touch-manipulation ${
        index === this.currentIndex
          ? 'opacity-100'
          : 'opacity-50 hover:opacity-75'
      }`;
      if (index === this.currentIndex) {
        thumbnail.setAttribute('data-active', 'true');
      }
      thumbnail.style.width = `${width}px`;
      thumbnail.style.height = `${height}px`;
      thumbnail.setAttribute('aria-label', `View ${item.type} ${index + 1}`);
      thumbnail.setAttribute('aria-current', index === this.currentIndex ? 'true' : 'false');

      if (item.type === 'image') {
        const img = document.createElement('img');
        img.src = item.thumbnail || item.src;
        img.alt = '';
        img.decoding = 'async';
        img.className = 'w-full h-full object-cover pointer-events-none';
        thumbnail.appendChild(img);
      } else if (item.type === 'video') {
        const videoPlayer = item.videoPlayerElement;
        let posterSrc = item.thumbnail || null;

        if (!posterSrc && videoPlayer) {
          const playButton = videoPlayer.querySelector('._playButton');
          if (playButton) {
            const posterImg = playButton.querySelector('img');
            if (posterImg) {
              posterSrc = posterImg.src || posterImg.getAttribute('src');
            }
          }

          if (!posterSrc) {
            const template = videoPlayer.querySelector('template');
            if (template) {
              const video = template.content.querySelector('video');
              if (video) {
                posterSrc = video.poster || video.getAttribute('poster');
              }
            }
          }
        }

        if (posterSrc) {
          const img = document.createElement('img');
          img.src = posterSrc;
          img.alt = '';
          img.decoding = 'async';
          img.className = 'w-full h-full object-cover pointer-events-none';
          thumbnail.appendChild(img);

          const playOverlay = document.createElement('div');
          playOverlay.className = 'absolute inset-0 flex items-center justify-center pointer-events-none';
          const playCircle = document.createElement('span');
          playCircle.className = 'w-6 h-6 rounded-full bg-primary/85 flex items-center justify-center';
          playCircle.innerHTML = window.icons?.videoPlayOverlay || '';
          playCircle.querySelectorAll('svg').forEach((svg) => {
            svg.style.width = '0.875rem';
            svg.style.height = '0.875rem';
          });
          playOverlay.appendChild(playCircle);
          thumbnail.appendChild(playOverlay);
        } else {
          const placeholder = document.createElement('div');
          placeholder.className = 'w-full h-full bg-gray-200 flex items-center justify-center text-xs pointer-events-none';
          placeholder.textContent = 'Video';
          thumbnail.appendChild(placeholder);
        }
      }

      thumbnail.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (index === this.currentIndex) {
          return;
        }
        this.currentIndex = index;
        this.#updateContent();
        this.#updateThumbnailStates();
        thumbnail.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      });

      this.thumbnailStrip.appendChild(thumbnail);
    });

    // Keep the active thumb in view once the strip is laid out
    requestAnimationFrame(() => {
      const active = this.thumbnailStrip.querySelector('button[data-active="true"]');
      active?.scrollIntoView({ inline: 'center', block: 'nearest' });
    });
  }

  /**
   * Update thumbnail active states
   * @private
   */
  #updateThumbnailStates() {
    const thumbnails = this.thumbnailStrip.querySelectorAll('button');
    thumbnails.forEach((thumbnail, index) => {
      if (index === this.currentIndex) {
        thumbnail.classList.remove('opacity-50');
        thumbnail.classList.add('opacity-100');
        thumbnail.setAttribute('data-active', 'true');
        thumbnail.setAttribute('aria-current', 'true');
        thumbnail.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      } else {
        thumbnail.classList.remove('opacity-100');
        thumbnail.classList.add('opacity-50');
        thumbnail.removeAttribute('data-active');
        thumbnail.setAttribute('aria-current', 'false');
      }
    });
  }

  /**
   * Dispatch custom event
   * @param {string} name - Event name
   * @param {Object} detail - Event detail
   * @private
   */
  #dispatchEvent(name, detail) {
    const event = new CustomEvent(name, {
      detail,
      bubbles: true,
      cancelable: true
    });
    document.dispatchEvent(event);
    return event;
  }

  /**
   * Cleanup resources
   * @private
   */
  #cleanup() {
    // Remove event listeners
    if (this.boundClickHandler) {
      document.removeEventListener('click', this.boundClickHandler, true);
    }
    if (this.boundKeyHandler) {
      document.removeEventListener('keydown', this.boundKeyHandler);
    }

    // Remove container
    if (this.container) {
      this.container.remove();
    }
  }
}

// Register the custom element
if (!customElements.get('electric-lightbox')) {
  customElements.define('electric-lightbox', ElectricLightbox);
}

// Initialize one instance globally
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('electric-lightbox')) {
      const lightbox = document.createElement('electric-lightbox');
      document.body.appendChild(lightbox);
    }
  });
} else {
  // DOM is already loaded
  if (!document.querySelector('electric-lightbox')) {
    const lightbox = document.createElement('electric-lightbox');
    document.body.appendChild(lightbox);
  }
}

(function () {
/**
 * @fileoverview Electric Disclosure System for Electric Maybe Shopify Theme
 * @description Shared disclosure system providing both accordion and dropdown functionality
 * with comprehensive accessibility, keyboard navigation, and sync group support.
 * 
 * @author Electric Maybe
 * @version 3.0.0
 * @license MIT
 */

/**
 * Base disclosure class that provides shared functionality for both accordion and dropdown variants
 * 
 * This class handles common disclosure patterns including:
 * - Sync group management (closing other disclosures when one opens)
 * - Keyboard navigation (Enter, Space, Arrow keys, Escape)
 * - Accessibility attributes (ARIA expanded, controls, labelledby)
 * - Event handling and cleanup
 * - Error handling and logging
 * 
 * @example
 * // For accordion disclosure
 * <accordion-disclosure data-sync-group="faq">
 *   <details>
 *     <summary>FAQ Item</summary>
 *     <div>Answer content</div>
 *   </details>
 * </accordion-disclosure>
 * 
 * @example
 * // For dropdown disclosure  
 * <dropdown-disclosure data-sync-group="filters">
 *   <details>
 *     <summary>Filter Options</summary>
 *     <div class="dropdown-content">Filter content</div>
 *   </details>
 * </dropdown-disclosure>
 */
class ElectricDisclosure extends HTMLElement {
  /** @type {boolean} Component connection state */
  #isConnected = false;
  
  /** @type {HTMLDetailsElement | null} Details element */
  #details = null;
  
  /** @type {HTMLElement | null} Summary element */
  #summary = null;
  
  /** @type {HTMLElement | null} Content element */
  #content = null;

  /**
   * Get the details element (protected for child classes)
   * @protected
   */
  get details() {
    return this.#details;
  }

  /**
   * Get the summary element (protected for child classes)
   * @protected
   */
  get summary() {
    return this.#summary;
  }

  /**
   * Get the content element (protected for child classes)
   * @protected
   */
  get content() {
    return this.#content;
  }
  
  /** @type {NodeList | null} Other elements in sync group */
  #syncGroup = null;
  
  /** @type {string} Disclosure type (accordion or dropdown) */
  #disclosureType = '';

  constructor() {
    super();
  }

  /**
   * Initialize the disclosure component
   * @private
   */
  connectedCallback() {
    if (this.#isConnected) return;
    
    try {
      this.#isConnected = true;
      this.#disclosureType = this.tagName.toLowerCase();
      this.#initializeElements();
      this.#setupAccessibility();
      this.#setupEventListeners();
      this.#setupSyncGroup();
      this.#setupInitialState();
    } catch (error) {
      this.#handleError('Failed to initialize disclosure', error);
    }
  }

  /**
   * Clean up resources when component is disconnected
   * @private
   */
  disconnectedCallback() {
    this.#isConnected = false;
    this.#cleanup();
  }

  /**
   * Initialize DOM elements
   * @private
   */
  #initializeElements() {
    this.#details = this.querySelector('details');
    this.#summary = this.#details?.querySelector('summary');
    // Find the first content element that is not a descendant of <summary>
    this.#content = null;
    if (this.#details) {
      const candidates = Array.from(this.#details.querySelectorAll('div, ul, ol, section, article'));
      for (const el of candidates) {
        // Exclude elements that are inside a <summary>
        if (!el.closest('summary')) {
          this.#content = el;
          break;
        }
      }
    }
    
    if (!this.#details) {
      throw new Error('ElectricDisclosure: Details element is required');
    }
    
    if (!this.#summary) {
      throw new Error('ElectricDisclosure: Summary element is required');
    }
    
    if (!this.#content) {
      throw new Error('ElectricDisclosure: Content element is required');
    }
  }

  /**
   * Setup accessibility attributes and roles
   * @private
   */
  #setupAccessibility() {
    // Set up summary accessibility
    this.#summary.setAttribute('tabindex', '0');
    this.#summary.setAttribute('role', 'button');
    this.#summary.setAttribute('aria-expanded', 'false');
    
    // Generate unique IDs for ARIA relationships
    const contentId = `${this.id || 'disclosure'}-content`;
    const summaryId = `${this.id || 'disclosure'}-summary`;
    
    this.#content.id = contentId;
    this.#summary.id = summaryId;
    
    // Set up ARIA relationships
    this.#summary.setAttribute('aria-controls', contentId);
    this.#content.setAttribute('aria-labelledby', summaryId);
    
    // Set appropriate role for content
    if (this.#disclosureType === 'dropdown-disclosure') {
      // Only use role="menu" when content is a real menu (menuitems). Use data-no-menu
      // for dropdowns that contain form controls (e.g. filters, sort) to avoid broken ARIA menu.
      if (this.hasAttribute('data-no-menu')) {
        this.#content.setAttribute('role', 'group');
      } else {
        this.#content.setAttribute('role', 'menu');
      }
    } else {
      this.#content.setAttribute('role', 'region');
    }
  }

  /**
   * Setup event listeners for keyboard and mouse interactions
   * @private
   */
  #setupEventListeners() {
    // Click handler
    this.#summary.addEventListener('click', this.#handleClick.bind(this));
    
    // Keyboard navigation
    this.#summary.addEventListener('keydown', this.#handleKeydown.bind(this));
    
    // Outside click detection for dropdowns
    if (this.#disclosureType === 'dropdown-disclosure') {
      document.addEventListener('click', this.#handleDocumentClick.bind(this), true);
    }
  }

  /**
   * Get current sync group members (always returns fresh list)
   * @returns {NodeList | null} Current sync group members or null if no sync group
   * @private
   */
  #getSyncGroup() {
    const syncGroupName = this.dataset.syncGroup;
    if (!syncGroupName) return null;
    
    return document.querySelectorAll(`[data-sync-group="${syncGroupName}"]`);
  }

  /**
   * Setup sync group functionality
   * @private
   */
  #setupSyncGroup() {
    // Store initial sync group reference for validation
    this.#syncGroup = this.#getSyncGroup();
  }

  /**
   * Setup initial state based on attributes
   * @private
   */
  #setupInitialState() {
    // Check if should be open by default
    if (this.#details.hasAttribute('open')) {
      this.setAttribute('aria-expanded', 'true');
      
      // For accordions, trigger the open animation
      if (this.#disclosureType === 'accordion-disclosure') {
        this.open();
      }
    }
  }

  /**
   * Handle click events on the summary
   * @param {Event} event - Click event
   * @private
   */
  #handleClick(event) {
    event.preventDefault();
    
    if (this.#details.open) {
      this.close();
    } else {
      this.open();
    }
  }

  /**
   * Handle keyboard navigation
   * @param {KeyboardEvent} event - Keydown event
   * @private
   */
  #handleKeydown(event) {
    // Prevent default behavior for these keys
    if (["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight", "Enter", " "].includes(event.key)) {
      event.preventDefault();
    }

    switch (event.key) {
      case "ArrowDown":
      case "ArrowRight":
        if (!this.#details.open) {
          this.open();
        } else if (this.#disclosureType === 'accordion-disclosure') {
          // Move focus to first focusable element in content
          const firstFocusable = this.#content.querySelector('[tabindex="0"], button, a, input, select, textarea');
          if (firstFocusable) {
            firstFocusable.focus();
          }
        }
        break;
        
      case "ArrowUp":
      case "ArrowLeft":
        if (this.#details.open && this.#disclosureType === 'accordion-disclosure') {
          this.close();
        }
        break;
        
      case "Enter":
      case " ": // Space key
        this.#handleClick(event);
        break;
        
      case "Escape":
        if (this.#details.open) {
          this.close();
          this.#summary.focus();
        }
        break;
    }
  }

  /**
   * Handle clicks outside the disclosure (for dropdowns)
   * @param {Event} event - Click event
   * @private
   */
  #handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.close();
    }
  }

  /**
   * Open the disclosure and close others in sync group
   * @private
   */
  open() {
    // Close other elements in the same sync group
    this.#closeSyncGroup();
    
    // Set open state
    this.#details.open = true;
    this.setAttribute('aria-expanded', 'true');
    
    // Dispatch custom event
    this.dispatchEvent(new CustomEvent('disclosure:opened', {
      detail: { type: this.#disclosureType },
      bubbles: true
    }));
  }

  /**
   * Close the disclosure
   * @private
   */
  close() {
    this.#details.open = false;
    this.setAttribute('aria-expanded', 'false');
    
    // Dispatch custom event
    this.dispatchEvent(new CustomEvent('disclosure:closed', {
      detail: { type: this.#disclosureType },
      bubbles: true
    }));
  }

  /**
   * Close other elements in the same sync group
   * @private
   */
  #closeSyncGroup() {
    const syncGroupMembers = this.#getSyncGroup();
    if (!syncGroupMembers) return;
    
    syncGroupMembers.forEach((el) => {
      // Skip if element is being replaced or not connected
      if (el === this || !el.isConnected) return;
      
      // Handle different types of disclosure elements
      const tagName = el.tagName.toLowerCase();
      
      if (tagName === 'accordion-disclosure' || tagName === 'dropdown-disclosure') {
        // Check if element has the close method (properly initialized)
        if (typeof el.close === 'function' && el.details?.open) {
          try {
            el.close();
          } catch (error) {
            // Failed to close sync group member
          }
        }
      } else if (el.classList.contains('disclosure-element')) {
        // Handle legacy disclosure-element components
        if (el.elements?.button?.getAttribute('aria-expanded') === 'true') {
          try {
            el.close();
          } catch (error) {
            // Failed to close sync group member
          }
        }
      }
    });
  }

  /**
   * Handle errors gracefully with logging and events
   * @param {string} message - Error message
   * @param {Error} error - Original error object
   * @private
   */
  #handleError(message, error) {
    this.dispatchEvent(new CustomEvent('disclosure:error', {
      detail: { message, error: error.message, type: this.#disclosureType },
      bubbles: true
    }));
  }

  /**
   * Clean up resources and event listeners
   * @private
   */
  #cleanup() {
    if (this.#disclosureType === 'dropdown-disclosure') {
      document.removeEventListener('click', this.#handleDocumentClick, true);
    }
  }

  /**
   * Static utility method to find disclosure elements
   * @param {string} type - Disclosure type to find
   * @returns {NodeList} Matching disclosure elements
   * @static
   */
  static findDisclosures(type = '') {
    const selector = type ? `${type}` : 'accordion-disclosure, dropdown-disclosure';
    return document.querySelectorAll(selector);
  }

  /**
   * Static utility method to close all disclosures of a specific type
   * @param {string} type - Disclosure type to close
   * @static
   */
  static closeAll(type = '') {
    const disclosures = this.findDisclosures(type);
    disclosures.forEach(disclosure => {
      if (disclosure.details?.open) {
        disclosure.close();
      }
    });
  }

  /**
   * Static utility method to get sync group members by group name
   * Always returns fresh list of current DOM elements
   * @param {string} syncGroupName - Name of the sync group
   * @returns {NodeList} Current sync group members
   * @static
   */
  static getSyncGroup(syncGroupName) {
    if (!syncGroupName) {
      return document.querySelectorAll('[data-sync-group="__non_existent__"]'); // Empty NodeList
    }
    
    return document.querySelectorAll(`[data-sync-group="${syncGroupName}"]`);
  }
}

/**
 * Accordion Disclosure - Animated collapsible content sections
 * 
 * Extends ElectricDisclosure to provide smooth height animations
 * and accordion-specific behavior for content sections.
 * 
 * @example
 * <accordion-disclosure data-sync-group="faq">
 *   <details>
 *     <summary>FAQ Item</summary>
 *     <div>Answer content with smooth animations</div>
 *   </details>
 * </accordion-disclosure>
 */
class AccordionDisclosure extends ElectricDisclosure {
  /** @type {Animation | null} Current animation instance */
  #animation = null;
  
  /** @type {boolean} Whether accordion is currently closing */
  #isClosing = false;
  
  /** @type {boolean} Whether accordion is currently expanding */
  #isExpanding = false;

  constructor() {
    super();
  }

  /**
   * Override open method to add accordion-specific behavior
   * @private
   */
  open() {
    // Prevent interaction while animations are in progress
    if (this.#isClosing || this.#isExpanding) {
      return;
    }

    // Ensure any ongoing animation is canceled before starting a new one
    if (this.#animation) {
      this.#animation.cancel();
      this.#animation = null;
    }

    // Preset the host element height to the closed (summary-only) height so the
    // expand animation has a correct starting value even after base open logic
    const summaryHeight = `${this.summary?.offsetHeight || 0}px`;
    this.style.display = "block";
    this.style.height = summaryHeight;
    this.style.overflow = "hidden";

    // Call base open to handle sync-group closing, aria, and events
    super.open();

    // Animate to full height on next frame when layout has updated
    window.requestAnimationFrame(() => this.#expand());
  }

  /**
   * Override close method to add accordion-specific behavior
   * @private
   */
  close() {
    // Prevent interaction while animations are in progress
    if (this.#isClosing || this.#isExpanding) {
      return;
    }
    
    this.#shrink();
  }

  /**
   * Animate the accordion shrinking
   * @param {number} duration - Animation duration in milliseconds
   * @private
   */
  async #shrink(duration = window.animation.duration) {
    this.#isClosing = true;
    this.setAttribute('aria-expanded', 'false');

    const startHeight = `${this.offsetHeight + 1}px`;
    const endHeight = `${this.summary.offsetHeight + 2}px`;

    try {
        if (this.#animation) {
          this.#animation.cancel();
        }

        this.#animation = this.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration,
            easing: window.animation.cubicBezier
          }
        );

        // Animate content opacity
        this.content.animate(
          {
            opacity: [1, 0],
            transform: ["translateY(0px)", "translateY(4px)"]
          },
          {
            duration: window.animation.durationShort,
            easing: window.animation.cubicBezier,
            fill: "forwards",
          }
        );

        this.#animation.onfinish = () => this.#onAnimationFinish(false);
        this.#animation.oncancel = () => (this.#isClosing = false);
    } catch (error) {
      // Graceful degradation - just close without animation
      this.style.height = endHeight;
      this.#onAnimationFinish(false);
    }
  }

  /**
   * Animate the accordion expanding
   * @private
   */
  async #expand() {
    this.#isExpanding = true;
    const startHeight = `${this.offsetHeight + 2}px`;
    const endHeight = `${this.summary.offsetHeight + this.content?.offsetHeight + 1}px`;
    
    try {
        // Fallback to Web Animations API
        if (this.#animation) {
          this.#animation.cancel();
        }

        this.#animation = this.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: window.animation.duration,
            easing: window.animation.cubicBezier
          }
        );

        // Animate content opacity
        this.content.animate(
          {
            opacity: [0, 1],
            transform: ["translateY(4px)", "translateY(0)"]
          },
          {
            duration: window.animation.durationShort,
            easing: "ease-out",
            fill: "forwards",
          }
        );

        this.#animation.onfinish = () => this.#onAnimationFinish(true);
        this.#animation.oncancel = () => (this.#isExpanding = false);
    } catch (error) {
      // Graceful degradation - just open without animation
      this.style.height = 'auto';
      this.#onAnimationFinish(true);
    }
  }

  /**
   * Handle animation completion
   * @param {boolean} open - Whether the accordion is now open
   * @private
   */
  #onAnimationFinish(open) {
    this.details.open = open;
    this.#animation = null;
    this.#isClosing = false;
    this.#isExpanding = false;
    this.style.height = this.style.overflow = "";

    // When an accordion finishes closing, force a reflow on children
    // with slide-up-sm to reset their CSS animations/transitions
    if (!open) {
      this.#forceReflowOnSlideUpElements();
    }
  }

  /**
   * Public method to shrink accordion (for external control)
   * @param {number} duration - Animation duration
   */
  shrink(duration) {
    this.#shrink(duration);
  }

  /**
   * Force a synchronous reflow on elements that should re-run their CSS animations
   * Targets children with class `slide-up-sm` inside the accordion content
   * @private
   */
  #forceReflowOnSlideUpElements() {
    try {
      const targets = this.content?.querySelectorAll('.slide-up-sm');
      if (!targets || targets.length === 0) return;

      targets.forEach((node) => {
        // Force a reflow to restart CSS animations/transitions reliably
        // eslint-disable-next-line no-unused-expressions
        node.classList.remove('slide-up-sm');
        setTimeout(() => {
          void document.body.offsetHeight;
        }, 100);
        setTimeout(() => {
          node.classList.add('slide-up-sm');
        }, 200);
      });
    } catch (error) {
      this.dispatchEvent(new CustomEvent('disclosure:error', {
        detail: { message: 'Failed to force reflow', error: error?.message, type: 'accordion-disclosure' },
        bubbles: true
      }));
    }
  }
  
  /**
   * Clean up resources on disconnect
   * Per javascript-standards.mdc Line 156-173
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    
    // Cancel any ongoing animations
    if (this.#animation) {
      this.#animation.cancel();
      this.#animation = null;
    }
  }
}

/**
 * Dropdown Disclosure - Dropdown menu functionality
 * 
 * Extends ElectricDisclosure to provide dropdown-specific behavior
 * with absolute positioning and outside click detection.
 * 
 * @example
 * <dropdown-disclosure data-sync-group="filters">
 *   <details>
 *     <summary>Filter Options</summary>
 *     <div class="absolute top-full left-0 z-50">Filter content</div>
 *   </details>
 * </dropdown-disclosure>
 */
class DropdownDisclosure extends ElectricDisclosure {
  constructor() {
    super();
  }

  /**
   * Override open method to add dropdown-specific behavior
   * @private
   */
  open() {
    super.open();
    
    // Ensure dropdown content is properly positioned
    if (this.content) {
      this.content.style.display = 'block';
    }
  }

  /**
   * Override close method to add dropdown-specific behavior
   * @private
   */
  close() {
    super.close();
    
    // Hide dropdown content
    if (this.content) {
      this.content.style.display = 'none';
    }
  }
}

/**
 * Register all disclosure components when DOM is ready
 * @private
 */
function registerDisclosureComponents() {
  // Register accordion disclosure
  if (!customElements.get('accordion-disclosure')) {
    customElements.define('accordion-disclosure', AccordionDisclosure);
  }
  
  // Register dropdown disclosure
  if (!customElements.get('dropdown-disclosure')) {
    customElements.define('dropdown-disclosure', DropdownDisclosure);
  }
}

// Register components when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', registerDisclosureComponents);
} else {
  registerDisclosureComponents();
}

// Export for module usage
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    ElectricDisclosure,
    AccordionDisclosure,
    DropdownDisclosure
  };
}
})();
(function () {
/**
 * HeaderDrawer - Mobile menu drawer component for header navigation
 * 
 * Extends MenuDrawer to provide mobile-specific navigation functionality
 * with proper focus management and responsive behavior.
 * 
 * @extends MenuDrawer
 * @fires menu:opened - When the menu drawer is opened
 * @fires menu:closed - When the menu drawer is closed
 * 
 * @example
 * <header-drawer>
 *   <details id="menu-drawer">
 *     <summary>Menu</summary>
 *     <nav>...</nav>
 *   </details>
 * </header-drawer>
 */
class HeaderDrawer extends MenuDrawer {
  // Private fields
  #header = null;
  #menuDrawer = null;
  #resizeHandler = null;
  /** @type {number|null} Cached root font size (px); invalidated on resize. */
  #cachedRootFontSize = null;
  
  constructor() {
    super();
    
    // Bind event handlers
    this.#resizeHandler = this.#handleResize.bind(this);
  }
  
  connectedCallback() {
    super.connectedCallback?.();
    
    try {
      this.#setupDOM();
      this.#adjustMenuPosition();
    } catch (error) {
      // Error in connectedCallback
    }
  }
  
  /**
   * Opens the menu drawer with proper animations and focus management
   * @param {HTMLElement} summaryElement - The summary element that triggered opening
   */
  openMenuDrawer(summaryElement) {
    try {
      document.body.classList.add("overflow-hidden");
      this.#header = this.#header || document.querySelector("header-element");
      
      if (this.#header) {
        this.#header.classList.add("menu-open");
      }
      
      setTimeout(() => {
        this.mainDetailsToggle?.classList.add("menu-opening");
      });
      
      summaryElement.setAttribute("aria-expanded", "true");
      window.addEventListener("resize", this.#resizeHandler);
      
      // Call parent's focus trap if available
      if (typeof trapFocus === 'function') {
        trapFocus(this.mainDetailsToggle, summaryElement);
      }
      
      
      this.dispatchEvent(new CustomEvent('menu:opened', {
        bubbles: true,
        detail: { drawer: this }
      }));
    } catch (error) {
      // Error opening menu
    }
  }
  
  /**
   * Closes the menu drawer and restores focus
   * @param {Event} event - The event that triggered closing
   * @param {HTMLElement} elementToFocus - Element to focus after closing
   */
  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    
    try {
      super.closeMenuDrawer?.(event, elementToFocus);
      
      if (this.#header) {
        this.#header.classList.remove("menu-open");
      }
      
      window.removeEventListener("resize", this.#resizeHandler);
      
      this.dispatchEvent(new CustomEvent('menu:closed', {
        bubbles: true,
        detail: { drawer: this }
      }));
    } catch (error) {
      // Error closing menu
    }
  }
  
  // Private methods
  #setupDOM() {
    this.#menuDrawer = this.querySelector("#menu-drawer");
  }
  
  #adjustMenuPosition() {
    if (!this.#menuDrawer) return;
    const headerElement = document.querySelector("header-element");
    if (!headerElement) return;
    // Batch style reads then single write (avoids interleaved getComputedStyle reflows)
    const headerStyle = window.getComputedStyle(headerElement);
    const paddingBottom = parseInt(headerStyle.paddingBottom, 10) || 0;
    const rootFontSize = this.#cachedRootFontSize ?? parseFloat(
      getComputedStyle(document.documentElement).fontSize
    );
    if (this.#cachedRootFontSize == null) this.#cachedRootFontSize = rootFontSize;
    this.#menuDrawer.style.marginTop = `-${paddingBottom / rootFontSize}rem`;
  }
  
  #handleResize() {
    if (!this.#header) return;
    // Batch all reads (layout + style) then writes to avoid forced reflows
    const rect = this.#header.getBoundingClientRect();
    const bottomPosition = rect.bottom - (this.borderOffset || 0);
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    this.#cachedRootFontSize = rootFontSize;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${Math.round(bottomPosition) / rootFontSize}rem`
    );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight / rootFontSize}rem`
    );
  }
}

// Register custom element
if (!customElements.get("header-drawer")) {
  customElements.define("header-drawer", HeaderDrawer);
}

/**
 * HeaderElement - Advanced sticky header component with scroll-based visibility
 * 
 * Provides a high-performance sticky header that hides/shows based on scroll
 * direction and position. Includes comprehensive state management and 
 * accessibility features.
 * 
 * @fires header:state-change - When header state changes
 * @fires header:visibility-change - When header visibility changes
 * 
 * @example
 * <header-element data-sticky="true">
 *   <div class="js-announcement-bar">...</div>
 *   <nav class="header__desktop-navigation">...</nav>
 * </header-element>
 * 
 * @example CSS usage with state attributes
 * header-element[data-visibility="hidden"] { transform: translateY(-100%); }
 * header-element[data-threshold-passed="true"] { backdrop-filter: blur(10px); }
 * header-element[data-scroll-range="far"] { background: solid; }
 */
class HeaderElement extends HTMLElement {
  // Private fields
  #isConnected = false;
  #abortController = null;
  #rafId = null;
  #scrollTimeout = null;
  #resizeTimeout = null;
  #transitionTimeout = null;
  #lastScrollTime = 0;
  
  // DOM references
  #header = null;
  #announcementBar = null;
  #headerOffset = null;
  
  // Event handlers
  #scrollHandler = null;
  #resizeHandler = null;
  
  // State management
  #state = {
    scrollPosition: 0,
    lastScrollPosition: 0,
    headerHeight: 0,
    announcementHeight: 0,
    visibility: 'visible',
    scrollDirection: 'none',
    thresholdPassed: false,
    isTransitioning: false,
    animationDuration: 300,
    isSticky: false
  };

  /** @type {number|null} Cached root font size (px); invalidated on resize to avoid getComputedStyle reflows. */
  #cachedRootFontSize = null;
  /** @type {string} */
  #lastStateFingerprint = '';
  /** @type {string} */
  #lastScrollRange = '';
  /** @type {number|null} */
  #lastRoundedScrollPosition = null;
  
  // Configuration
  #config = {
    threshold: 100,
    thresholdHysteresis: 20, // Prevents oscillation near threshold
    /** Below this scroll distance from top, `sticky` is removed from `.header-elements`. */
    stickyReleaseScrollPx: 120,
    scrollDebounceDelay: 32,
    resizeDebounceDelay: 150,
    hideOffset: 5,
    showOffset: 5,
    lastStateChangeTime: 0,
    minStateChangeInterval: 100 // Minimum time between state changes
  };
  
  // Constants
  static #TRANSITION_DELAY = 500;
  
  // Observed attributes
  static observedAttributes = ["data-sticky"];
  
  constructor() {
    super();
    
    // Bind event handlers
    this.#scrollHandler = this.#handleScroll.bind(this);
    this.#resizeHandler = this.#handleResize.bind(this);
  }
  
  connectedCallback() {
    if (this.#isConnected) return;
    
    try {
      this.#setupDOM();
      
      if (!this.#state.isSticky || !this.#header) {
        this.#isConnected = true;
        return;
      }
      
      this.#setupEventListeners();
      requestAnimationFrame(() => {
        if (!this.#header) return;
        this.#setupAnimationDurations();
        const layoutSnapshot = this.#readLayoutSnapshot();
        this.#applyLayoutFromSnapshot(layoutSnapshot);
        this.#setupInitialStickyState();
        this.#state.scrollPosition = window.scrollY || document.documentElement.scrollTop;
        this.#state.lastScrollPosition = this.#state.scrollPosition;
        this.#syncHeaderStickyClass(this.#state.scrollPosition);
        this.#updateStateAttributes();
        this.#isConnected = true;
        this.dispatchEvent(new CustomEvent('header:ready', {
          detail: { header: this },
          bubbles: true
        }));
      });
    } catch (error) {
      // Error in connectedCallback
    }
  }
  
  disconnectedCallback() {
    if (!this.#isConnected) return;
    
    try {
      this.#cleanup();
      this.#isConnected = false;
    } catch (error) {
      // Error in disconnectedCallback
    }
  }
  
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    
    if (name === "data-sticky") {
      this.#state.isSticky = newValue === "true";
      
      if (this.#isConnected) {
        if (this.#state.isSticky) {
          this.#setupEventListeners();
        } else {
          this.#cleanup();
        }
      }
    }
  }
  
  // Public API methods
  /**
   * Get current header state
   * @returns {Object} Current state object
   */
  getState() {
    return { ...this.#state };
  }
  
  /**
   * Force show the header
   */
  show() {
    this.#showHeader();
  }
  
  /**
   * Force hide the header
   */
  hide() {
    this.#hideHeader();
  }
  
  /**
   * Update header sticky offset CSS variable
   * Public method to allow external components to trigger offset recalculation
   */
  updateHeaderStickyOffset() {
    const layoutSnapshot = this.#readLayoutSnapshot();
    this.#applyLayoutFromSnapshot(layoutSnapshot);
  }

  /**
   * Keep the header (and hamburger close control) on-screen while a drawer
   * locks body scroll. iOS `position: fixed` on body unsticks the bar if
   * `sticky` was removed during downward scroll.
   */
  pinForDrawer() {
    if (!this.#header) return;
    this.#showHeader();
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    if (scrollPosition >= this.#config.stickyReleaseScrollPx) {
      this.#header.classList.add("sticky");
    }
  }
  
  // Private methods
  #setupDOM() {
    this.#header = this.closest(".header-elements");
    this.#announcementBar = this.querySelector(".js-announcement-bar");
    this.#state.isSticky = this.dataset.sticky === "true";
  }
  
  #setupAnimationDurations() {
    if (!this.#header) return;
    // Single read; transitionDuration is style-only (no layout). Batched at init.
    const transitionDuration = window.getComputedStyle(this.#header).transitionDuration || '0.3s';
    const durationInMs = transitionDuration.includes('ms')
      ? parseFloat(transitionDuration)
      : parseFloat(transitionDuration) * 1000;
    this.#state.animationDuration = durationInMs || 300;
  }

  /**
   * Root font size in px. Cached to avoid repeated getComputedStyle (forced reflow).
   * Invalidated in #handleResize so one read per resize batch.
   * @returns {number}
   * @private
   */
  #getRootFontSize() {
    if (this.#cachedRootFontSize == null) {
      this.#cachedRootFontSize = parseFloat(
        getComputedStyle(document.documentElement).fontSize
      );
    }
    return this.#cachedRootFontSize;
  }

  /**
   * Single batch of all layout reads (offsetHeight etc.) to avoid forced reflows.
   * Call once, then pass result to #applyLayoutFromSnapshot for all writes.
   * @returns {{ headerOffsetPx: number, stickyOffsetPx: number, headerHeight: number, announcementHeight: number, rootFontSize: number } | null}
   * @private
   */
  #readLayoutSnapshot() {
    if (!this.#header) return null;
    const headerElements = document.querySelectorAll("header-element");
    const headerOffsetPx = headerElements.length
      ? Array.from(headerElements).reduce((acc, el) => acc + el.offsetHeight, 0)
      : 0;
    const mainHeader = this.querySelector(".header__main");
    const promoBanner = this.querySelector("promo-banner");
    let stickyOffsetPx = mainHeader?.offsetHeight || 0;
    if (
      promoBanner &&
      this.getAttribute("data-threshold-passed") !== "true"
    ) {
      stickyOffsetPx += promoBanner.offsetHeight || 0;
    }
    const headerHeight = this.#header.offsetHeight;
    const announcementHeight = this.#announcementBar?.offsetHeight || 0;
    const rootFontSize = this.#getRootFontSize();
    return {
      headerOffsetPx,
      stickyOffsetPx,
      headerHeight,
      announcementHeight,
      rootFontSize
    };
  }

  /**
   * Applies a layout snapshot (writes only). No layout reads here — avoids reflow.
   * @param {{ headerOffsetPx: number, stickyOffsetPx: number, headerHeight: number, announcementHeight: number, rootFontSize: number } | null} snapshot
   * @private
   */
  #applyLayoutFromSnapshot(snapshot) {
    if (!snapshot) return;
    const { headerOffsetPx, stickyOffsetPx, headerHeight, announcementHeight, rootFontSize } =
      snapshot;
    document.body.style.setProperty(
      "--header-offset",
      `${headerOffsetPx / rootFontSize}rem`
    );
    this.#state.headerHeight = headerHeight;
    this.#state.announcementHeight = announcementHeight;
    if (this.#headerOffset) {
      this.#headerOffset.style.height = `${headerHeight / rootFontSize}rem`;
    }
    setTimeout(() => {
      if (!this.isConnected) return;
      document.body.style.setProperty(
        "--header-sticky-offset",
        `${stickyOffsetPx / rootFontSize}rem`
      );
    }, HeaderElement.#TRANSITION_DELAY);
  }
  
  /**
   * Toggle Tailwind `sticky` on the header shell: off near the top of the page; on
   * once scrolled past {@link #config.stickyReleaseScrollPx} while scrolling up (or on
   * initial programmatic sync). Never adds `sticky` during downward scroll.
   * @param {number} scrollPosition
   * @param {'up' | 'down' | 'none' | undefined} [scrollDirection] From last frame's delta; `undefined` = init / non-scroll (position-only add when past threshold).
   * @private
   */
  #syncHeaderStickyClass(scrollPosition, scrollDirection) {
    if (!this.#header) return;
    const releasePx = this.#config.stickyReleaseScrollPx;
    if (scrollPosition < releasePx) {
      this.#header.classList.remove("sticky");
      return;
    }
    if (scrollDirection === 'down') {
      this.#header.classList.remove("sticky");
      return;
    }
    if (scrollDirection === 'up') {
      this.#header.classList.add("sticky");
      return;
    }
    if (scrollDirection === 'none') {
      return;
    }
    this.#header.classList.add("sticky");
  }

  #setupInitialStickyState() {
    if (!this.#header) return;
    this.#headerOffset = document.createElement("div");
    const rootFontSize = this.#getRootFontSize();
    this.#headerOffset.style.height = `${this.#state.headerHeight / rootFontSize}rem`;
    this.#headerOffset.className = 
      "absolute inset-0 bg-background1 shopify-section-group-header-group";
    this.#headerOffset.setAttribute("aria-hidden", "true");
    
    this.#header.classList.add(
      "transition-transform",
      "duration-300",
      "top-0",
      "z-20",
      "bg-transparent"
    );
    // `sticky` is applied only from #syncHeaderStickyClass once scroll passes
    // {@link #config.stickyReleaseScrollPx}, not on initial paint.
  }
  
  #setupEventListeners() {
    // Create abort controller for cleanup
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    
    // Throttled scroll handler
    const throttledScroll = this.#throttle(
      this.#scrollHandler,
      this.#config.scrollDebounceDelay
    );
    
    // Debounced resize handler
    const debouncedResize = this.#debounce(
      this.#resizeHandler,
      this.#config.resizeDebounceDelay
    );
    
    // Add listeners with signal
    window.addEventListener("scroll", throttledScroll, { 
      passive: true, 
      signal 
    });
    
    window.addEventListener("resize", debouncedResize, { 
      signal 
    });
    
    document.addEventListener("promo-banner:closed", this.#handlePromoBannerClosed.bind(this), { 
      signal 
    });
    
    document.addEventListener("promo-banner:visible", this.#handlePromoBannerVisible.bind(this), { 
      signal 
    });
  }
  
  #cleanup() {
    // Abort all event listeners
    this.#abortController?.abort();
    this.#abortController = null;
    
    // Cancel animation frames
    if (this.#rafId) {
      cancelAnimationFrame(this.#rafId);
      this.#rafId = null;
    }
    
    // Clear timeouts
    clearTimeout(this.#scrollTimeout);
    clearTimeout(this.#resizeTimeout);
    clearTimeout(this.#transitionTimeout);
    
    // Reset state
    this.#state.visibility = 'visible';
    this.#state.isTransitioning = false;
  }

  // Event handlers
  #handleScroll() {
    const now = Date.now();
    if (now - this.#lastScrollTime < this.#config.scrollDebounceDelay) {
      return;
    }
    this.#lastScrollTime = now;
    
    // Cancel previous frame
    if (this.#rafId) {
      cancelAnimationFrame(this.#rafId);
    }
    
    // Schedule update in next frame
    this.#rafId = requestAnimationFrame(() => {
      this.#updateScrollState();
    });
  }
  
  #handleResize() {
    try {
      this.#cachedRootFontSize = null;
      const layoutSnapshot = this.#readLayoutSnapshot();
      this.#applyLayoutFromSnapshot(layoutSnapshot);
    } catch (error) {
      // Error handling resize
    }
  }
  
  #handlePromoBannerClosed() {
    try {
      const layoutSnapshot = this.#readLayoutSnapshot();
      this.#applyLayoutFromSnapshot(layoutSnapshot);
    } catch (error) {
      // Error handling promo banner close
    }
  }

  #handlePromoBannerVisible() {
    try {
      const layoutSnapshot = this.#readLayoutSnapshot();
      this.#applyLayoutFromSnapshot(layoutSnapshot);
    } catch (error) {
      // Error handling promo banner visible
    }
  }
  
  #updateScrollState() {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    if (this.#isBodyLocked()) {
      this.#state.lastScrollPosition = scrollPosition;
      return;
    }
    const scrollDelta = scrollPosition - this.#state.lastScrollPosition;
    const scrollDirection =
      Math.abs(scrollDelta) < 1
        ? 'none'
        : scrollDelta > 0
          ? 'down'
          : 'up';

    this.#state.scrollPosition = scrollPosition;
    this.#syncHeaderStickyClass(scrollPosition, scrollDirection);
    this.#state.scrollDirection = scrollDirection;
    
    // Check threshold with hysteresis to prevent oscillation
    const wasThresholdPassed = this.#state.thresholdPassed;
    if (!wasThresholdPassed && scrollPosition > this.#config.threshold + this.#config.thresholdHysteresis) {
      this.#state.thresholdPassed = true;
    } else if (wasThresholdPassed && scrollPosition < this.#config.threshold - this.#config.thresholdHysteresis) {
      this.#state.thresholdPassed = false;
    }
    
    // Always update state attributes to ensure scroll range is current
    this.#updateStateAttributes();
    
    // Handle header visibility only for significant movements
    if (Math.abs(scrollDelta) >= 1) {
      this.#handleHeaderVisibility(scrollPosition, scrollDelta);
    }
    
    this.#state.lastScrollPosition = scrollPosition;
  }
  
  #handleHeaderVisibility(scrollPosition, scrollDelta) {
    // Skip visibility changes when body scroll is locked (modal/drawer open)
    if (this.#isBodyLocked()) {
      return;
    }
    
    // Prevent rapid state changes
    const now = Date.now();
    if (now - this.#config.lastStateChangeTime < this.#config.minStateChangeInterval) {
      return;
    }
    
    // If body is locked (drawer/modal open), maintain current header state
    // This prevents header flicker when body has overflow-hidden
    if (document.body.classList.contains('overflow-hidden')) {
      return;
    }
    
    // Always show header when at the top of the page
    if (scrollPosition <= this.#state.announcementHeight) {
      if (this.#state.visibility !== 'visible' && this.#state.visibility !== 'showing') {
        this.#showHeader();
        this.#config.lastStateChangeTime = now;
      }
      return;
    }
    
    const isHidden = this.#state.visibility === 'hidden' || this.#state.visibility === 'hiding';
    const isVisible = this.#state.visibility === 'visible' || this.#state.visibility === 'showing';
    
    const shouldHide = 
      this.#state.thresholdPassed && 
      scrollDelta > this.#config.hideOffset && 
      !isHidden;
    
    const shouldShow = 
      scrollDelta < -this.#config.showOffset &&
      !isVisible;
    
    if (shouldHide) {
      this.#hideHeader();
      this.#config.lastStateChangeTime = now;
    } else if (shouldShow) {
      this.#showHeader();
      this.#config.lastStateChangeTime = now;
    }
  }
  
  /**
   * Check if body scroll is locked (modal/drawer is open)
   * @returns {boolean} True if body scroll is locked
   */
  #isBodyLocked() {
    return (
      document.body.classList.contains('overflow-hidden') ||
      document.body.style.overflow === 'hidden' ||
      document.body.style.position === 'fixed'
    );
  }
  
  #hideHeader() {
    if (this.#state.visibility === 'hidden') return;
    
    // Clear any pending show transition
    clearTimeout(this.#transitionTimeout);
    
    this.#state.isTransitioning = true;
    this.#state.visibility = 'hiding';
    this.#updateStateAttributes();
    
    if (this.#header) {
      this.#header.classList.add("-translate-y-(--header-offset)");
    }
    
    this.#transitionTimeout = setTimeout(() => {
      // Only finalize hide if we're still in hiding state
      if (this.#state.visibility === 'hiding') {
        this.#state.visibility = 'hidden';
        this.#state.isTransitioning = false;
        this.#updateStateAttributes();
        // Delay sticky offset update to prevent layout shift during scroll
        setTimeout(() => {
          if (this.#state.visibility === 'hidden') {
            const layoutSnapshot = this.#readLayoutSnapshot();
            this.#applyLayoutFromSnapshot(layoutSnapshot);
          }
        }, 100);
        
        this.dispatchEvent(new CustomEvent('header:visibility-change', {
          detail: { visibility: 'hidden' },
          bubbles: true
        }));
      }
    }, this.#state.animationDuration);
  }
  
  #showHeader() {
    if (this.#state.visibility === 'visible') return;
    
    // Clear any pending hide transition
    clearTimeout(this.#transitionTimeout);
    
    this.#state.isTransitioning = true;
    this.#state.visibility = 'showing';
    this.#updateStateAttributes();
    
    if (this.#header) {
      this.#header.classList.remove("-translate-y-(--header-offset)");
    }
    
    this.#transitionTimeout = setTimeout(() => {
      // Only finalize show if we're still in showing state
      if (this.#state.visibility === 'showing') {
        this.#state.visibility = 'visible';
        this.#state.isTransitioning = false;
        this.#updateStateAttributes();
        // Delay sticky offset update to prevent layout shift during scroll
        setTimeout(() => {
          if (this.#state.visibility === 'visible') {
            const layoutSnapshot = this.#readLayoutSnapshot();
            this.#applyLayoutFromSnapshot(layoutSnapshot);
          }
        }, 100);
        
        this.dispatchEvent(new CustomEvent('header:visibility-change', {
          detail: { visibility: 'visible' },
          bubbles: true
        }));
      }
    }, this.#state.animationDuration);
  }
  
  #updateStateAttributes() {
    const roundedScroll = Math.round(this.#state.scrollPosition);
    const isScrolled = this.#state.scrollPosition > 0;
    this.#setAttributeIfChanged('data-visibility', this.#state.visibility);
    this.#setAttributeIfChanged('data-scroll-direction', this.#state.scrollDirection);
    this.#setAttributeIfChanged('data-threshold-passed', String(this.#state.thresholdPassed));
    if (this.#lastRoundedScrollPosition !== roundedScroll) {
      this.#setAttributeIfChanged('data-scroll-position', String(roundedScroll));
      this.#setAttributeIfChanged('data-scrolled', String(isScrolled));
      this.#lastRoundedScrollPosition = roundedScroll;
    }
    
    // Update HTML tag with header visibility state
    const isVisible = this.#state.visibility === 'visible' || this.#state.visibility === 'showing';
    const htmlElement = document.documentElement;
    
    if (isVisible) {
      if (htmlElement.getAttribute('data-header-visible') !== 'true') {
        htmlElement.setAttribute('data-header-visible', 'true');
      }
    } else {
      if (htmlElement.hasAttribute('data-header-visible')) {
        htmlElement.removeAttribute('data-header-visible');
      }
    }
    
    // Set scroll range
    const scrollPosition = this.#state.scrollPosition;
    let scrollRangeName = 'top';
    
    if (scrollPosition < 50) {
      scrollRangeName = 'top';
    } else if (scrollPosition < 150) {
      scrollRangeName = 'near-top';
    } else if (scrollPosition < 1000) {
      scrollRangeName = 'mid';
    } else {
      scrollRangeName = 'far';
    }
    
    if (this.#lastScrollRange !== scrollRangeName) {
      this.#setAttributeIfChanged('data-scroll-range', scrollRangeName);
      if (htmlElement.getAttribute('data-scroll-range') !== scrollRangeName) {
        htmlElement.setAttribute('data-scroll-range', scrollRangeName);
      }
      this.#lastScrollRange = scrollRangeName;
    }

    const stateFingerprint = [
      this.#state.visibility,
      this.#state.scrollDirection,
      String(this.#state.thresholdPassed),
      String(this.#state.isTransitioning),
      scrollRangeName,
    ].join('|');

    if (stateFingerprint !== this.#lastStateFingerprint) {
      this.#lastStateFingerprint = stateFingerprint;
      this.dispatchEvent(new CustomEvent('header:state-change', {
        detail: {
          visibility: this.#state.visibility,
          scrollDirection: this.#state.scrollDirection,
          thresholdPassed: this.#state.thresholdPassed,
          scrollPosition: this.#state.scrollPosition,
          isTransitioning: this.#state.isTransitioning
        },
        bubbles: true
      }));
    }
  }

  #setAttributeIfChanged(name, value) {
    if (this.getAttribute(name) === value) return;
    this.setAttribute(name, value);
  }
  
  // Utility methods
  #throttle(func, delay) {
    let lastCall = 0;
    let timeout = null;
    
    return (...args) => {
      const now = Date.now();
      const timeSinceLastCall = now - lastCall;
      
      if (timeSinceLastCall >= delay) {
        lastCall = now;
        func.apply(this, args);
      } else {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          lastCall = Date.now();
          func.apply(this, args);
        }, delay - timeSinceLastCall);
      }
    };
  }
  
  #debounce(func, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }
  
  // Static utility methods
  /**
   * Find header element by selector
   * @param {string} selector - CSS selector
   * @returns {HeaderElement|null}
   */
  static find(selector) {
    return document.querySelector(selector);
  }
  
  /**
   * Get all header elements
   * @returns {NodeList}
   */
  static findAll() {
    return document.querySelectorAll('header-element');
  }
}

// Register custom element
if (!customElements.get("header-element")) {
  customElements.define("header-element", HeaderElement);
}

/**
 * LocalizationForm - Handles language and country selection
 * 
 * Manages form submission for changing locale settings with
 * accessible dropdown interactions.
 * 
 * @fires localization:change - When locale is changed
 * 
 * @example
 * <localization-form>
 *   <form>
 *     <input name="language_code" type="hidden">
 *     <a data-value="en">English</a>
 *     <a data-value="fr">Français</a>
 *   </form>
 * </localization-form>
 */
class LocalizationForm extends HTMLElement {
  // Private fields
  #isConnected = false;
  #form = null;
  #input = null;
  #links = [];
  #abortController = null;
  
  constructor() {
    super();
  }
  
  connectedCallback() {
    if (this.#isConnected) return;
    
    try {
      this.#setupDOM();
      this.#setupEventListeners();
      this.#isConnected = true;
    } catch (error) {
      // Error in connectedCallback
    }
  }
  
  disconnectedCallback() {
    if (!this.#isConnected) return;
    
    try {
      this.#cleanup();
      this.#isConnected = false;
    } catch (error) {
      // Error in disconnectedCallback
    }
  }
  
  // Private methods
  #setupDOM() {
    this.#form = this.querySelector("form");
    this.#input = this.querySelector(
      'input[name="language_code"], input[name="locale_code"], input[name="country_code"]'
    );
    this.#links = Array.from(this.querySelectorAll("a[data-value]"));
  }
  
  #setupEventListeners() {
    if (!this.#links.length) return;
    
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    
    this.#links.forEach(link => {
      link.addEventListener("click", this.#handleItemClick.bind(this), { signal });
    });
  }
  
  #cleanup() {
    this.#abortController?.abort();
    this.#abortController = null;
  }
  
  #handleItemClick(event) {
    event.preventDefault();
    
    if (!this.#input || !this.#form) return;
    
    try {
      const value = event.currentTarget.dataset.value;
      this.#input.value = value;
      
      this.dispatchEvent(new CustomEvent('localization:change', {
        detail: { value, form: this.#form },
        bubbles: true,
        cancelable: true
      }));
      
      this.#form.submit();
    } catch (error) {
      // Error handling click
    }
  }
}

// Register custom element
if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}

/**
 * CountryStateProvinceSelector - Dynamic location-based dealer selector
 * 
 * Provides a multi-level selector for country, state/province with
 * dynamic dealer results display based on selection.
 * 
 * @fires dealer:selected - When a dealer location is selected
 * @fires dealer:cleared - When dealer results are cleared
 * 
 * @example
 * <country-state-province-selector data-dealers='[...]' data-inline="false">
 *   <select id="country">...</select>
 *   <select id="states">...</select>
 *   <select id="province">...</select>
 *   <div id="dealer-results"></div>
 * </country-state-province-selector>
 */
class CountryStateProvinceSelector extends HTMLElement {
  // Private fields
  #isConnected = false;
  #abortController = null;
  
  // DOM elements
  #countrySelect = null;
  #stateSelect = null;
  #provinceSelect = null;
  #dealerBox = null;
  
  // Data
  #cleanedDealers = [];
  #rawDealers = [];
  
  // Event handlers
  #countryChangeHandler = null;
  #stateChangeHandler = null;
  
  constructor() {
    super();
    
    // Bind event handlers
    this.#countryChangeHandler = this.#handleCountryChange.bind(this);
    this.#stateChangeHandler = this.#handleStateProvinceChange.bind(this);
  }
  
  connectedCallback() {
    if (this.#isConnected) return;
    
    try {
      this.#setupDOM();
      this.#processDealerData();
      this.#setupEventListeners();
      this.#initializeSelectors();
      
      this.#isConnected = true;
      
      this.dispatchEvent(new CustomEvent('selector:ready', {
        detail: { selector: this },
        bubbles: true
      }));
    } catch (error) {
      // Error in connectedCallback
    }
  }
  
  disconnectedCallback() {
    if (!this.#isConnected) return;
    
    try {
      this.#cleanup();
      this.#isConnected = false;
    } catch (error) {
      // Error in disconnectedCallback
    }
  }
  
  // Private methods
  #setupDOM() {
    this.#countrySelect = this.querySelector('#country');
    this.#stateSelect = this.querySelector('#states');
    this.#provinceSelect = this.querySelector('#province');
    this.#dealerBox = this.querySelector('#dealer-results');
  }
  
  #processDealerData() {
    try {
      const dealersData = this.dataset.dealers;
      if (!dealersData) return;
      
      this.#rawDealers = JSON.parse(dealersData);
      
      this.#cleanedDealers = this.#rawDealers.map(dealer => ({
        address: dealer.address?.replaceAll('\\n', '<br>') || '',
        contact_info: dealer.contact_info?.replaceAll('\\n', '<br>') || '',
        country: this.#normalize(dealer.country),
        google_maps: dealer.google_maps?.replaceAll('\\/', '/') || '',
        name: dealer.name || '',
        state: this.#normalize(dealer.state),
        logo: dealer.logo || ''
      }));
    } catch (error) {
      this.#cleanedDealers = [];
    }
  }
  
  #setupEventListeners() {
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    
    this.#countrySelect?.addEventListener('change', this.#countryChangeHandler, { signal });
    this.#stateSelect?.addEventListener('change', this.#stateChangeHandler, { signal });
    this.#provinceSelect?.addEventListener('change', this.#stateChangeHandler, { signal });
  }
  
  #cleanup() {
    this.#abortController?.abort();
    this.#abortController = null;
    this.#cleanedDealers = [];
    this.#rawDealers = [];
  }
  
  #initializeSelectors() {
    this.#hideStateProvinceSelectors();
    this.#clearDealerResults();
  }
  
  #handleCountryChange() {
    try {
      this.#hideStateProvinceSelectors();
      
      const countryValue = this.#countrySelect?.value;
      
      if (countryValue === 'us') {
        this.#showStateSelector();
      } else if (countryValue === 'ca') {
        this.#showProvinceSelector();
      } else {
        this.#showCountryDealers();
      }
    } catch (error) {
      // Error handling country change
    }
  }
  
  #handleStateProvinceChange() {
    try {
      const selectedCountry = this.#getSelectedCountryText();
      const regionSelect = this.#countrySelect?.value === 'us' 
        ? this.#stateSelect 
        : this.#provinceSelect;
      const selectedRegion = this.#normalize(regionSelect?.value || '');
      
      const matching = this.#cleanedDealers.filter(d =>
        d.country === selectedCountry &&
        d.state.includes(selectedRegion)
      );
      
      this.#updateDealerResults(matching);
    } catch (error) {
      // Error handling state/province change
    }
  }
  
  #showStateSelector() {
    if (!this.#stateSelect) return;
    
    this.#stateSelect.style.display = 'block';
    this.#stateSelect.disabled = false;
    
    const icon = this.#stateSelect.parentElement?.querySelector('.pointer-events-none.absolute.right-4');
    if (icon) icon.style.display = 'block';
    
    if (this.#stateSelect.value) {
      this.#handleStateProvinceChange();
    } else {
      this.#clearDealerResults();
    }
  }
  
  #showProvinceSelector() {
    if (!this.#provinceSelect) return;
    
    this.#provinceSelect.style.display = 'block';
    this.#provinceSelect.disabled = false;
    
    const icon = this.#provinceSelect.parentElement?.querySelector('.pointer-events-none.absolute.right-4');
    if (icon) icon.style.display = 'block';
    
    if (this.#provinceSelect.value) {
      this.#handleStateProvinceChange();
    } else {
      this.#clearDealerResults();
    }
  }
  
  #showCountryDealers() {
    const selectedCountry = this.#getSelectedCountryText();
    const matching = this.#cleanedDealers.filter(d => d.country === selectedCountry);
    this.#updateDealerResults(matching);
  }
  
  #getSelectedCountryText() {
    if (!this.#countrySelect) return '';
    
    const selectedOption = this.#countrySelect.options[this.#countrySelect.selectedIndex];
    return this.#normalize(selectedOption?.text || '');
  }
  
  #updateDealerResults(matchingDealers) {
    if (!this.#dealerBox) return;
    
    this.#dealerBox.innerHTML = '';
    this.#dealerBox.style.display = '';
    
    if (matchingDealers && matchingDealers.length > 0) {
      const html = matchingDealers.map(dealer => this.#createDealerCard(dealer)).join('');
      this.#dealerBox.innerHTML = html;
      
      this.dispatchEvent(new CustomEvent('dealer:selected', {
        detail: { dealers: matchingDealers },
        bubbles: true
      }));
    } else {
      this.#showHQFallback();
    }
  }
  
  #createDealerCard(dealer) {
    const cardClass = this.dataset.inline === 'false' 
      ? 'p-4 lg:p-12 lg:w-1/3 w-full' 
      : '';
    
    return `
      <div class="uppercase bg-beige ${cardClass}">
        ${dealer.logo ? `
          <img src="${dealer.logo}" 
               alt="${dealer.name} logo" 
               class="w-48 object-contain mb-6" 
               loading="lazy" 
               decoding="async" />
        ` : ''}
        <h4 class="font-bold mb-2">${dealer.name}</h4>
        <p>${dealer.address}</p>
        <h4 class="font-bold mt-4 mb-2">Contact</h4>
        <p>${dealer.contact_info}</p>
        ${dealer.google_maps ? `
          <a href="${dealer.google_maps}" 
             class="underline mt-2 block"
             target="_blank"
             rel="noopener noreferrer">
            Open Google Maps
          </a>
        ` : ''}
      </div>
    `;
  }
  
  #clearDealerResults() {
    if (!this.#dealerBox) return;
    
    this.#dealerBox.innerHTML = '';
    this.#dealerBox.style.display = 'none';
    
    this.dispatchEvent(new CustomEvent('dealer:cleared', {
      bubbles: true
    }));
  }
  
  #hideStateProvinceSelectors() {
    [this.#stateSelect, this.#provinceSelect].forEach(selector => {
      if (!selector) return;
      
      selector.style.display = 'none';
      selector.disabled = true;
      
      const icon = selector.parentElement?.querySelector('.pointer-events-none.absolute.right-4');
      if (icon) {
        icon.style.display = 'none';
      }
    });
  }
  
  #showHQFallback() {
    const hq = this.#cleanedDealers.find(d => 
      d.name.toLowerCase().includes('hq')
    );
    
    if (hq) {
      this.#dealerBox.innerHTML = this.#createDealerCard(hq);
    } else {
      const dealerMsg = (window.theme?.translations?.no_dealers_found) || 'No dealers found.';
      this.#dealerBox.innerHTML = '';
      const p = document.createElement('p');
      p.textContent = dealerMsg;
      this.#dealerBox.appendChild(p);
    }
  }
  
  #normalize(str) {
    // This function should be implemented based on your normalization needs
    // For now, returning lowercase trimmed string
    return (str || '').toLowerCase().trim();
  }
  
  // Static utility methods
  /**
   * Find selector by ID
   * @param {string} id - Element ID
   * @returns {CountryStateProvinceSelector|null}
   */
  static find(id) {
    return document.getElementById(id);
  }
}

// Register custom element
if (!customElements.get('country-state-province-selector')) {
  customElements.define('country-state-province-selector', CountryStateProvinceSelector);
}

/**
 * Opt-in debug overlay showing current scrollY (px).
 * Enabled via `?debug_scroll=1` (or `true`) or `localStorage.debug_scroll=1`.
 * @private
 */
const setupScrollDebugOverlay = () => {
  try {
    const url = new URL(window.location.href);
    const param = (url.searchParams.get('debug_scroll') || '').toLowerCase();
    const enabledFromParam = param === '1' || param === 'true' || param === 'yes' || param === 'on';
    const enabledFromStorage = (window.localStorage?.getItem('debug_scroll') || '') === '1';
    const isEnabled = enabledFromParam || enabledFromStorage;

    if (!isEnabled) return;
    if (enabledFromParam) {
      try {
        window.localStorage?.setItem('debug_scroll', '1');
      } catch {
        // Ignore storage failures (private mode, blocked, etc.)
      }
    }

    const existing = document.getElementById('em-debug-scroll');
    if (existing) return;

    const el = document.createElement('div');
    el.id = 'em-debug-scroll';
    el.setAttribute('aria-hidden', 'true');
    el.style.cssText = [
      'position:fixed',
      'top:12px',
      'right:12px',
      'z-index:2147483647',
      'pointer-events:none',
      'user-select:none',
      'font:12px/1.2 ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
      'padding:6px 8px',
      'border-radius:8px',
      'background:rgba(0,0,0,0.72)',
      'color:#fff',
      'backdrop-filter:saturate(180%) blur(10px)',
      '-webkit-backdrop-filter:saturate(180%) blur(10px)',
      'box-shadow:0 6px 22px rgba(0,0,0,0.35)'
    ].join(';');

    const abortController = new AbortController();
    const { signal } = abortController;

    let rafId = null;
    const update = () => {
      rafId = null;
      const y = Math.round(window.scrollY || document.documentElement.scrollTop || 0);
      el.textContent = `${y}px`;
    };

    const scheduleUpdate = () => {
      if (rafId != null) return;
      rafId = requestAnimationFrame(update);
    };

    const cleanup = () => {
      abortController.abort();
      if (rafId != null) cancelAnimationFrame(rafId);
      el.remove();
    };

    window.addEventListener('scroll', scheduleUpdate, { passive: true, signal });
    window.addEventListener('resize', scheduleUpdate, { passive: true, signal });
    window.addEventListener('pagehide', cleanup, { signal });

    document.body?.appendChild(el);
    update();
  } catch {
    // Debug-only feature; failures should be silent
  }
};

setupScrollDebugOverlay();

// Module exports
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    HeaderDrawer,
    HeaderElement,
    LocalizationForm,
    CountryStateProvinceSelector
  };
}
})();
(function () {
/**
 * Dynamic section loader for Shopify themes
 * 
 * Handles lazy loading, content replacement, and URL-based updates
 * for Shopify theme sections with performance optimizations.
 * 
 * @example
 * <electric-section 
 *   data-section-id="collection-main"
 *   data-url="/collections/all"
 *   data-animate="true"
 *   data-onload="true"
 *   data-fire-event="section-updated">
 * </electric-section>
 * 
 * @example
 * // With custom event trigger
 * <electric-section 
 *   data-section-id="product-grid"
 *   data-load-on-event="filter-changed"
 *   data-animate="false">
 * </electric-section>
 * 
 * @example
 * // Prefetch and fetch events
 * const section = document.querySelector('electric-section');
 * 
 * // Prefetch content without replacing
 * section.dispatchEvent(new CustomEvent('electric-section:prefetch', {
 *   detail: { url: '/collections/all?sort_by=price-ascending' }
 * }));
 * 
 * // Fetch and replace content immediately
 * section.dispatchEvent(new CustomEvent('electric-section:fetch', {
 *   detail: { url: '/collections/all?sort_by=price-descending' }
 * }));
 */
class ElectricSection extends HTMLElement {
  // Private fields
  #intersectionObserver = null;
  #isInitializing = true;
  #lastFetchedUrl = null;
  #debouncedCheckAndFetch = null;
  #temporaryData = new WeakMap();
  #connectionState = 'disconnected';
  #selectorCache = new Map();
  #fragmentCache = new Map();
  #cacheSize = 0;
  #maxCacheSize = 10; // Maximum number of cached fragments
  #performanceObserver = null;

  // Observed attributes for reactive updates
  static observedAttributes = [
    "data-url",
    "data-section-id",
    "data-selector",
    "data-animate",
    "data-fire-event",
    "data-onload",
    "data-load-on-event",
    "data-to-keep",
    "data-disable-pop-events"
  ];

  // Relevant URL parameters for change detection
  static #RELEVANT_PARAMS = new Set([
    "sort_by",
    "page",
    "q",
    "view",
    "limit"
  ]);

  constructor() {
    super();
    
    // Create debounced fetch function once
    this.#debouncedCheckAndFetch = this.#debounce(
      this.#checkAndFetch.bind(this),
      250
    );

    // Setup performance monitoring
    this.#setupPerformanceMonitoring();
  }

  /**
   * Called when element is connected to DOM
   * @private
   */
  connectedCallback() {
    if (this.#connectionState === 'connected') return;
    
    try {
      this.#setupInitialState();
      this.#addEventListeners();
      this.#restoreTemporaryData();
      
      // Setup lazy loading if enabled
      if (this.dataset.onload === "true") {
        this.#setupIntersectionObserver();
      }
      
      this.#isInitializing = false;
      this.#connectionState = 'connected';
      
      // Dispatch ready event
      this.#dispatchEvent('electric-section-ready', { 
        sectionId: this.#getSectionId() 
      });
      
    } catch (error) {
      this.#dispatchEvent('electric-section-error', { error });
    }
  }

  /**
   * Called when element is disconnected from DOM
   * @private
   */
  disconnectedCallback() {
    this.#connectionState = 'disconnected';
    this.#removeEventListeners();
    this.#removeIntersectionObserver();
    this.#removePerformanceObserver();
  }

  /**
   * Called when observed attributes change
   * @param {string} name - Attribute name
   * @param {string} oldValue - Previous value
   * @param {string} newValue - New value
   * @private
   */
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue || this.#isInitializing) return;

    switch (name) {
      case 'data-url':
        // Pass the new URL value to ensure we use the updated value
        this.#debouncedCheckAndFetch(false, true, newValue);
        break;
      case 'data-onload':
        if (newValue === "true") {
          this.#setupIntersectionObserver();
        } else {
          this.#removeIntersectionObserver();
        }
        break;
    }
  }

  /**
   * Setup intersection observer for lazy loading
   * @private
   */
  #setupIntersectionObserver() {
    if (this.#intersectionObserver) return;

    // Allow section to request earlier load via data-onload-root-margin (avoids empty screen)
    const rootMargin =
      this.dataset.onloadRootMargin?.trim() || "0px 0px 800px 0px";
    const options = {
      rootMargin,
      threshold: 0
    };

    this.#intersectionObserver = new IntersectionObserver(
      (entries) => this.#handleIntersection(entries),
      options
    );

    this.#intersectionObserver.observe(this);
  }

  /**
   * Handle intersection observer callback
   * @param {IntersectionObserverEntry[]} entries - Intersection entries
   * @private
   */
  #handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting && this.dataset.onload === "true") {
        queueMicrotask(() => this.#checkAndFetch(true));
        this.#removeIntersectionObserver();
      }
    });
  }

  /**
   * Remove intersection observer
   * @private
   */
  #removeIntersectionObserver() {
    if (this.#intersectionObserver) {
      this.#intersectionObserver.disconnect();
      this.#intersectionObserver = null;
    }
  }

  /**
   * Setup initial state and URL
   * @private
   */
  #setupInitialState() {
    const defaultUrl = new URL(window.location.href);
    defaultUrl.searchParams.delete("section_id");
    
    this.#lastFetchedUrl = this.dataset.url || window.location.href;
    
    // Set ARIA attributes for accessibility
    this.setAttribute('aria-live', 'polite');
    this.setAttribute('role', 'region');
  }

  /**
   * Add event listeners for navigation and custom events
   * @private
   */
  #addEventListeners() {
    if (this.dataset.disablePopEvents !== "true") {
      window.addEventListener("popstate", () => this.#handlePopState(), { passive: true });
    }
    
    if (this.dataset.loadOnEvent) {
      const onLoadEvent = () => {
        if (this.dataset.loadOnEvent === 'load') {
          this.dataset.url = this.#buildFetchUrl(window.location.href);
          this.#checkAndFetch(true);
        } else {
          this.#handlePopState();
        }
      };
      window.addEventListener(this.dataset.loadOnEvent, onLoadEvent, { passive: true });
      if (this.dataset.loadOnEvent === 'load' && document.readyState === 'complete') {
        queueMicrotask(onLoadEvent);
      }
    }

    // Listen for prefetch and fetch events
    this.addEventListener('electric-section:prefetch', (e) => this.#handlePrefetchEvent(e));
    this.addEventListener('electric-section:fetch', (e) => this.#handleFetchEvent(e));
  }

  /**
   * Remove event listeners
   * @private
   */
  #removeEventListeners() {
    // Note: We can't remove arrow function listeners, but this is acceptable
    // since the element will be garbage collected when disconnected
  }

  /**
   * Handle browser navigation events
   * @private
   */
  #handlePopState() {
    this.dataset.url = this.#buildFetchUrl(window.location.href);
    this.#debouncedCheckAndFetch(false);
  }

  /**
   * Handle prefetch event - fetch and cache content without replacing
   * @param {CustomEvent} event - Prefetch event
   * @private
   */
  #handlePrefetchEvent(event) {
    const url = this.#buildFetchUrl(event.detail?.url);
    if (!url) {
      return;
    }

    this.#prefetchContent(url);
  }

  /**
   * Handle fetch event - fetch and replace content immediately
   * @param {CustomEvent} event - Fetch event
   * @private
   */
  #handleFetchEvent(event) {
    const url = this.#buildFetchUrl(event.detail?.url);
    if (!url) {
      return;
    }

    // Update the data-url attribute to trigger normal fetch flow
    this.dataset.url = url;
  }

  /**
   * Check if content should be fetched and fetch if needed
   * @param {boolean} isInitialLoad - Whether this is the initial load
   * @param {boolean} isAttributeChange - Whether triggered by attribute change
   * @param {string} newUrl - New URL value (for attribute changes)
   * @returns {Promise<boolean>} Whether content was fetched
   * @private
   */
  async #checkAndFetch(isInitialLoad = false, isAttributeChange = false, newUrl = null) {
    const startTime = performance.now();
    
    try {
      // Use the new URL if provided (for attribute changes), otherwise use dataset.url
      const urlToUse = newUrl || this.dataset.url;
      const currentUrl = new URL(urlToUse, window.location.origin);
      const dataUrl = new URL(this.#lastFetchedUrl, window.location.origin);

      // Get all relevant parameters including dynamic filters
      const relevantParams = this.#getRelevantParameters(currentUrl, dataUrl);
      
      // Always fetch on attribute change, otherwise check if it's initial load
      let shouldFetch = isAttributeChange || isInitialLoad;

      if (shouldFetch) {
        const fetchUrl = this.#buildFetchUrl(urlToUse);

        if (fetchUrl !== this.#lastFetchedUrl) {
          this.#lastFetchedUrl = fetchUrl;

          const success = await this.#fetchAndReplaceContent(fetchUrl, isAttributeChange);
          
          return success;
        }
      }
      
      return false;
    } catch (error) {
      this.#dispatchEvent('electric-section-error', { error });
      return false;
    }
  }

  /**
   * Get all relevant URL parameters including dynamic filters
   * @param {URL} currentUrl - Current URL
   * @param {URL} dataUrl - Data URL
   * @returns {Set<string>} Set of relevant parameter names
   * @private
   */
  #getRelevantParameters(currentUrl, dataUrl) {
    const params = new Set(ElectricSection.#RELEVANT_PARAMS);
    
    // Add dynamic filter parameters
    [currentUrl, dataUrl].forEach(url => {
      Array.from(url.searchParams.keys())
        .filter(key => key.startsWith('filter.'))
        .forEach(key => params.add(key));
    });
    
    return params;
  }

  /**
   * Update URL parameters with new values
   * @param {URL} url - URL to update
   * @param {string} param - Parameter name
   * @param {string[]} values - New values
   * @private
   */
  #updateUrlParameters(url, param, values) {
    url.searchParams.delete(param);
    values.forEach(value => url.searchParams.append(param, value));
  }

  /**
   * Build fetch URL with section ID
   * @param {string} url - Base URL
   * @returns {string} Fetch URL with section ID
   * @private
   */
  #buildFetchUrl(url) {
    const fetchUrl = new URL(url, window.location.origin);
    const sectionId = this.#getSectionId();
    if (sectionId) {
      fetchUrl.searchParams.set("section_id", sectionId);
    }
    return fetchUrl.toString();
  }

  /**
   * Get the section ID from the closest section element or data attribute
   * @returns {string|null} Section ID or null if not found
   * @private
   */
  #getSectionId() {
    // First check if we have a data-section-id attribute
    if (this.dataset.sectionId) {
      return this.dataset.sectionId;
    }
    
    // Find the closest section element
    const sectionElement = this.closest('section');
    if (sectionElement) {
      // Try to get the section ID from the section element's ID
      const sectionId = sectionElement.id;
      if (sectionId && sectionId.startsWith('shopify-section-')) {
        return sectionId.replace('shopify-section-', '');
      }
      
      // Try to get from data-section-id attribute on the section
      if (sectionElement.dataset.sectionId) {
        return sectionElement.dataset.sectionId;
      }
    }
    
    return null;
  }

  /**
   * Get optimized selector for section ID
   * @param {string} sectionId - Section ID
   * @returns {string} Optimized selector
   * @private
   */
  #getOptimizedSelector(sectionId) {
    if (!this.#selectorCache.has(sectionId)) {
      // Try selectors in order of specificity and performance
      const selectors = [
        `#shopify-section-${sectionId}`, // Most specific, fastest
        `[data-section-id="${sectionId}"]`,
        `[data-section="${sectionId}"]`
      ];
      
      // Cache the first working selector
      for (const selector of selectors) {
        if (document.querySelector(selector)) {
          this.#selectorCache.set(sectionId, selector);
          break;
        }
      }
      
      // Fallback to first selector if none found
      if (!this.#selectorCache.has(sectionId)) {
        this.#selectorCache.set(sectionId, selectors[0]);
      }
    }
    
    return this.#selectorCache.get(sectionId);
  }

  /**
   * Store temporary data before content replacement
   * @private
   */
  #storeTemporaryData() {
    if (!this.dataset.toKeep) return;
    
    const dataToKeep = {};
    this.dataset.toKeep.split(",").forEach(key => {
      dataToKeep[key.trim()] = this.dataset[key.trim()];
    });
    
    this.#temporaryData.set(this, dataToKeep);
    
    // Auto-cleanup after 3 seconds
    setTimeout(() => {
      this.#temporaryData.delete(this);
    }, 3000);
  }

  /**
   * Restore temporary data after content replacement
   * @private
   */
  #restoreTemporaryData() {
    const savedData = this.#temporaryData.get(this);
    if (!savedData) return;
    
    Object.entries(savedData).forEach(([key, value]) => {
      this.dataset[key] = value;
    });
  }

  /**
   * Fetch and replace content
   * @param {string} url - URL to fetch from
   * @param {boolean} isAttributeChange - Whether triggered by attribute change
   * @returns {Promise<boolean>} Whether operation was successful
   * @private
   */
  async #fetchAndReplaceContent(url, isAttributeChange = false) {
    const startTime = performance.now();
    
    try {
      this.setAttribute('aria-busy', 'true');
      this.#storeTemporaryData();
      
      let newContent = this.#getCachedFragment(url);
      
      if (!newContent) {
        const response = await this.#fetchWithRetry(url);
        const html = await response.text();
        newContent = this.#parseHTML(html);
        
        if (newContent === null) {
          this.remove();
          return false;
        }
        
        // Cache the parsed fragment
        this.#cacheFragment(url, newContent);
      }

      // Replace content with or without animation
      if (this.dataset.animate !== "false") {
        await this.#animateTransition(newContent);
      } else {
        this.#replaceContent(newContent);
      }

      this.#fireCustomEvent(newContent);
      
      const duration = performance.now() - startTime;
      this.#dispatchEvent('electric-section-updated', { 
        url, 
        duration,
        isAttributeChange 
      });
      
      return true;
    } catch (error) {
      this.#dispatchEvent('electric-section-error', { error });
      return false;
    } finally {
      this.removeAttribute('aria-busy');
    }
  }

  /**
   * Get cached fragment if available
   * @param {string} url - URL to check cache for
   * @returns {Element|null} Cached fragment or null
   * @private
   */
  #getCachedFragment(url) {
    const cached = this.#fragmentCache.get(url);
    if (cached) {
      // Move to end for LRU behavior
      this.#fragmentCache.delete(url);
      this.#fragmentCache.set(url, cached);
      return cached.cloneNode(true);
    }
    return null;
  }

  /**
   * Cache fragment with LRU behavior
   * @param {string} url - URL to cache
   * @param {Element} fragment - Fragment to cache
   * @private
   */
  #cacheFragment(url, fragment) {
    // Remove oldest entry if cache is full
    if (this.#cacheSize >= this.#maxCacheSize) {
      const firstKey = this.#fragmentCache.keys().next().value;
      this.#fragmentCache.delete(firstKey);
      this.#cacheSize--;
    }
    
    this.#fragmentCache.set(url, fragment.cloneNode(true));
    this.#cacheSize++;
    
    // Auto-cleanup after 5 minutes
    setTimeout(() => {
      if (this.#fragmentCache.has(url)) {
        this.#fragmentCache.delete(url);
        this.#cacheSize--;
      }
    }, 300000);
  }

  /**
   * Prefetch content without replacing current content
   * @param {string} url - URL to prefetch
   * @private
   */
  async #prefetchContent(url) {
    try {
      // Check if already cached
      if (this.#getCachedFragment(url)) {
        return;
      }

      // Fetch and cache the content
      const response = await this.#fetchWithRetry(url);
      const html = await response.text();

      // Validate the content can be parsed
      const parsed = this.#parseHTML(html);
      if (parsed) {
        this.#cacheFragment(url, parsed);
        
        // Dispatch prefetch success event
        this.#dispatchEvent('electric-section:prefetch-success', { 
          url,
          cached: true 
        });
      } else {
        throw new Error('Failed to parse prefetched content');
      }
    } catch (error) {
      this.#dispatchEvent('electric-section:prefetch-error', { 
        url, 
        error: error.message 
      });
    }
  }

  /**
   * Fetch with retry logic and exponential backoff
   * @param {string} url - URL to fetch
   * @param {number} retries - Number of retry attempts
   * @returns {Promise<Response>} Fetch response
   * @private
   */
  async #fetchWithRetry(url, retries = 3) {
    for (let i = 0; i < retries; i++) {
      try {
        const response = await fetch(url, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        return response;
      } catch (error) {
        if (i === retries - 1) throw error;
        
        const delay = 1000 * Math.pow(2, i);
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
  }

  /**
   * Parse HTML and extract section content with optimized selector
   * @param {string} html - HTML string to parse
   * @returns {Element|null} Parsed section element or null
   * @private
   */
  #parseHTML(html) {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      
      // Check for parsing errors
      const parseError = doc.querySelector('parsererror');
      if (parseError) {
        throw new Error('HTML parsing failed');
      }
      
      const sectionId = this.#getSectionId();
      if (!sectionId) {
        return null;
      }
      
      // Fetched HTML from Section Rendering API always uses id="shopify-section-{section_id}".
      // Do not use #getOptimizedSelector here: that selector is for the current document (e.g.
      // [data-section-id] on <electric-section>); the API response has a <section id="...">.
      const sectionEl = doc.querySelector(`#shopify-section-${sectionId}`);
      if (!sectionEl) {
        return null;
      }
      // Section response includes full section (heading, tabs, panel). Use only the panel
      // so we replace just the product grid. Custom elements may not match in DOMParser
      // output, so use role="tabpanel" which the section template sets on the panel.
      const innerPanel =
        sectionEl.querySelector('[role="tabpanel"]') ||
        sectionEl.querySelector('electric-section') ||
        sectionEl.querySelector(`[data-section-id="${sectionId}"]`);
      return innerPanel || sectionEl;
    } catch (error) {
      return null;
    }
  }

  /**
   * Animate content transition using CSS transitions
   * @param {Element} newContent - New content to animate in
   * @private
   */
  async #animateTransition(newContent) {
    try {
      // Add transition class
      this.classList.add('electric-section-transitioning');
      
      // Fade out current content
      this.style.opacity = '0';
      this.style.transition = 'opacity 150ms ease-out';
      
      // Wait for fade out
      await new Promise(resolve => setTimeout(resolve, 150));
      
      this.#replaceContent(newContent);
      
      // Fade in new content
      this.style.transition = 'opacity 150ms ease-in';
      this.style.opacity = '1';
      
      // Clean up after animation
      setTimeout(() => {
        this.classList.remove('electric-section-transitioning');
        this.style.transition = '';
        this.style.opacity = '';
      }, 150);
      
    } catch (error) {
      // Fallback to immediate replacement
      this.#replaceContent(newContent);
    }
  }

  /**
   * Replace current content with new content using DocumentFragment
   * @param {Element} newContent - New content element
   * @private
   */
  #replaceContent(newContent) {
    // Preserve any temporary data
    const tempData = this.#temporaryData.get(this);
    
    // Use DocumentFragment for better performance
    const fragment = document.createDocumentFragment();
    while (newContent.firstChild) {
      fragment.appendChild(newContent.firstChild);
    }
    
    // Clear and replace content
    this.innerHTML = '';
    this.appendChild(fragment);
    
    // Restore temporary data to new element
    if (tempData) {
      this.#temporaryData.set(this, tempData);
    }
  }

  /**
   * Fire custom event after content update
   * @param {Element} newContent - New content element
   * @private
   */
  #fireCustomEvent(newContent) {
    if (this.dataset.fireEvent) {
      const event = new CustomEvent(this.dataset.fireEvent, {
        bubbles: true,
        detail: {
          source: this.#getSectionId(),
          found: newContent !== null,
          url: this.dataset.url
        }
      });
      this.dispatchEvent(event);
    }
  }

  /**
   * Dispatch internal event
   * @param {string} eventName - Event name
   * @param {object} detail - Event detail
   * @private
   */
  #dispatchEvent(eventName, detail = {}) {
    const event = new CustomEvent(eventName, {
      bubbles: true,
      detail: {
        sectionId: this.#getSectionId(),
        ...detail
      }
    });
    this.dispatchEvent(event);
  }

  /**
   * Setup performance monitoring
   * @private
   */
  #setupPerformanceMonitoring() {
    if ('PerformanceObserver' in window) {
      try {
        this.#performanceObserver = new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) {
            if (entry.entryType === 'measure' && entry.name.includes('electric-section')) {
              if (entry.duration > 100) {
                // Slow operation detected
              }
            }
          }
        });
        
        this.#performanceObserver.observe({ entryTypes: ['measure'] });
      } catch (error) {
        // Performance monitoring not available
      }
    }
  }

  /**
   * Remove performance observer
   * @private
   */
  #removePerformanceObserver() {
    if (this.#performanceObserver) {
      this.#performanceObserver.disconnect();
      this.#performanceObserver = null;
    }
  }

  /**
   * Debounce function to limit execution frequency
   * @param {Function} func - Function to debounce
   * @param {number} wait - Wait time in milliseconds
   * @returns {Function} Debounced function
   * @private
   */
  #debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Static utility methods for external use

  /**
   * Find all electric-section elements in the document
   * @param {string} sectionId - Optional section ID to filter by
   * @returns {ElectricSection[]} Array of electric-section elements
   * @static
   */
  static findAll(sectionId = null) {
    const selector = sectionId 
      ? `electric-section[data-section-id="${sectionId}"]`
      : 'electric-section';
    return Array.from(document.querySelectorAll(selector));
  }

  /**
   * Find electric-section element by section ID
   * @param {string} sectionId - Section ID to find
   * @returns {ElectricSection|null} Electric section element or null
   * @static
   */
  static findBySectionId(sectionId) {
    return document.querySelector(`electric-section[data-section-id="${sectionId}"]`);
  }

  /**
   * Trigger content update for all electric-section elements
   * @param {string} sectionId - Optional section ID to filter by
   * @static
   */
  static async updateAll(sectionId = null) {
    const elements = this.findAll(sectionId);
    await Promise.all(elements.map(el => el.#checkAndFetch(false, true)));
  }

  /**
   * Clear all cached content
   * @static
   */
  static clearCache() {
    // Cache clearing not implemented in this version
  }

  /**
   * Prefetch content for a specific section
   * @param {string} sectionId - Section ID to prefetch for
   * @param {string} url - URL to prefetch
   * @static
   */
  static prefetch(sectionId, url) {
    const section = this.findBySectionId(sectionId);
    if (section) {
      section.dispatchEvent(new CustomEvent('electric-section:prefetch', {
        detail: { url },
        bubbles: false
      }));
    }
  }

  /**
   * Fetch and replace content for a specific section
   * @param {string} sectionId - Section ID to fetch for
   * @param {string} url - URL to fetch
   * @static
   */
  static fetch(sectionId, url) {
    const section = this.findBySectionId(sectionId);
    if (section) {
      section.dispatchEvent(new CustomEvent('electric-section:fetch', {
        detail: { url },
        bubbles: false
      }));
    }
  }

  /**
   * Prefetch content for all sections
   * @param {string} url - URL to prefetch
   * @static
   */
  static prefetchAll(url) {
    const sections = this.findAll();
    sections.forEach(section => {
      section.dispatchEvent(new CustomEvent('electric-section:prefetch', {
        detail: { url },
        bubbles: false
      }));
    });
  }
}

// Register the custom element with safety check
if (!customElements.get('electric-section')) {
  customElements.define('electric-section', ElectricSection);
}

// Export for module usage
if (typeof module !== 'undefined' && module.exports) {
  module.exports = ElectricSection;
}
})();
(function () {
/**
 * ElectricPub - Simple Event Publisher
 * Dispatches custom events when buttons or radio buttons inside are interacted with
 *
 * data-prefetch-trigger: "hover" | "intersection"
 *   - hover (default): prefetch only on hover/focus/click
 *   - intersection: when the element enters the viewport, prefetch all tab URLs once
 *
 * @example
 * <electric-pub data-channel=".my-section" data-hover-event="prefetch" data-click-event="fetch">
 *   <button data-detail-url="/collections/all" data-detail-foo="bar">All Products</button>
 * </electric-pub>
 *
 * @example Prefetch all tabs when in view
 * <electric-pub data-prefetch-trigger="intersection" data-channel="#section electric-section" data-hover-event="electric-section:prefetch">
 *   <button role="tab" data-detail-url="/collections/a">Tab A</button>
 *   <button role="tab" data-detail-url="/collections/b">Tab B</button>
 * </electric-pub>
 */
class ElectricPub extends HTMLElement {
  #isConnected = false;
  #intersectionObserver = null;
  #prefetchFired = false;

  constructor() {
    super();
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  connectedCallback() {
    if (this.#isConnected) return;

    this.addEventListener('mouseover', this.handleMouseOver, { passive: true });
    this.addEventListener('click', this.handleClick, { passive: true });
    this.addEventListener('change', this.handleChange, { passive: true });
    this.addEventListener('focus', this.handleFocus, { passive: true });
    this.addEventListener('keydown', this.handleKeyDown);

    if (this.dataset.prefetchTrigger === 'intersection') {
      this.#setupIntersectionPrefetch();
    }

    this.#isConnected = true;
  }

  disconnectedCallback() {
    if (!this.#isConnected) return;

    this.removeEventListener('mouseover', this.handleMouseOver);
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('change', this.handleChange);
    this.removeEventListener('focus', this.handleFocus);
    this.removeEventListener('keydown', this.handleKeyDown);
    this.#removeIntersectionPrefetch();
    this.#isConnected = false;
  }

  /**
   * Prefetch all tab URLs by dispatching the hover-event (prefetch) to the channel target.
   * Runs once when the element enters the viewport if data-prefetch-trigger="intersection".
   * @private
   */
  #prefetchAllTabs() {
    if (this.#prefetchFired) return;
    const channel = this.dataset.channel;
    const prefetchEventName = this.dataset.hoverEvent;
    if (!channel || !prefetchEventName) return;

    const target = document.querySelector(channel);
    if (!target) return;

    const tabs = this.querySelectorAll('[role="tab"][data-detail-url]');
    for (const tab of tabs) {
      const url = tab.getAttribute('data-detail-url');
      if (url) {
        target.dispatchEvent(new CustomEvent(prefetchEventName, {
          detail: { url },
          bubbles: true,
          cancelable: true
        }));
      }
    }
    this.#prefetchFired = true;
  }

  #setupIntersectionPrefetch() {
    if (this.#intersectionObserver) return;
    this.#intersectionObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry?.isIntersecting) {
          this.#prefetchAllTabs();
          this.#intersectionObserver?.disconnect();
          this.#intersectionObserver = null;
        }
      },
      { root: null, rootMargin: '50px', threshold: 0 }
    );
    this.#intersectionObserver.observe(this);
  }

  #removeIntersectionPrefetch() {
    this.#intersectionObserver?.disconnect();
    this.#intersectionObserver = null;
  }

  handleMouseOver(event) {
    this.#processEvent(event, 'hoverEvent');
  }

  handleClick(event) {
    this.#processEvent(event, 'clickEvent');
  }

  handleChange(event) {
    this.#processEvent(event, 'changeEvent');
  }

  handleFocus(event) {
    this.#processEvent(event, 'focusEvent');
  }

  handleKeyDown(event) {
    const target = event.target;
    if (target.role !== 'tab') return;

    const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    const currentIndex = tabs.indexOf(target);

    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        event.preventDefault();
        const prevIndex = currentIndex === 0 ? tabs.length - 1 : currentIndex - 1;
        this.#activateTab(tabs[prevIndex]);
        break;
      case 'ArrowRight':
      case 'ArrowDown':
        event.preventDefault();
        const nextIndex = currentIndex === tabs.length - 1 ? 0 : currentIndex + 1;
        this.#activateTab(tabs[nextIndex]);
        break;
      case 'Home':
        event.preventDefault();
        this.#activateTab(tabs[0]);
        break;
      case 'End':
        event.preventDefault();
        this.#activateTab(tabs[tabs.length - 1]);
        break;
    }
  }

  #processEvent(event, eventTypeKey) {
    // Handle both button clicks and radio button changes
    const interactiveElement = event.target.closest('button') || event.target.closest('input[type="radio"]') || event.target.querySelector('input[type="radio"]');

    if (!interactiveElement) return;

    // For tab buttons, activate the tab on click
    if (eventTypeKey === 'clickEvent' && interactiveElement.role === 'tab') {
      this.#activateTab(interactiveElement);
    }

    const eventName = this.dataset[eventTypeKey];
    if (!eventName) return;

    const channel = this.dataset.channel;
    if (!channel) return;

    const targetElement = document.querySelector(channel);
    if (!targetElement) return;

    const detail = {};
    
    // Add all data-detail-* properties to the detail object
    Array.from(interactiveElement.attributes).forEach(attr => {
      if (attr.name.startsWith('data-detail-')) {
        const key = attr.name.replace('data-detail-', '');
        detail[key] = attr.value;
      }
    });

    // For radio buttons, add the checked state
    if (interactiveElement.type === 'radio') {
      detail.checked = interactiveElement.checked;
      detail.name = interactiveElement.name;
      detail.value = interactiveElement.value;
    }

    // For tab buttons, add active state
    if (interactiveElement.role === 'tab') {
      detail.active = interactiveElement.getAttribute('aria-selected') === 'true';
      detail.tabId = interactiveElement.id;
    }

    targetElement.dispatchEvent(new CustomEvent(eventName, {
      detail,
      bubbles: true,
      cancelable: true
    }));
  }

  #activateTab(tab) {
    // Deactivate all tabs
    const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    tabs.forEach(t => {
      t.setAttribute('aria-selected', 'false');
      t.setAttribute('tabindex', '-1');
      t.removeAttribute('data-active');
    });

    // Activate selected tab
    tab.setAttribute('aria-selected', 'true');
    tab.setAttribute('tabindex', '0');
    tab.setAttribute('data-active', 'true');
    tab.focus();
  }

  /**
   * Get all radio buttons within this component
   * @returns {NodeListOf<HTMLInputElement>}
   */
  static getRadioButtons(element) {
    return element.querySelectorAll('input[type="radio"]');
  }

  /**
   * Get the currently checked radio button
   * @returns {HTMLInputElement|null}
   */
  static getCheckedRadio(element) {
    return element.querySelector('input[type="radio"]:checked');
  }

  /**
   * Check a specific radio button by value
   * @param {string} value - The value of the radio button to check
   */
  static checkRadioByValue(element, value) {
    const radio = element.querySelector(`input[type="radio"][value="${value}"]`);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

if (!customElements.get('electric-pub')) {
  customElements.define('electric-pub', ElectricPub);
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = ElectricPub;
}
})();
(function () {
if (!customElements.get("electric-slider")) {
  class ElectricSlider extends HTMLElement {
    constructor() {
      super();
      this.state = {
        isDragging: false,
        wasDragged: false,
        dragThreshold: 10,
        pos: { left: 0, x: 0 },
        isTransitioning: false
      };
      
      this.observers = [];
      this.eventRegistry = [];
      this.items = [];
      /** Cached layout/style snapshot; invalidated on resize/content change to avoid reflows */
      this._valuesCache = null;
      this._isVisible = false;
      this._hasInitialized = false;

      // Pre-bind critical methods to avoid repeated binding
      this.dragMove = this.dragMove.bind(this);
      this.dragEnd = this.dragEnd.bind(this);
      this.resetScrollSnap = this.resetScrollSnap.bind(this);
    }

    connectedCallback() {
      try {
        this.cacheElements();
        this.setupObservers();
        this.attachEvents();
        
        // Reset drag state if drag is disabled
        if (this.dataset.drag === "false") {
          this.state.wasDragged = false;
          this.state.isDragging = false;
        }
      } catch (error) {
        // Initialization error
      }
    }

    disconnectedCallback() {
      this.detachEvents();
      this.disconnectObservers();
      
      // Clean up content update timeout
      if (this.contentUpdateTimeout) {
        clearTimeout(this.contentUpdateTimeout);
        this.contentUpdateTimeout = null;
      }
    }

    /**
     * Resolve a nav control for this slider. Prefer local nodes so modal clones
     * and duplicate ids cannot bind to another instance's arrows.
     * @param {string} selector
     * @returns {Element|null}
     * @private
     */
    #queryNavControl(selector) {
      return this.querySelector(selector) || document.querySelector(selector);
    }

    get els() {
      const target = this.dataset.id;
      return {
        slider: this.querySelector(".electric-slider__feed") || (() => { throw new Error("Slider feed not found"); })(),
        /** Prev/next + optional bar wrapper; hidden when the track is not scrollable */
        nav: this.querySelector(".electric-slider__nav"),
        prevBtn: this.#queryNavControl(`button[name="previous"][data-slider-target="${target}"], button[aria-label="previous"][data-slider-target="${target}"]`),
        nextBtn: this.#queryNavControl(`button[name="next"][data-slider-target="${target}"], button[aria-label="next"][data-slider-target="${target}"]`),
        upBtn: this.#queryNavControl(`button[name="up"][data-slider-target="${target}"]`),
        downBtn: this.#queryNavControl(`button[name="down"][data-slider-target="${target}"]`),
        gradient: this.querySelector("gradient-finish"),
        dots: this.querySelector('.electric-slider__dots'),
        thumbnails: this.querySelector('.electric-slider__thumbnails'),
        sliderBar: this.querySelector(`[data-slider-target="${target}"].electric-slider__bar`),
        verticalBarWrapper: this.querySelector(`.electric-slider__vertical-bar-wrapper[data-slider-target="${target}"]`),
      }
    }

    cacheElements() {
      this.els.prevWrapper = this.els.prevBtn?.parentElement === this ? 
        this.els.prevBtn : this.els.prevBtn?.parentElement;
        
      // Set cursor based on drag state
      if (this.els.sliderBar) {
        this.els.sliderBar.style.cursor = this.dataset.drag === "false" ? 'default' : 'grab';
      }
    }

    attachEvents() {
      const { slider, prevBtn, nextBtn, sliderBar } = this.els;
      
      // Common event handler setup
      // Only prevent clicks if drag is enabled AND was dragged
      if (this.dataset.drag !== "false") {
        this.addEvent(slider, 'click', e => this.state.wasDragged && (e.preventDefault(), e.stopPropagation(), this.state.wasDragged = false), true);
      }
      this.addEvent(slider, 'scroll', () => this.throttleUpdate(), { passive: true });
      this.addEvent(slider, 'scrollend', () => this.updateEdgeStates());
      
      // Drag events
      if (this.dataset.drag !== "false") {
        this.addEvent(slider, 'mousedown', e => this.startDrag(e));
      }
      
      // Navigation buttons
      this.addEvent(prevBtn, 'click', e => this.handleDirectionClick(e));
      this.addEvent(nextBtn, 'click', e => this.handleDirectionClick(e));
      
      // Vertical navigation buttons
      const { upBtn, downBtn } = this.els;
      this.addEvent(upBtn, 'click', e => this.handleVerticalDirectionClick(e));
      this.addEvent(downBtn, 'click', e => this.handleVerticalDirectionClick(e));
      
      // Slider bar - only enable if drag is enabled
      if (sliderBar && this.dataset.drag !== "false") {
        this.addEvent(sliderBar, 'mousedown', e => this.startBarDrag(e));
        this.addEvent(sliderBar, 'touchstart', e => this.startBarDrag(e), { passive: false });
      }
      
      // Listen for product fetch completion events
      this.addEvent(this, 'rebuy-products-loaded', () => this.handleProductsLoaded());
      this.addEvent(this, 'rebuy-shopify-products-loaded', () => this.handleProductsLoaded());
    }
    
    addEvent(element, eventType, handler, options = {}) {
      if (!element) return;
      element.addEventListener(eventType, handler, options);
      this.eventRegistry.push([element, eventType, handler, options]);
    }

    detachEvents() {
      this.eventRegistry.forEach(([element, eventType, handler, options]) => {
        element?.removeEventListener(eventType, handler, options);
      });
      this.eventRegistry = [];
      this.cleanUpGlobalEvents();
    }

    cleanUpGlobalEvents() {
      document.removeEventListener('mousemove', this.dragMove);
      document.removeEventListener('touchmove', this.dragMove);
      document.removeEventListener('mouseup', this.dragEnd);
      document.removeEventListener('mouseleave', this.dragEnd);
      document.removeEventListener('touchend', this.dragEnd);
      document.removeEventListener('touchcancel', this.dragEnd);
    }

    addGlobalEvents(isTouch) {
      const events = isTouch 
        ? [['touchmove', this.dragMove, {passive: false}], ['touchend', this.dragEnd], ['touchcancel', this.dragEnd]]
        : [['mousemove', this.dragMove], ['mouseup', this.dragEnd], ['mouseleave', this.dragEnd]];
      
      events.forEach(([event, handler, options]) => 
        document.addEventListener(event, handler, options));
    }

    setupObservers() {
      const { slider } = this.els;

      // Dynamic content changes
      if (this.dataset.dummy === "true") {
        this.addObserver(new MutationObserver(() => this.initSlider()), 
          slider, { childList: true });
      }
      
      // Content change observer - detects when items are added/removed
      const contentObserver = new MutationObserver((mutations) => {
        let shouldUpdate = false;
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            // Check if any added nodes are slider items
            const addedItems = Array.from(mutation.addedNodes).some(node => 
              node.nodeType === Node.ELEMENT_NODE && 
              (node.classList?.contains('electric-slider__item') || 
               node.querySelector?.('.electric-slider__item'))
            );
            if (addedItems) {
              shouldUpdate = true;
            }
          }
        });
        
        if (shouldUpdate) {
          // Debounce updates to avoid excessive calls
          clearTimeout(this.contentUpdateTimeout);
          this.contentUpdateTimeout = setTimeout(() => {
            this.handleContentChange();
          }, 100);
        }
      });
      
      this.addObserver(contentObserver, slider, { childList: true, subtree: true });
      
      // Resize observer for content dimension changes
      const resizeObserver = new ResizeObserver(() => {
        this._valuesCache = null;
        requestAnimationFrame(() => {
          this.handleContentChange();
        });
      });

      this.addObserver(resizeObserver, slider);
      
      // Visibility observer
      const visibilityObserver = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          this._isVisible = true;
          this.initSlider();
          this._hasInitialized = true;
          visibilityObserver.unobserve(slider);
        }
      });
      
      this.addObserver(visibilityObserver, slider);
      
      // Attribute observer for dynamic drag toggle
      const attributeObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-drag') {
            this.handleDragAttributeChange();
          }
        });
      });
      
      attributeObserver.observe(this, { attributes: true, attributeFilter: ['data-drag'] });
      this.observers.push({ observer: attributeObserver, target: this, options: { attributes: true, attributeFilter: ['data-drag'] } });
    }
    
    addObserver(observer, target, options = {}) {
      observer.observe(target, options);
      this.observers.push({ observer, target, options });
    }
    
    /**
     * Handle dynamic changes to the data-drag attribute
     * @private
     */
    handleDragAttributeChange() {
      const isDragDisabled = this.dataset.drag === "false";
      
      // Reset drag state when drag is disabled
      if (isDragDisabled) {
        this.state.wasDragged = false;
        this.state.isDragging = false;
        
        // Clean up any active drag operations
        this.cleanUpGlobalEvents();
      }
      
      // Update cursor style for slider bar
      if (this.els.sliderBar) {
        this.els.sliderBar.style.cursor = isDragDisabled ? 'default' : 'grab';
      }
    }
    
    /**
     * Handle product fetch completion events
     * Updates navigation visibility and edge states when products are dynamically loaded
     * @private
     */
    handleProductsLoaded() {
      // Wait a brief moment for DOM to update with new products
      requestAnimationFrame(() => {
        // Re-cache items if they've changed
        const { slider } = this.els;
        if (slider) {
          const newItems = slider.querySelector(".electric-slider__feed > *.contents") 
            ? this.querySelectorAll(".electric-slider__feed .contents > *") 
            : this.querySelectorAll(".electric-slider__feed > *");
          
          if (newItems.length !== this.items?.length) {
            this.handleContentChange();
          } else {
            // Just update UI state
            this.updateUI();
            this.updateEdgeStates();
          }
        }
      });
    }
    
    /**
     * Handle content changes (items added/removed)
     * @private
     */
    handleContentChange() {
      if (!this._isVisible && !this._hasInitialized) return;
      const { slider } = this.els;
      this._valuesCache = null;
      // Re-cache slider items
      this.items = slider.querySelector(".electric-slider__feed > *.contents") 
        ? this.querySelectorAll(".electric-slider__feed .contents > *") 
        : this.querySelectorAll(".electric-slider__feed > *");
      
      if (!this.items.length) return;
      
      // Wait for elements to be properly rendered before finding first/last
      requestAnimationFrame(() => {
        // Find first and last visible elements (don't mutate original array)
        const itemsArray = [...this.items];
        this.firstEl = itemsArray.map(item => this.#getFirstChildWithWidth(item)).find(el => el);
        this.lastEl = [...itemsArray].reverse().map(item => this.#getLastChildWithWidth(item)).find(el => el);
        
        // If elements still don't have width, wait a bit more
        if (!this.firstEl || !this.lastEl || this.firstEl.clientWidth === 0 || this.lastEl.clientWidth === 0) {
          setTimeout(() => {
            this.firstEl = itemsArray.map(item => this.#getFirstChildWithWidth(item)).find(el => el);
            this.lastEl = [...itemsArray].reverse().map(item => this.#getLastChildWithWidth(item)).find(el => el);
            
            if (this.firstEl && this.lastEl) {
              this.setupEdgeDetection();
              this.updateUI();
              this.updateEdgeStates();
            }
          }, 100);
          return;
        }
        this.setupEdgeDetection();
        
        // Update UI state
        this.updateUI();
        
        // Update edge states after content change
        this.updateEdgeStates();
      });
    }
    
    /**
     * Handle content resize events
     * @private
     */
    handleContentResize() {
      if (!this.items?.length) return;
      this._valuesCache = null;
      // Re-cache first and last elements in case they changed
      const itemsArray = [...this.items];
      this.firstEl = itemsArray.map(item => this.#getFirstChildWithWidth(item)).find(el => el);
      this.lastEl = [...itemsArray].reverse().map(item => this.#getLastChildWithWidth(item)).find(el => el);
      
      // Update UI state
      this.updateUI();
      
      // Update edge states after resize
      setTimeout(() => this.updateEdgeStates(), 50);
    }
    
    createObserver(callback, options = {}) {
      return new IntersectionObserver(callback, options);
    }
    
    disconnectObservers() {
      this.observers.forEach(({ observer }) => observer.disconnect());
      this.observers = [];
    }

    /**
     * Disconnect edge-detection observers created in setupEdgeDetection.
     * These are stored separately from this.observers.
     * @private
     */
    #disconnectEdgeObservers() {
      this.startObserver?.disconnect();
      this.endObserver?.disconnect();
      this.elementObserver?.disconnect();
      this.startObserver = null;
      this.endObserver = null;
      this.elementObserver = null;
    }

    /**
     * Re-initialize slider after variant radios replace innerHTML of
     * [data-variant-dynamic] electric-slider (e.g. quick ATC modal gallery).
     * Navigation buttons are replaced in DOM; listeners must be re-bound.
     */
    reinitializeAfterVariantUpdate() {
      try {
        this.detachEvents();
        this.disconnectObservers();
        this.#disconnectEdgeObservers();

        if (this.contentUpdateTimeout) {
          clearTimeout(this.contentUpdateTimeout);
          this.contentUpdateTimeout = null;
        }

        this._valuesCache = null;
        this.items = [];
        this.firstEl = null;
        this.lastEl = null;

        this.cacheElements();
        this.setupObservers();
        this.attachEvents();

        requestAnimationFrame(() => {
          const { slider } = this.els;
          if (slider) slider.scrollLeft = 0;
          this.initSlider();
        });
      } catch (error) {
        console.error('ElectricSlider: reinitializeAfterVariantUpdate failed', error);
      }
    }

    /**
     * Get the first child element with actual width, handling display: contents
     * @param {Element} element - Element to check
     * @returns {Element|null} First child with width > 0, or null
     * @private
     */
    #getFirstChildWithWidth(element) {
      if (!element) return null;
      
      // Check if element itself has width
      if (element.clientWidth > 0) return element;
      
      // Check if element has display: contents
      const computedStyle = window.getComputedStyle(element);
      if (computedStyle.display === 'contents') {
        // Recursively check first child
        const firstChild = element.firstElementChild;
        if (firstChild) {
          return this.#getFirstChildWithWidth(firstChild);
        }
      }
      
      return null;
    }

    /**
     * Get the last child element with actual width, handling display: contents
     * @param {Element} element - Element to check
     * @returns {Element|null} Last child with width > 0, or null
     * @private
     */
    #getLastChildWithWidth(element) {
      if (!element) return null;
      
      // Check if element itself has width
      if (element.clientWidth > 0) return element;
      
      // Check if element has display: contents
      const computedStyle = window.getComputedStyle(element);
      if (computedStyle.display === 'contents') {
        // Recursively check last child
        const lastChild = element.lastElementChild;
        if (lastChild) {
          return this.#getLastChildWithWidth(lastChild);
        }
      }
      
      return null;
    }

    initSlider() {
      const { slider, sliderBar, dots, thumbnails } = this.els;
      this._hasInitialized = true;

      // attempts to check if slider is loaded late
      if (!slider.clientWidth) {
        let attempts = 0;
        const maxAttempts = 10;
        
        const tryInit = () => {
          if (attempts >= maxAttempts) return;
          attempts++;
          
          setTimeout(() => {
            if (!slider.clientWidth) {
              tryInit();
            } else {
              this.initSlider();
            }
          }, 100);
        };
        
        tryInit();
        return;
      }

      
      // Cache slider items
      this.items = slider.querySelector(".electric-slider__feed > *.contents") 
        ? this.querySelectorAll(".electric-slider__feed .contents > *") 
        : this.querySelectorAll(".electric-slider__feed > *");
      
      if (!this.items.length) return;

      // Find first and last visible elements
      const itemsArray = [...this.items];
      this.firstEl = itemsArray.map(item => this.#getFirstChildWithWidth(item)).find(el => el);
      this.lastEl = [...itemsArray].reverse().map(item => this.#getLastChildWithWidth(item)).find(el => el);
      
      if (!this.firstEl || !this.lastEl) return;

      if (sliderBar) {
        sliderBar.parentElement.style.setProperty('--slider-bar-position', '0px');
        sliderBar.parentElement.style.setProperty('--slider-bar-clone-position', '0px');
      }
            
      this.currentIndex = 0;

      if (dots) {
        [...dots.children].forEach((dot, index) => {
          dot.dataset.active = index === 0 ? 'true' : 'false';
          this.addEvent(dot, 'click', () => this.navigateSlider(index, 'instant'));
        });
      }

      if (thumbnails) {
        [...thumbnails.children].forEach((thumbnail, index) => {
          thumbnail.dataset.active = index === 0 ? 'true' : 'false';
          this.addEvent(thumbnail, 'click', () => this.navigateSlider(index, 'instant'));
        });
      }

      // Set up carousel modes
      this.setupSliderMode();

      // Setup edge detection
      this.setupEdgeDetection();
      
      // Initialize UI state
      this.updateUI();
      
      // Ensure edge states are correct after initialization
      setTimeout(() => this.updateEdgeStates(), 100);
    }
    
    setupSliderMode() {
      if (this.dataset.carouselMode === "slide") {
        this.setupSlideMode();
      }
    }
    
    setupEdgeDetection() {
      const { slider } = this.els;
      this.#disconnectEdgeObservers();
      
      // Initial edge state update
      this.updateEdgeStates();
      
      // Re-check scroll position when the first/last slide crosses the viewport.
      // Button state comes from updateEdgeStates(), not intersectionRatio: a batched
      // callback's first entry is the earliest threshold, so returning to the first
      // slide was re-enabling the previous button.
      const options = { 
        threshold: [0, 0.1, 0.9, 1], 
        root: slider,
        rootMargin: '0px -1px 0px -1px' // Small margin to account for sub-pixel rendering
      };
      
      this.startObserver = this.createObserver(() => {
        this.updateEdgeStates();
      }, options);
      
      this.endObserver = this.createObserver(() => {
        this.updateEdgeStates();
      }, options);
      
      // Observer to manage activation
      this.elementObserver = this.createObserver(entries => {
        if (entries[0].isIntersecting) {
          if (this.firstEl) this.startObserver.observe(this.firstEl);
          if (this.lastEl) this.endObserver.observe(this.lastEl);
        } else {
          if (this.firstEl) this.startObserver.unobserve(this.firstEl);
          if (this.lastEl) this.endObserver.unobserve(this.lastEl);
        }
      }, { threshold: 0.1 });
      
      this.elementObserver.observe(slider);
    }
    
    setupSlideMode() {
      const { slider, sliderBar } = this.els;
      
      // Clone the first element and add it as the last item to create an infinite loop effect
      const clonedFirstElement = this.firstEl.cloneNode(true);
      clonedFirstElement.classList.add('cloned-slide');
      slider.appendChild(clonedFirstElement);
      
      // Set up intersection observer to detect when the clone is in view
      const firstCloneObserver = this.createObserver(entries => {
        if (entries[0].isIntersecting && !this.state.isTransitioning) {
          this.state.isTransitioning = true;
          slider.scrollTo({ left: slider.clientWidth, behavior: 'instant' });
          setTimeout(() => { this.state.isTransitioning = false; }, 50);
        }
      }, { threshold: 1.0, root: slider });
      
      firstCloneObserver.observe(clonedFirstElement);
      this.observers.push({ observer: firstCloneObserver, target: clonedFirstElement, options: { threshold: 1.0, root: slider } });

      // Clone the last element and add it as the first item
      const clonedLastElement = this.lastEl.cloneNode(true);
      clonedLastElement.classList.add('cloned-slide');
      slider.insertBefore(clonedLastElement, slider.firstChild);
      slider.scrollTo({ left: slider.clientWidth, behavior: 'instant' });

      const lastCloneObserver = this.createObserver(entries => {
        if (entries[0].isIntersecting && !this.state.isTransitioning) {
          this.state.isTransitioning = true;
          slider.scrollTo({ left: slider.scrollWidth - (2 * slider.clientWidth), behavior: 'instant' });
          setTimeout(() => { this.state.isTransitioning = false; }, 50);
        }
      }, { threshold: 1.0, root: slider });
      
      lastCloneObserver.observe(clonedLastElement);
      this.observers.push({ observer: lastCloneObserver, target: clonedLastElement, options: { threshold: 1.0, root: slider } });

      if (sliderBar) {
        this.cloneSliderBar = sliderBar.cloneNode(true);
        this.cloneSliderBar.style.transform = `translateX(calc(var(--slider-bar-clone-position) - var(--slider-bar-width)))`;
        this.cloneSliderBar.style.willChange = 'transform';
        sliderBar.parentElement.appendChild(this.cloneSliderBar);
      }
    }

    updateUI() {
      this.updateGradient();
      this.updateScrollability();
      this.updateSliderBar();
      this.updateVerticalBar();
      this.updateEdgeStates();
      debounce(this.updateSliderBarCSS.bind(this), 200)();
    }

    updateGradient() {
      const { gradient, slider } = this.els;
      
      if (gradient && this.items?.[0]) {
        const height = this.items[0].clientHeight || 0;
        slider.style.setProperty("--gradient-height", `${height}px`);
      }
    }

    updateScrollability() {
      const { slider, nav, sliderBar, dots, thumbnails, prevBtn, nextBtn, verticalBarWrapper } = this.els;
      const isHidden = slider.scrollWidth <= slider.clientWidth;
      nav?.classList.toggle("hidden", isHidden);
      sliderBar?.parentElement?.classList.toggle("hidden", isHidden);
      dots?.classList.toggle("hidden", isHidden);
      thumbnails?.classList.toggle("hidden", isHidden);
      prevBtn?.classList.toggle("hidden", isHidden);
      nextBtn?.classList.toggle("hidden", isHidden);
      
      // Vertical bar visibility is handled in updateVerticalBar() method
      // since it depends on vertical scrollability, not horizontal
    }

    updateNavVisibility() {
      const { prevBtn, nextBtn, prevWrapper, sliderBar } = this.els;
      
      if (!prevBtn || !nextBtn) return;
      
      const isHidden = prevBtn.hasAttribute("disabled") && nextBtn.hasAttribute("disabled");
      prevWrapper?.classList.toggle("opacity-0", isHidden);
    }

    /**
     * Apply disabled + aria-disabled to a nav button for visual and a11y boundary state.
     * @param {HTMLElement|null|undefined} button
     * @param {boolean} isDisabled
     * @private
     */
    #setNavButtonDisabled(button, isDisabled) {
      if (!button) return;
      button.toggleAttribute('disabled', isDisabled);
      if (isDisabled) {
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-disabled');
      }
    }

    /**
     * Update edge states based on scroll position - more reliable than intersection observer alone
     * Recomputed on arrows, keyboard, swipe/drag, and thumbnail/dot navigation.
     * @private
     */
    updateEdgeStates() {
      const { slider, prevBtn, nextBtn } = this.els;
      if (!slider || (!prevBtn && !nextBtn)) return;
      
      // Calculate scroll boundaries with tolerance for sub-pixel precision
      const tolerance = 2; // 2px tolerance for edge detection
      const scrollLeft = Math.round(slider.scrollLeft);
      const maxScrollLeft = Math.round(slider.scrollWidth - slider.clientWidth);
      
      // Account for slide mode offset (cloned elements)
      const startOffset = this.dataset.carouselMode === "slide" ? slider.clientWidth : 0;
      const adjustedScrollLeft = scrollLeft - startOffset;
      const adjustedMaxScroll = maxScrollLeft - (this.dataset.carouselMode === "slide" ? slider.clientWidth : 0);
      
      // Update button states
      const isAtStart = adjustedScrollLeft <= tolerance;
      const isAtEnd = adjustedMaxScroll <= tolerance || adjustedScrollLeft >= (adjustedMaxScroll - tolerance);
      
      this.#setNavButtonDisabled(prevBtn, isAtStart);
      this.#setNavButtonDisabled(nextBtn, isAtEnd);
      
      this.updateNavVisibility();
    }

    //amk currentindexi ilk basta set olamiyor dataset active falan olmadigi icin
    get currentIndex() {
      return [...this.items].findIndex(item => item.dataset.active === 'true') || 0;
    }

    set currentIndex(index) {
      if (!this.items?.length || index < 0 || index >= this.items.length) return;
      this.items.forEach(item => item.dataset.active = 'false');
      this.items[index].dataset.active = 'true';
      this.updateNavs(index)
    }

    updateNavs(targetIndex) {
      // Update dots
      if (this.els.dots) {
        const dots = [...this.els.dots.children];
        dots.forEach(dot => dot.dataset.active = 'false');
        dots[targetIndex].dataset.active = 'true';
      }

      // Update thumbnails
      if (this.els.thumbnails) {
        const thumbnails = [...this.els.thumbnails.children];
        thumbnails.forEach(thumbnail => thumbnail.dataset.active = 'false');
        thumbnails[targetIndex].dataset.active = 'true';
      }

      this.updateSliderBar()
    }

    handleDirectionClick(event) {
      event.preventDefault();
      const button = event.currentTarget;
      if (button?.disabled || button?.getAttribute('aria-disabled') === 'true') {
        return;
      }

      const { slider } = this.els;
      const { clientWidth } = this.getValues();
      const direction = button?.name === "next" ? 1 : -1;
      const step = this.dataset.sliderStepBy === "page" 
      ? clientWidth || 0
      : this.firstEl?.clientWidth || 0;

      if(step) {
        slider.scrollTo({
          left: slider.scrollLeft + (direction * step),
          behavior: 'smooth'
        });
        // Smooth scroll / scroll-snap can skip a final scroll event in some
        // browsers (notably inside modals). Recompute boundaries after settle.
        this.#scheduleEdgeStateSync(slider);
      }
    }

    /**
     * Recompute prev/next disabled state after scroll settles.
     * @param {HTMLElement} slider
     * @private
     */
    #scheduleEdgeStateSync(slider) {
      if (!slider) {
        this.updateEdgeStates();
        return;
      }

      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        slider.removeEventListener('scrollend', onScrollEnd);
        this.updateEdgeStates();
      };
      const onScrollEnd = () => finish();

      slider.addEventListener('scrollend', onScrollEnd, { once: true });
      // Fallback when scrollend is unsupported or never fires.
      setTimeout(finish, 350);
      requestAnimationFrame(() => this.updateEdgeStates());
    }

    /**
     * Handle vertical navigation button clicks
     * Scrolls the slider vertically when up/down buttons are clicked
     * @param {Event} event - Click event from vertical navigation button
     * @private
     */
    handleVerticalDirectionClick(event) {
      event.preventDefault();
      const { slider } = this.els;
      const direction = event.currentTarget.name === "down" ? 1 : -1;
      const clientHeight = slider.clientHeight;
      const step = clientHeight || 0;

      if (step) {
        slider.scrollTo({
          top: slider.scrollTop + (direction * step),
          behavior: 'smooth'
        });
      }
    }

    navigateSlider(index, behavior = 'smooth') {
      const { slider } = this.els;
      const { clientWidth } = this.getValues();
      const step = this.dataset.sliderStepBy === "page" 
        ? clientWidth || 0
        : this.firstEl?.clientWidth || 0;
        
      if (step) {
        const targetScrollLeft = (index + (this.dataset.carouselMode === "slide" ? 1 : 0)) * step;
        
        if (behavior === 'instant') {
          requestAnimationFrame(() => {
            slider.style.scrollBehavior = 'auto';
            slider.style.scrollSnapType = 'none';
            slider.scrollLeft = targetScrollLeft;
            requestAnimationFrame(() => {
              this.updateSliderBar();
              this.updateEdgeStates();
              slider.style.scrollBehavior = '';
              slider.style.scrollSnapType = '';
            });
          });
        } else {
          // Use scrollTo for smooth scrolling
          slider.scrollTo({
            left: targetScrollLeft,
            behavior: behavior
          });
        }
      }

      this.currentIndex = index;
      
      // Update edge states after navigation (only for smooth scrolling)
      if (behavior !== 'instant') {
        setTimeout(() => this.updateEdgeStates(), 50);
      }
    }

    shouldStartDrag(e) {
      const isTouchEvent = e.type.includes('touch');
      const clientX = isTouchEvent ? e.touches[0].clientX : e.clientX;
      const { slider } = this.els;
      
      // Store initial position
      this.state.initialPos = {
        left: slider.scrollLeft,
        x: clientX
      };
      
      return true;
    }

    startDrag(e, preventDefault = true) {
      if (this.state.isDragging) return;
      
      const isTouchEvent = e.type.includes('touch');
      // Return early if it's a touch event but not in carousel mode
      if (isTouchEvent && !this.dataset.carouselMode) return;
      
      const clientX = isTouchEvent ? e.touches[0].clientX : e.clientX;
      const { slider } = this.els;
      
      this.state = {
        ...this.state,
        isDragging: true,
        wasDragged: false,
        pos: {
          left: slider.scrollLeft,
          x: clientX
        }
      };
      
      // Disable smooth scrolling during drag
      slider.style.scrollBehavior = "auto";
      slider.style.scrollSnapType = "none";
      
      this.addGlobalEvents(isTouchEvent);
    }

    dragMove(e) {
      if (!this.state.isDragging) return;
      
      const isTouchEvent = e.type.includes('touch');
      if (isTouchEvent) {
        // Check if we've moved enough to consider this a drag
        const touch = e.touches[0];
        const dx = Math.abs(touch.clientX - this.state.initialTouch.x);
        const dy = Math.abs(touch.clientY - this.state.initialTouch.y);
        const timeDiff = Date.now() - this.state.initialTouch.time;
        
        // If we've moved enough horizontally and not too much vertically, prevent default
        if (dx > 10 && dy < 20 && timeDiff < 300) {
          e.preventDefault();
        }
      }
      
      const clientX = isTouchEvent ? e.touches[0].clientX : e.clientX;
      const { pos, dragThreshold } = this.state;
      const dx = clientX - pos.x;
      
      if (Math.abs(dx) <= dragThreshold) {
        return;
      }
      this.state.wasDragged = true;
      
      const { slider } = this.els;
      slider.scrollLeft = pos.left - dx;
      this.updateSliderBar();
    }

    dragEnd() {
      if (!this.state.isDragging) return;
      
      this.state.isDragging = false;
      
      // Remove all event listeners
      this.cleanUpGlobalEvents();
      
      const { slider } = this.els;

      if (!this.state.wasDragged) return;
      
      const direction = slider.scrollLeft > this.state.pos.left ? "right" : "left";
      const target = this.findSnapPoint({
        currentScrollLeft: slider.scrollLeft,
        dragDirection: direction,
        by: 'page'
      });
      
      slider.scrollTo({ left: target, behavior: 'smooth' });
      slider.addEventListener('wheel', this.resetScrollSnap);
      
      // Update edge states after drag end
      setTimeout(() => this.updateEdgeStates(), 100);
    }

    resetScrollSnap() {
      setTimeout(() => {
        const { slider } = this.els;
        slider.style.scrollSnapType = "x mandatory";
        slider.style.scrollBehavior = "smooth";
        slider.removeEventListener('wheel', this.resetScrollSnap);
      }, 100);
    }

    startBarDrag(e) {
      e.preventDefault();
      const { slider, sliderBar } = this.els;
      const isTouch = e.type.includes('touch');
      const { clientWidth, handleWidth, scrollable } = this.getValues();
      
      this.state.isDragging = true;
      sliderBar.style.cursor = 'grabbing';
      slider.style.scrollBehavior = "auto";
      slider.style.scrollSnapType = "none";
      
      const trackRect = sliderBar.parentElement.getBoundingClientRect();
      const startScrollLeft = slider.scrollLeft;
      const handleRect = sliderBar.getBoundingClientRect();
      const handleOffset = (isTouch ? e.touches[0].clientX : e.clientX) - handleRect.left;

      const moveHandler = (e) => {
        if (!this.state.isDragging) return;
        
        const cursorX = (e.touches ? e.touches[0].clientX : e.clientX);
        const cursorPosition = cursorX - trackRect.left - handleOffset;
        const effectiveWidth = trackRect.width - (trackRect.width * handleWidth);
        const progress = Math.max(0, Math.min(1, cursorPosition / effectiveWidth));

        slider.scrollLeft = progress * scrollable + (this.dataset.carouselMode === "slide" ? clientWidth : 0)
        
        this.updateSliderBar();
      };

      const stopHandler = () => {
        if (!this.state.isDragging) return;
        
        this.state.isDragging = false;
        sliderBar.style.cursor = 'grab';
        
        const direction = slider.scrollLeft < startScrollLeft ? "left" : "right";
        const target = this.findSnapPoint({
          currentScrollLeft: slider.scrollLeft,
          dragDirection: direction,
          by: 'item'
        });

        slider.scrollTo({ left: target, behavior: 'smooth' });
        
        slider.addEventListener('wheel', this.resetScrollSnap);
        document.removeEventListener('mousemove', moveHandler);
        document.removeEventListener('mouseup', stopHandler);
        document.removeEventListener('touchmove', moveHandler);
        document.removeEventListener('touchend', stopHandler);
        document.removeEventListener('touchcancel', stopHandler);

        this.resetScrollSnap();
        
        // Update edge states after slider bar drag
        setTimeout(() => this.updateEdgeStates(), 100);
      };

      // Add appropriate event listeners
      if (isTouch) {
        document.addEventListener('touchmove', moveHandler, { passive: false });
        document.addEventListener('touchend', stopHandler);
        document.addEventListener('touchcancel', stopHandler);
      } else {
        document.addEventListener('mousemove', moveHandler);
        document.addEventListener('mouseup', stopHandler);
      }
    }

    findSnapPoint({ currentScrollLeft, dragDirection, by = 'page' }) {
      const { slider } = this.els;
      const { scrollPaddingLeft: padding, gap, clientWidth: sliderClientWidth, scrollable } = this.getValues();
      let targetScrollLeft = currentScrollLeft;
      let closestDiff = Infinity;

      if (by === 'item') {
        const itemOffsets = Array.from(slider.children, (item) => item.offsetLeft);
        for (let i = 0; i < slider.children.length; i++) {
          const itemLeft = itemOffsets[i] - padding;
          const diff = itemLeft - currentScrollLeft;
          const absDiff = Math.abs(diff);
          
          if ((dragDirection === "right" && diff >= 0) || 
              (dragDirection === "left" && diff <= 0) || 
              diff === 0) {
            if (absDiff < closestDiff) {
              closestDiff = absDiff;
              targetScrollLeft = itemLeft;
            }
          }
        }
      } else if (by === 'page') {
        const times = sliderClientWidth > 0 ? currentScrollLeft / sliderClientWidth : 0;
        targetScrollLeft = sliderClientWidth * (dragDirection === "right" ? Math.ceil(times) : Math.floor(times));
      }

      return Math.max(0, Math.min(targetScrollLeft, scrollable));
    }

    /**
     * Layout/style snapshot for slider. Cached and invalidated on resize/content change to avoid forced reflows.
     * @returns {{ scrollPaddingLeft: number, scrollPaddingRight: number, gap: number, clientWidth: number, scrollWidth: number, handleWidth: number, barWidth: number, scrollable: number }}
     */
    getValues() {
      if (this._valuesCache) return this._valuesCache;
      const { slider } = this.els;
      const scrollPaddingLeft = parseInt(getComputedStyle(slider).scrollPaddingLeft, 10) || 0;
      const scrollPaddingRight = parseInt(getComputedStyle(slider).scrollPaddingRight, 10) || 0;
      const paddingRight = parseInt(getComputedStyle(slider).paddingRight, 10) || 0;
      const paddingLeft = parseInt(getComputedStyle(slider).paddingLeft, 10) || 0;
      const gap = parseInt(getComputedStyle(slider).gap, 10) || 0;
      const totalPadding = scrollPaddingLeft + scrollPaddingRight + paddingRight + paddingLeft;
      const clientWidth = slider.clientWidth - totalPadding + gap;
      const scrollWidth = this.dataset.carouselMode === "slide"
        ? slider.scrollWidth - (2 * clientWidth) - totalPadding
        : slider.scrollWidth - totalPadding;
      const handleWidth = scrollWidth > 0 ? clientWidth / scrollWidth : 0;
      const barWidth = clientWidth * handleWidth;
      const scrollable = scrollWidth - clientWidth;
      this._valuesCache = {
        scrollPaddingLeft,
        scrollPaddingRight,
        gap,
        clientWidth,
        scrollWidth,
        handleWidth,
        barWidth,
        scrollable
      };
      return this._valuesCache;
    }

    updateSliderBarCSS() {
      const { sliderBar } = this.els;
      sliderBar?.parentElement?.style.setProperty('--slider-bar-width', `${this.getValues().barWidth}px`);
    }

    throttleUpdate() {
      requestAnimationFrame(() => {
        this.updateSliderBar();
        this.updateVerticalBar();
        this.updateCurrentIndexFromScroll();
        this.updateEdgeStates();
      });
    }

    /**
     * Update current index based on scroll position
     * This ensures dots and navigation stay in sync with manual scrolling
     * @private
     */
    updateCurrentIndexFromScroll() {
      const { slider } = this.els;
      if (!slider || !this.items.length) return;

      const { clientWidth, scrollPaddingLeft } = this.getValues();
      const scrollLeft = slider.scrollLeft;
      const startOffset = this.dataset.carouselMode === "slide" ? clientWidth : 0;
      const adjustedScrollLeft = scrollLeft - startOffset;

      let newIndex = 0;

      if (this.dataset.sliderStepBy === "page") {
        const step = clientWidth || 0;
        if (step > 0) {
          newIndex = Math.round(adjustedScrollLeft / step);
        }
      } else {
        let closestIndex = 0;
        let closestDistance = Infinity;
        const itemOffsets = this.items.map((item) => item.offsetLeft);
        this.items.forEach((item, index) => {
          const itemLeft = itemOffsets[index] - scrollPaddingLeft;
          const distance = Math.abs(itemLeft - adjustedScrollLeft);
          
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        newIndex = closestIndex;
      }

      // Clamp index to valid range
      const maxIndex = this.items.length - 1;
      newIndex = Math.max(0, Math.min(newIndex, maxIndex));

      // Only update if index actually changed to avoid unnecessary updates
      if (newIndex !== this.currentIndex) {
        // Update items' data-active without triggering setter (to avoid circular updates)
        this.items.forEach((item, index) => {
          item.dataset.active = index === newIndex ? 'true' : 'false';
        });
        
        // Update dots and thumbnails directly
        this.updateNavs(newIndex);
      }
    }

    updateSliderBar() {
      const { slider, sliderBar } = this.els;
      if (!sliderBar || slider.scrollWidth === 0) return;

      const { barWidth, scrollable, clientWidth } = this.getValues();
    
      const progress = scrollable > 0 ? (slider.scrollLeft - (this.dataset.carouselMode === "slide" ? clientWidth : 0)) / scrollable : 0;
      const position = progress >= 1 + (clientWidth / scrollable) ? 0 : progress * (clientWidth - barWidth);

      sliderBar.parentElement.style.setProperty('--slider-bar-position', `${position}px`);
      
      if (this.dataset.carouselMode === "slide") {
        if (progress > 1 || progress < 0) {
          sliderBar.parentElement.style.setProperty('--slider-bar-clone-position', `${barWidth + position + (progress > 1 ? -clientWidth : clientWidth)}px`);
        } else {
          setTimeout(() => {
            sliderBar.parentElement.style.setProperty('--slider-bar-clone-position', `-${barWidth}px`);
          }, 100);
        }
      }
    }

    /**
     * Update vertical scrollbar indicator
     * Shows a vertical progress bar when the slider is vertically scrollable
     * Updates button states based on scroll position
     * @private
     */
    updateVerticalBar() {
      const { slider, verticalBarWrapper, upBtn, downBtn } = this.els;
      if (!verticalBarWrapper) return;

      // Get the actual track element for accurate height calculations
      const track = verticalBarWrapper.querySelector('.electric-slider__vertical-bar-track');
      if (!track) return;

      // Read phase: all layout/style reads first to avoid forced reflows
      const trackHeight = track.clientHeight;
      if (trackHeight === 0) {
        requestAnimationFrame(() => this.updateVerticalBar());
        return;
      }
      const scrollHeight = slider.scrollHeight;
      const clientHeight = slider.clientHeight;
      const overflowY = window.getComputedStyle(slider).overflowY;
      const scrollTop = slider.scrollTop;

      const isVerticallyScrollable = scrollHeight > clientHeight &&
        (overflowY === 'scroll' || overflowY === 'auto' || overflowY === 'overlay');
      const scrollableHeight = scrollHeight - clientHeight;
      const barHeightPercent = scrollHeight > 0 ? (clientHeight / scrollHeight) * 100 : 0;
      const thumbHeight = (barHeightPercent / 100) * trackHeight;
      const maxPosition = Math.max(0, trackHeight - thumbHeight);
      const scrollProgress = scrollableHeight > 0 ? Math.min(1, Math.max(0, scrollTop / scrollableHeight)) : 0;
      const barPosition = Math.min(Math.max(0, scrollProgress * maxPosition), maxPosition);
      const tolerance = 2;
      const isAtTop = scrollTop <= tolerance;
      const isAtBottom = scrollTop >= (scrollableHeight - tolerance);

      // Write phase: all DOM/style updates after reads
      if (!isVerticallyScrollable) {
        verticalBarWrapper.style.opacity = '0';
        verticalBarWrapper.style.pointerEvents = 'none';
      this.#setNavButtonDisabled(upBtn, true);
      this.#setNavButtonDisabled(downBtn, true);
      return;
      }
      verticalBarWrapper.style.opacity = '1';
      verticalBarWrapper.style.pointerEvents = 'auto';
      if (upBtn) upBtn.style.pointerEvents = 'auto';
      if (downBtn) downBtn.style.pointerEvents = 'auto';
      verticalBarWrapper.style.setProperty('--vertical-bar-height', `${barHeightPercent}%`);
      verticalBarWrapper.style.setProperty('--vertical-bar-position', `${barPosition}px`);
      this.#setNavButtonDisabled(upBtn, isAtTop);
      this.#setNavButtonDisabled(downBtn, isAtBottom);
    }
  }

  customElements.define("electric-slider", ElectricSlider);

  /**
   * Variant radios replace innerHTML of [data-variant-dynamic] sliders, which
   * swaps nav buttons and feed nodes. Re-bind listeners after DOM replace.
   */
  document.addEventListener('variant:content-updated', (e) => {
    if (e.detail?.phase !== 'afterReplace') return;
    const productRoot = e.target;
    if (!productRoot?.querySelectorAll) return;

    productRoot.querySelectorAll('electric-slider[data-variant-dynamic]').forEach((slider) => {
      slider.reinitializeAfterVariantUpdate();
    });
  });
}
})();
(function () {
function isB2bCustomer() {
  return Boolean(window.customer?.b2b);
}

function getB2bSearchExcludeOps() {
  const raw = window.theme_settings?.b2b_search_exclude_tags;
  const tags = String(raw ?? 'discontinued')
    .split(',')
    .map((tag) => tag.trim())
    .filter(Boolean);
  return tags.map((tag) => `-tag:${tag}`).join(' ');
}

function excludeDiscontinuedTag(query) {
  const q = (query || '').trim();
  if (!isB2bCustomer()) return q;
  const exclusion = getB2bSearchExcludeOps();
  if (!exclusion) return q;
  if (q.includes(exclusion)) return q;
  return q ? `${q} ${exclusion}` : exclusion;
}

// Core functionality interfaces
class SearchFeature {
  constructor(host) {
    this.host = host;
  }

  init() {} // Optional initialization
  destroy() {} // Cleanup if needed
}
class ProductTypeFilter extends SearchFeature {
  constructor(host) {
    super(host);
    this.productTypeSelector = host.querySelector('.js-product-type');
    this.input = host.querySelector('input[type="search"]');
    this.boundFilterChange = this.handleFilterChange.bind(this);
  }

  init() {
    if (this.productTypeSelector) {
      this.productTypeSelector.addEventListener('change', this.boundFilterChange);
    }
  }

  destroy() {
    if (this.productTypeSelector) {
      this.productTypeSelector.removeEventListener('change', this.boundFilterChange);
    }
  }

  handleFilterChange() {
    this.applyFilter();
    // Trigger search with new filter if there's an active search
    if (this.input.value.trim()) {
      // If predictive search is enabled, trigger it
      if (!this.host.dataset?.disabled) {
        this.host.features.search.triggerSearch();
      }
    }
  }

  getFilter() {
    return this.productTypeSelector?.value.replace(' ', '+') || '';
  }

  applyFilter() {
    const cloneNode = this.input.cloneNode(true);
    cloneNode.setAttribute("type", "hidden");
    cloneNode.value = '';

    const productTypeFilter = this.getFilter();

    if (productTypeFilter !== '') {
      cloneNode.value += "product_type:" + productTypeFilter;
      if (this.input.value !== '') {
        cloneNode.value += ' ';
      }
    }
    cloneNode.value += this.input.value;
    cloneNode.value = excludeDiscontinuedTag(cloneNode.value);

    this.input.removeAttribute("name");
    this.input.insertAdjacentElement("afterend", cloneNode);
  }
}

class KeyboardManager extends SearchFeature {
  constructor(host) {
    super(host);
    this.input = host.querySelector('input[type="search"]');
    this.boundShortcutHandler = this.handleShortcut.bind(this);
  }

  init() {
    document.addEventListener("keydown", this.boundShortcutHandler);
  }

  destroy() {
    document.removeEventListener("keydown", this.boundShortcutHandler);
  }

  handleShortcut(event) {
    // Ignore if another handler already handled it
    if (event.defaultPrevented) return;

    // Normalize key
    const key = (event.key || '').toLowerCase();

    // Do not trigger on plain '/' while typing in editable fields
    const activeElement = document.activeElement;
    const isEditable =
      activeElement && (
        activeElement.isContentEditable ||
        activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.getAttribute?.('role') === 'textbox'
      );

    // Slash to focus only when not inside an editable target
    const isSlashFocus = key === '/' && !isEditable;

    // Cmd/Ctrl+K anywhere (avoid with extra modifiers)
    const isShortcutFocus =
      key === 'k' && (event.metaKey || event.ctrlKey) && !event.altKey && !event.shiftKey;

    if (isSlashFocus || isShortcutFocus) {
      event.preventDefault();
      
      // Check if we're on mobile
      const mobileBreakpoints = ["xs", "sm", "md"];
      const currentBreakpoint = getCurrentBreakpoint();
      const isMobile = mobileBreakpoints.includes(currentBreakpoint);
      
      if (isMobile) {
        // On mobile, just open search without focusing
        this.host.setAttribute('open', 'true');
      } else {
        // On desktop, focus the input
        this.input?.focus({ preventScroll: true });
        // Position cursor at end after focus
        setTimeout(() => {
          this.input?.setSelectionRange(this.input.value.length, this.input.value.length);
        }, 0);
      }
    }
  }
}

class PredictiveSearchCore extends SearchFeature {
  constructor(host) {
    super(host);
    this.cachedResults = {};
    this.cachedSuggestedQueries = {};
    this.input = host.querySelector('input[type="search"]');
    this.modalWrapper = host.querySelector(".search-modal-wrapper");
    this.outputWrapper = host.querySelector(".js-search-output-wrapper");
    this.resultsList = host.querySelector("#predictive-search-results-list");
    this.statusElement = host.querySelector(".predictive-search-status");
    this.displayElement = host.querySelector(".search-input-display");
    this.isOpen = false;
    this.noResults = false;
    this.show_collections = host.dataset.collections === 'true';
    this.isOpenedByClick = false; // Track if search was opened by click vs focus
    this.isSubmitting = false; // Track if form is being submitted
    this.isModalContentLoaded = Boolean(this.outputWrapper?.children.length);
    this.initialContentRequest = null;
    this.hasProcessedGlobalData = false;

    this.boundHandlers = {
      onChange: debounce(this.#handleSearchInput.bind(this), 300),
      onInput: this.onInput.bind(this),
      onFocus: this.onFocus.bind(this),
      onFocusOut: this.onFocusOut.bind(this),
      onKeyup: this.onKeyup.bind(this),
      onKeydown: this.onKeydown.bind(this),
      onSearchTriggerClick: this.onSearchTriggerClick.bind(this),
      onOverlayClick: this.onOverlayClick.bind(this),
      onPaste: this.onPaste.bind(this),
      onSearchTriggerIntent: this.onSearchTriggerIntent.bind(this),
    };
  }

  init() {
    if (this.host.dataset?.disabled) {
      return;
    }

    this.setupEventListeners();
    this.input.addEventListener('paste', this.boundHandlers.onPaste);
    this.setupComplementaryProducts();
    this.setupLazyHydrationTriggers();

    if (this.outputWrapper && this.isModalContentLoaded) {
      this.saveSuggestions();
      this.initializeSuggestionMarkup();
      if (!this.hasProcessedGlobalData) {
        this.hasProcessedGlobalData = true;
        this.checkExistingGlobalData();
      }
    }

    // Check if input already has a value (e.g., on search page)
    const currentQuery = this.getQuery();
    if (currentQuery.length > 0) {
      // If we have search terms, mark that we have results and open if focused
      this.host.setAttribute("results", true);
      // Update display to match input value
      this.updateDisplay();
      // Update search form visibility
      this.updateSearchForm();
      // Don't auto-open, but be ready to show results if user focuses
    }
  }

  destroy() {
    this.removeEventListeners();
    this.removeComplementaryEventListeners();
    this.removeLazyHydrationTriggers();
  }

  setupLazyHydrationTriggers() {
    const searchTrigger = this.host.querySelector('.js-search-trigger');
    if (!searchTrigger) return;

    searchTrigger.addEventListener('pointerenter', this.boundHandlers.onSearchTriggerIntent, { passive: true });
    searchTrigger.addEventListener('focusin', this.boundHandlers.onSearchTriggerIntent);
    searchTrigger.addEventListener('click', this.boundHandlers.onSearchTriggerIntent, { passive: true });
  }

  removeLazyHydrationTriggers() {
    const searchTrigger = this.host.querySelector('.js-search-trigger');
    if (!searchTrigger) return;

    searchTrigger.removeEventListener('pointerenter', this.boundHandlers.onSearchTriggerIntent);
    searchTrigger.removeEventListener('focusin', this.boundHandlers.onSearchTriggerIntent);
    searchTrigger.removeEventListener('click', this.boundHandlers.onSearchTriggerIntent);
  }

  onSearchTriggerIntent() {
    this.loadInitialModalContent();
  }

  async loadInitialModalContent() {
    if (this.isModalContentLoaded) {
      return true;
    }

    if (this.initialContentRequest) {
      return this.initialContentRequest;
    }

    if (!this.outputWrapper) {
      return false;
    }

    this.initialContentRequest = (async () => {
      try {
        const searchUrl = this.#getRoutes().search_url || '/search';
        const requestUrl = `${searchUrl}?section_id=api--search--predictive`;
        const response = await fetch(requestUrl, { credentials: 'same-origin' });

        if (!response.ok) {
          throw new Error(`Failed to load initial search panel: ${response.status}`);
        }

        const html = await response.text();
        const parsedDoc = new DOMParser().parseFromString(html, 'text/html');
        const sectionEl =
          parsedDoc.querySelector('#shopify-section-api--search--predictive') ||
          parsedDoc.querySelector('.shopify-section');
        const sectionMarkup = sectionEl ? sectionEl.innerHTML : html;

        this.outputWrapper.innerHTML = sectionMarkup;
        this.isModalContentLoaded = true;
        this.saveSuggestions();
        this.initializeSuggestionMarkup();

        if (typeof window.unveilLazyloadIn === 'function') {
          window.unveilLazyloadIn(this.outputWrapper);
        }

        if (!this.hasProcessedGlobalData) {
          this.hasProcessedGlobalData = true;
          this.checkExistingGlobalData();
        }

        return true;
      } catch {
        return false;
      } finally {
        this.initialContentRequest = null;
      }
    })();

    return this.initialContentRequest;
  }

  initializeSuggestionMarkup() {
    // Suggestions now include a dedicated [data-recent-searches-container] placeholder.
    // Keep the fetched markup unchanged and let injectRecentSearches() manage this region
    // to avoid duplicating "Recent Searches" after repeated open/clear/search cycles.
    if (!this.suggestions) return;
  }

  /**
   * Check if global data is already available and process it
   * @private
   */
  checkExistingGlobalData() {
    if (window.rebuyGlobalData && window.rebuyGlobalData.complementary_to_viewed && window.rebuyGlobalData.complementary_to_viewed.length > 0) {
      // Create a copy of the array to avoid modifying the original during processing
      const complementaryProducts = [...window.rebuyGlobalData.complementary_to_viewed];
      
      // Simulate the event with existing data
      const event = new CustomEvent('rebuy-complementary-ready', {
        detail: {
          products: complementaryProducts,
          count: complementaryProducts.length,
          source: 'complementary_to_viewed',
          timestamp: Date.now()
        }
      });
      
      this.handleComplementaryProducts(event);
    }
  }

  /**
   * Setup complementary products functionality
   * @private
   */
  setupComplementaryProducts() {
    this.boundComplementaryHandler = this.handleComplementaryProducts.bind(this);
    document.addEventListener('rebuy-complementary-ready', this.boundComplementaryHandler);
  }

  /**
   * Remove complementary products event listeners
   * @private
   */
  removeComplementaryEventListeners() {
    if (this.boundComplementaryHandler) {
      document.removeEventListener('rebuy-complementary-ready', this.boundComplementaryHandler);
    }
  }

  /**
   * Handle complementary products event
   * @param {CustomEvent} event - The complementary products event
   * @private
   */
  async handleComplementaryProducts(event) {
    const products = event.detail.products;
    if (!products || products.length === 0) {
      return;
    }

    // Get first two products
    const firstTwoProducts = products.slice(0, 2);
    
    const productIds = firstTwoProducts.map(product => product.id || product.shopify_product_id).filter(Boolean);

    if (productIds.length === 0) {
      return;
    }

    // Remove used products from global data
    this.#removeUsedProductsFromGlobalData(firstTwoProducts, event.detail.source);

    try {
      await this.fetchAndInsertComplementaryProducts(productIds);
    } catch (error) {
      // Silently handle error
    }
  }

  /**
   * Remove used products from global rebuy data
   * @param {Array<Object>} usedProducts - Products that were used
   * @param {string} source - The source array name (e.g., 'complementary_to_viewed')
   * @private
   */
  #removeUsedProductsFromGlobalData(usedProducts, source) {
    if (!window.rebuyGlobalData || !usedProducts || usedProducts.length === 0) {
      return;
    }

    const sourceArray = window.rebuyGlobalData[source];
    if (!Array.isArray(sourceArray)) {
      return;
    }

    // Create a set of used product IDs for efficient lookup
    const usedProductIds = new Set(
      usedProducts.map(product => product.id || product.shopify_product_id).filter(Boolean)
    );

    // Remove used products from the source array
    for (let i = sourceArray.length - 1; i >= 0; i--) {
      const product = sourceArray[i];
      const productId = product.id || product.shopify_product_id;
      
      if (productId && usedProductIds.has(productId)) {
        sourceArray.splice(i, 1);
      }
    }
  }

  /**
   * Fetch and insert complementary product cards
   * @param {Array<string>} productIds - Array of product IDs
   * @private
   */
  async fetchAndInsertComplementaryProducts(productIds) {
    const promotedList = this.host.querySelector('[data-slider="predictive-search-promoted-list"]');
    
    if (!promotedList) {
      return;
    }

    // Build search query with product IDs (don't encode the query part).
    // Apply -tag exclusion to every OR operand so Shopify does not bind NOT only to the last id:.
    const exclusion = getB2bSearchExcludeOps();
    const exclusionQuery = exclusion.replace(/\s+/g, '+');
    const applyExclusion = isB2bCustomer() && Boolean(exclusionQuery);
    let query = productIds
      .map((id) => {
        const idTerm = `id:${id}`;
        return applyExclusion ? `(${idTerm}+${exclusionQuery})` : idTerm;
      })
      .join('+OR+');
    const url = `${window.routes?.search_url || '/search'}?q=${query}&section_id=product-cards--lite&type=product`;

    try {
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`Failed to fetch complementary products: ${response.status}`);
      }

      const html = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const section = doc.querySelector('.shopify-section');

      if (section) {
        // Create a temporary container to parse the HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = section.innerHTML;

        // Get all product cards
        const productCards = tempDiv.querySelectorAll('product-card, [data-product-id]');
        
        if (productCards.length > 0) {
          // Create a document fragment for efficient DOM manipulation
          const fragment = document.createDocumentFragment();
          
          // Clone each product card and add to fragment
          productCards.forEach((card) => {
            card.classList.add('shrink-0', 'block', 'md:max-lg:!w-full', 'snap-start');
            fragment.appendChild(card.cloneNode(true));
          });

          // Insert at the beginning of the promoted list
          promotedList.insertBefore(fragment, promotedList.firstChild);
        }
      }
    } catch (error) {
      // Silently handle error
    }
  }

  setupEventListeners() {
    this.input.addEventListener("input", this.boundHandlers.onChange);
    this.input.addEventListener("input", this.boundHandlers.onInput); // Also listen to input for display sync
    this.input.addEventListener("focus", this.boundHandlers.onFocus);
    this.host.addEventListener("focusout", this.boundHandlers.onFocusOut);
    this.host.addEventListener("keyup", this.boundHandlers.onKeyup);
    this.host.addEventListener("keydown", this.boundHandlers.onKeydown);

    // Add click handler for search trigger
    const searchTrigger = this.host.querySelector('.js-search-trigger');
    if (searchTrigger) {
      searchTrigger.addEventListener('click', this.boundHandlers.onSearchTriggerClick);
    }

    // Add click handler for search overlay
    const searchOverlay = this.host.querySelector('.js-search-overlay');
    if (searchOverlay) {
      searchOverlay.addEventListener('click', this.boundHandlers.onOverlayClick);
    }
  }

  removeEventListeners() {
    this.input.removeEventListener("input", this.boundHandlers.onChange);
    this.input.removeEventListener("input", this.boundHandlers.onInput);
    this.input.removeEventListener('paste', this.boundHandlers.onPaste);
    this.input.removeEventListener("focus", this.boundHandlers.onFocus);
    this.host.removeEventListener("focusout", this.boundHandlers.onFocusOut);
    this.host.removeEventListener("keyup", this.boundHandlers.onKeyup);
    this.host.removeEventListener("keydown", this.boundHandlers.onKeydown);

    // Remove click handler for search trigger
    const searchTrigger = this.host.querySelector('.js-search-trigger');
    if (searchTrigger) {
      searchTrigger.removeEventListener('click', this.boundHandlers.onSearchTriggerClick);
    }

    // Remove click handler for search overlay
    const searchOverlay = this.host.querySelector('.js-search-overlay');
    if (searchOverlay) {
      searchOverlay.removeEventListener('click', this.boundHandlers.onOverlayClick);
    }
  }

  saveSuggestions() {
    if (!this.outputWrapper) {
      this.suggestions = '';
      return;
    }

    this.suggestions = this.outputWrapper.innerHTML;
  }

  /**
   * Generate recent searches HTML
   * @private
   * @returns {string} HTML string for recent searches section
   */
  generateRecentSearchesHtml() {
    let recentSearches = [];
    try {
      recentSearches = JSON.parse(localStorage.getItem('recent_searches') || '[]');
    } catch (e) {
      // Clear corrupted data
      localStorage.removeItem('recent_searches');
      return '';
    }

    if (!Array.isArray(recentSearches) || recentSearches.length === 0) return '';

    // Ensure all searches are strings and clean up localStorage if needed
    const validSearches = recentSearches.filter(q => typeof q === 'string' && q.trim());

    // If we filtered out invalid entries, update localStorage
    if (validSearches.length !== recentSearches.length) {
      localStorage.setItem('recent_searches', JSON.stringify(validSearches));
    }

    if (validSearches.length === 0) return '';

    return `
      <div class="text-ui-nav-title uppercase text-nowrap mb-3">
        <span>Recent Searches</span>
      </div>
      <ul class="space-y-3 font-medium mb-6">
        ${validSearches.map((query, index) => {
          return `
          <li class="slide-right-sm" style="--nth-child:${index + 1}">
            <a href="${this.#getRoutes().search_url}?q=${encodeURIComponent(excludeDiscontinuedTag(query))}" class="hover:underline w-full block">
              ${this.escapeHtml(query)}
            </a>
          </li>
        `;
        }).join('')}
      </ul>
    `;
  }

  /**
   * Escape HTML to prevent XSS
   * @private
   * @param {string} text
   * @returns {string}
   */
  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  /**
   * Inject recent searches into the dedicated container (first in wrapper so Trending stays above its list)
   * @private
   */
  injectRecentSearches() {
    if (!this.isModalContentLoaded || !this.outputWrapper) return;

    const container = this.outputWrapper.querySelector('[data-recent-searches-container]');
    if (!container) return;

    const recentSearchesHtml = this.generateRecentSearchesHtml();
    if (recentSearchesHtml) {
      container.innerHTML = recentSearchesHtml;
      container.setAttribute('data-recent-searches', 'true');
      container.classList.remove('hidden');
    } else {
      container.innerHTML = '';
      container.removeAttribute('data-recent-searches');
      container.classList.add('hidden');
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  /**
   * Shopify route URLs from _script-variables (module scope cannot use bare `routes`).
   * @returns {{ search_url: string, predictive_search_url?: string, predictive_search_suggest_json_url?: string }}
   * @private
   */
  #getRoutes() {
    return window.routes || {
      search_url: '/search',
      predictive_search_url: '/search/suggest',
      predictive_search_suggest_json_url: '/search/suggest.json',
    };
  }

  /**
   * Format user search input for Shopify search (temp: plain terms, no AND/OR operators).
   * @param {string} searchTerm - Raw input value
   * @returns {string} Query string for search API
   * @private
   */
  #formatSearchQuery(searchTerm) {
    return searchTerm.trim().toLowerCase().replace(/\s+/g, ' ');
  }

  /**
   * Fetch suggested search queries from predictive search API (e.g. "black" → "black leather")
   * @param {string} queryKey - Encoded search term
   * @returns {Promise<string>} HTML for suggested queries block or empty string
   * @private
   */
  async getSuggestedQueriesHtml(queryKey) {
    if (!queryKey || queryKey.length < 2) return '';
    const shopifyRoutes = this.#getRoutes();
    const suggestUrl = shopifyRoutes.predictive_search_suggest_json_url || (shopifyRoutes.predictive_search_url || '').split('?')[0].replace(/\/suggest\/?$/, '') + '/suggest.json';
    if (!suggestUrl || suggestUrl.endsWith('/suggest.json') === false) return '';

    if (this.cachedSuggestedQueries[queryKey] !== undefined) {
      return this.cachedSuggestedQueries[queryKey];
    }

    try {
      const params = new URLSearchParams({ q: queryKey });
      params.set('resources[type]', 'query');
      params.set('resources[limit]', '6');
      const response = await fetch(`${suggestUrl}?${params.toString()}`);
      if (!response.ok) return '';
      const data = await response.json();
      const queries = data?.resources?.results?.queries;
      if (!Array.isArray(queries) || queries.length === 0) {
        this.cachedSuggestedQueries[queryKey] = '';
        return '';
      }
      const html = `
        <div class="text-ui-nav-title uppercase text-nowrap mb-3" data-suggested-queries-heading>
          <span>Suggested</span>
        </div>
        <ul class="space-y-3 font-medium mb-6" data-suggested-queries-list role="list">
          ${queries.map((q, i) => {
            const suggestText = q.text || '';
            const suggestHref = (isB2bCustomer() || !q.url)
              ? `${this.#getRoutes().search_url}?q=${encodeURIComponent(excludeDiscontinuedTag(suggestText))}`
              : q.url;
            return `
            <li class="slide-right-sm" style="--nth-child:${i + 1}">
              <a href="${this.escapeHtml(suggestHref)}" class="hover:underline w-full block">${this.escapeHtml(suggestText || (q.styled_text ? this.#stripHtmlToText(q.styled_text) : ''))}</a>
            </li>`;
          }).join('')}
        </ul>
      `;
      this.cachedSuggestedQueries[queryKey] = html;
      return html;
    } catch {
      this.cachedSuggestedQueries[queryKey] = '';
      return '';
    }
  }

  /**
   * Strip HTML from API styled_text to plain text
   * @param {string} styled - May contain <mark> or <span> from Shopify API
   * @returns {string} Plain text
   * @private
   */
  #stripHtmlToText(styled) {
    if (!styled || typeof styled !== 'string') return '';
    const div = document.createElement('div');
    div.innerHTML = styled;
    return div.textContent || '';
  }

  /**
   * Update the display element with current input value
   * @private
   */
  updateDisplay() {
    if (!this.displayElement) return;

    const value = this.input.value.trim();
    if (value) {
      this.displayElement.textContent = value;
    } else {
      // Show placeholder text when empty
      const placeholderText = this.displayElement.getAttribute('data-placeholder');
      if (placeholderText) {
        this.displayElement.textContent = placeholderText;
      }
    }
  }

  /**
   * Update search form visibility and content based on input length
   * @private
   */
  updateSearchForm() {
    const searchFormContainer = this.host.querySelector('#search-form-container');
    const searchFormInput = this.host.querySelector('#search-form-input');
    const searchFormLabel = this.host.querySelector('#search-form-label');
    
    if (!searchFormContainer || !searchFormInput || !searchFormLabel) return;

    const value = this.input.value.trim();
    
    // Show form if input has 3+ characters, hide otherwise
    if (value.length >= 3) {
      searchFormContainer.classList.remove('hidden');
      
      // Update the hidden input value (B2B query includes theme-setting tag exclusion)
      searchFormInput.value = excludeDiscontinuedTag(value);
      
      // Update the button label with the search term
      const searchForText = window.theme?.strings?.templates?.search?.search_for || 'View all products for {{ terms }}';
      searchFormLabel.textContent = searchForText.replace('{{ terms }}', `"${value}"`);
    } else {
      searchFormContainer.classList.add('hidden');
    }
  }

  /**
   * Position cursor at the end of the input text
   * @private
   */
  positionCursorAtEnd() {
    if (!this.input) return;
    
    const value = this.input.value;
    if (value.length > 0) {
      // Use setTimeout to ensure the focus has been applied before setting cursor position
      setTimeout(() => {
        this.input.setSelectionRange(value.length, value.length);
      }, 0);
    }
  }

  /**
   * Handle input events for real-time display sync
   * @private
   */
  onInput() {
    this.updateDisplay();
    this.updateSearchForm();
  }

  /**
   * Run search immediately after paste (input event can lag behind paste in some browsers)
   * @private
   */
  onPaste() {
    if (this.isSubmitting) return;
    requestAnimationFrame(() => this.#handleSearchInput());
  }

  /**
   * Check if current device is mobile based on breakpoint
   * @returns {boolean} True if mobile device
   * @private
   */
  isMobile() {
    const mobileBreakpoints = ["xs", "sm", "md"];
    const currentBreakpoint = getCurrentBreakpoint();
    return mobileBreakpoints.includes(currentBreakpoint);
  }

  /**
   * Handle search trigger click events
   * @param {Event} event - Click event
   * @private
   */
  async onSearchTriggerClick(event) {
    // Don't handle clicks during form submission
    if (this.isSubmitting) return;
    await this.loadInitialModalContent();

    // Always open the search UI
    this.host.setAttribute('open', 'true');

    // Mark that search was opened by click
    this.isOpenedByClick = true;

    // Open search and dispatch event
    this.openSearch();

      // Focus the input for immediate typing
      setTimeout(() => {
        this.input.focus({ preventScroll: true });
        this.positionCursorAtEnd();
        this.isOpenedByClick = false; // Reset flag after focus
      }, 0);
  }

  /**
   * Handle search overlay click events
   * @param {Event} event - Click event
   * @private
   */
  onOverlayClick(event) {
    // Don't handle clicks during form submission
    if (this.isSubmitting) return;

    // Close the search when overlay is clicked
    this.close();
  }

  /**
   * Open search without focusing input (for mobile)
   * @private
   */
  openSearch() {
    // Don't open search during form submission
    if (this.isSubmitting) return;
    if (!this.isModalContentLoaded) {
      this.loadInitialModalContent();
      return;
    }

    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.showSuggestions();
    } else if (this.host.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  /**
   * Run predictive search immediately (e.g. product type filter change)
   */
  triggerSearch() {
    this.#handleSearchInput();
  }

  /**
   * Run predictive search for the current input value
   * @private
   */
  #handleSearchInput() {
    if (this.isSubmitting) return;
    if (!this.isModalContentLoaded) {
      this.loadInitialModalContent().then((loaded) => {
        if (loaded) this.#handleSearchInput();
      });
      return;
    }

    const searchTerm = this.getQuery();
    const errorMessage = this.host.querySelector('.js-error-message');
    if (errorMessage) errorMessage.style.display = '';

    if (!searchTerm.length) {
      this.showSuggestions();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFocus() {
    // Don't handle focus events during form submission
    if (this.isSubmitting) return;
    if (!this.isModalContentLoaded) {
      this.loadInitialModalContent().then((loaded) => {
        if (loaded && this.input === document.activeElement) {
          this.onFocus();
        }
      });
      return;
    }

    // On mobile, if search was opened by click, don't trigger focus behavior
    if (this.isMobile() && this.isOpenedByClick) {
      this.isOpenedByClick = false; // Reset flag
      return;
    }

    // Position cursor at end of text when focusing
    this.positionCursorAtEnd();

    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.showSuggestions();
      return;
    }

    if (this.host.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut(e) {
    // Don't handle focus events during form submission
    if (this.isSubmitting) return;

    if (e.target.getAttribute("aria-label") === "minus" ||
        e.target.getAttribute("aria-label") === "delete" ||
        e.target.getAttribute("aria-label") === "previous" ||
        e.target.getAttribute("aria-label") === "next") return;

    // On mobile, be less aggressive about closing on focus out
    // Only close if focus moves completely outside the search component
    setTimeout(() => {
      // Double-check we're still not submitting
      if (this.isSubmitting) return;

      if (!this.host.contains(document.activeElement)) {
        // On mobile, only close if the close button was explicitly clicked
        // or if focus moved to a different interactive element
        if (this.isMobile()) {
          const activeElement = document.activeElement;
          const isInteractiveElement = activeElement && (
            activeElement.tagName === 'BUTTON' ||
            activeElement.tagName === 'A' ||
            activeElement.tagName === 'INPUT' ||
            activeElement.hasAttribute('tabindex')
          );
          
          // Only close if user interacted with another element or clicked close
          if (isInteractiveElement || e.target.classList.contains('js-close-search')) {
            this.close();
          }
        } else {
          // Desktop behavior remains the same
          this.close();
        }
      }
    });
  }

  onKeyup(event) {
    // Don't handle keyboard events during form submission
    if (this.isSubmitting) return;

    switch (event.code) {
      case "Escape":
        event.preventDefault();
        this.close();
        break;
      case "ArrowUp":
        event.preventDefault();
        this.switchOption("up");
        break;
      case "ArrowDown":
        event.preventDefault();
        this.switchOption("down");
        break;
      case "Enter": {
        const selectedOption = this.host.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');
        if (selectedOption) {
          event.preventDefault();
          selectedOption.click();
        }
        break;
      }
    }
  }

  onKeydown(event) {
    // Don't handle keyboard events during form submission
    if (this.isSubmitting) return;

    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      event.preventDefault();
    }
  }

  showSuggestions() {
    if (this.host.dataset?.disabled) return;
    // Don't show suggestions during form submission
    if (this.isSubmitting) return;
    if (!this.isModalContentLoaded || !this.outputWrapper) {
      this.loadInitialModalContent().then((loaded) => {
        if (loaded) this.showSuggestions();
      });
      return;
    }

    // Only reset if we don't already have suggestions content
    if (!this.outputWrapper.querySelector('ul.popular-searches') && !this.outputWrapper.querySelector('[data-recent-searches]')) {
      this.outputWrapper.innerHTML = this.suggestions;
    }

    // Inject recent searches
    this.injectRecentSearches();

    this.host.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
    if (this.resultsList) this.resultsList.classList.remove('[&_>_*]:opacity-50');

    // Dispatch search opened event
    this.#dispatchSearchEvent('search:opened');
  }

  switchOption(direction) {
    if (!this.host.getAttribute("open")) return;

    const moveUp = direction === "up";
    const selectedElement = this.host.querySelector('[aria-selected="true"]');
    const allVisibleElements = Array.from(
      this.host.querySelectorAll("li, button.predictive-search__item")
    ).filter((element) => element.offsetParent !== null);

    let activeElementIndex = 0;
    if (moveUp && !selectedElement) return;

    let selectedElementIndex = allVisibleElements.findIndex(
      element => element === selectedElement
    );

    if (this.statusElement) this.statusElement.textContent = "";

    if (!moveUp && selectedElement) {
      activeElementIndex =
        selectedElementIndex === allVisibleElements.length - 1
          ? 0
          : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex =
        selectedElementIndex === 0
          ? allVisibleElements.length - 1
          : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];
    activeElement.setAttribute("aria-selected", true);
    if (selectedElement) selectedElement.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", activeElement.id);
  }


  async getSearchResults(searchTerm) {
    // Don't fetch search results during form submission
    if (this.isSubmitting) return;
    if (!this.isModalContentLoaded) {
      const loaded = await this.loadInitialModalContent();
      if (!loaded) return;
    }

    let queryKey = this.#formatSearchQuery(searchTerm);
    const productTypeFilter = this.host.features.productTypeFilter?.getFilter() || '';

    if (productTypeFilter !== '') {
      queryKey = queryKey ? `product_type:${productTypeFilter} ${queryKey}` : `product_type:${productTypeFilter}`;
    }

    const productQuery = excludeDiscontinuedTag(queryKey);

    this.setLiveRegionLoadingState();

    if (this.cachedResults[productQuery]) {
      this.noResults = false;
      const suggestedHtml = await this.getSuggestedQueriesHtml(queryKey);
      this.renderSearchResults(this.cachedResults[productQuery], suggestedHtml);
      return;
    }

    try {
      const [suggestedHtml, searchResponse] = await Promise.all([
        this.getSuggestedQueriesHtml(queryKey),
        fetch(
          `${this.#getRoutes().search_url}?${new URLSearchParams({
            q: productQuery,
            type: 'product',
            section_id: 'api--search--results'
          }).toString()}&resource%5Blimit_scope%5D=all`
        )
      ]);

      if (!searchResponse.ok) {
        throw new Error(searchResponse.status);
      }

      const text = await searchResponse.text();
      const resultsMarkup = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#shopify-section-api--search--results");

      if (!resultsMarkup) {
        throw new Error('Search results section not found');
      }

      const noResultsItem = resultsMarkup.querySelector("#no-results");
      const noResultsText = this.host.querySelector(".js-error-message");

      this.noResults = false;
      if (noResultsItem) {
        this.noResults = true;
        noResultsText.innerHTML = noResultsItem.innerHTML;
      } else {
        this.cachedResults[productQuery] = resultsMarkup.innerHTML;
        noResultsText.innerHTML = "";
      }

      this.renderSearchResults(resultsMarkup.innerHTML, suggestedHtml);
    } catch {
      this.#clearLoadingState();
      this.close();
    }
  }

  /**
   * Reset loading UI after fetch/render completes or fails
   * @private
   */
  #clearLoadingState() {
    this.host.removeAttribute('loading');
    if (this.resultsList) {
      this.resultsList.classList.remove('[&_>_*]:opacity-50');
    }
  }

  setLiveRegionLoadingState() {
    // Don't set loading state during form submission
    if (this.isSubmitting) return;

    this.statusElement = this.statusElement || this.host.querySelector(".predictive-search-status");
    this.loadingText = this.loadingText || this.host.getAttribute("data-loading-text");

    this.setLiveRegionText(this.loadingText);
    this.host.setAttribute("loading", true);
    if (this.resultsList) this.resultsList.classList.add('[&_>_*]:opacity-50');
  }

  setLiveRegionText(statusText) {
    if (!this.statusElement) return;

    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement?.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  /**
   * Render search results and optional suggested queries into the output wrapper
   * @param {string} resultsMarkup - HTML from search results section
   * @param {string} [suggestedQueriesHtml=''] - HTML for suggested queries block (from predictive suggest.json)
   */
  renderSearchResults(resultsMarkup, suggestedQueriesHtml = '') {
    if (this.isSubmitting) return;
    if (!this.outputWrapper) return;

    const fullMarkup = (suggestedQueriesHtml || '') + resultsMarkup;

    if (this.noResults) {
      this.host.querySelector(".js-error-message").style.display = "block";
      if (this.outputWrapper.children.length > 0) {
        this.outputWrapper.innerHTML = "";
      }
      this.#clearLoadingState();
      this.open();
    } else {
      this.host.querySelector(".js-error-message").style.display = "";
      if (this.outputWrapper.innerHTML !== fullMarkup) {
        this.outputWrapper.innerHTML = fullMarkup;
        if (typeof window.unveilLazyloadIn === 'function') {
          window.unveilLazyloadIn(this.outputWrapper);
        }
      }
      this.host.setAttribute("results", true);
      this.setLiveRegionResults();
      this.open();
    }
  }

  setLiveRegionResults() {
    const countEl = this.host.querySelector('[data-predictive-search-live-region-count-value]');
    this.#clearLoadingState();
    if (countEl) {
      this.setLiveRegionText(countEl.textContent);
    }
  }

  open() {
    // Don't open during form submission
    if (this.isSubmitting) return;
    if (!this.isModalContentLoaded || !this.outputWrapper) {
      this.loadInitialModalContent().then((loaded) => {
        if (loaded) this.open();
      });
      return;
    }

    this.host.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;

    // Inject recent searches if we're showing the initial state
    if (!this.getQuery().length && this.outputWrapper.querySelector('ul.popular-searches')) {
      this.injectRecentSearches();
    }

    // Dispatch search opened event
    this.#dispatchSearchEvent('search:opened');
  }

  close(clearSearchTerm = false) {
    // Don't close during form submission
    if (this.isSubmitting) return;

    this.#clearLoadingState();

    if (clearSearchTerm) {
      this.input.value = "";
      this.host.removeAttribute("results");
      // Update display when clearing
      this.updateDisplay();
      // Update search form visibility when clearing
      this.updateSearchForm();
      // Only clear if we have content to clear
      if (this.outputWrapper && this.outputWrapper.children.length > 0) {
        this.outputWrapper.innerHTML = "";
      }
    }

    const selected = this.host.querySelector('[aria-selected="true"]');
    if (selected) selected.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", "");
    this.host.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.isOpen = false;
    if (this.resultsList) [...this.resultsList.children].forEach(child => child.classList.remove('opacity-50') );

    // Dispatch search closed event
    this.#dispatchSearchEvent('search:closed');
  }

  /**
   * Dispatch custom search events
   * @param {string} eventType - The event type to dispatch
   * @private
   */
  #dispatchSearchEvent(eventType) {
    const event = new CustomEvent(eventType, {
      bubbles: true,
      cancelable: true,
      detail: {
        searchComponent: this.host,
        isOpen: this.isOpen
      }
    });
    
    document.dispatchEvent(event);
  }
}

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    // Initialize features
    this.features = {
      productTypeFilter: new ProductTypeFilter(this),
      keyboard: new KeyboardManager(this),
      search: new PredictiveSearchCore(this)
    };
  }

connectedCallback() {
    // Initialize all features that should work regardless of disabled state
    this.features.keyboard.init();
    this.features.productTypeFilter.init(); // Initialize product type filter

    // Initialize predictive search only if not disabled
    if (!this.dataset?.disabled) {
      this.features.search.init();
    }

    // Set up form submission handling
    const form = this.querySelector('form[role="search"]');
    form.addEventListener("submit", this.handleFormSubmit.bind(this));
  }

  disconnectedCallback() {
    // Cleanup all features
    Object.values(this.features).forEach(feature => feature.destroy?.());
  }

  handleFormSubmit(event) {
    if (this.dataset?.disabled) {
      event.preventDefault();
      this.removeAttribute("data-disabled");
      setTimeout(() => {
        this.closest('form').submit();
      }, 1000);
      return;
    }

    // If there's a selected option, let it handle the click instead
    const selectedOption = this.querySelector('[aria-selected="true"] a');
    if (selectedOption) {
      event.preventDefault();
      selectedOption.click();
      return;
    }

    // If there's no search query, prevent submission
    if (!this.features.search.getQuery().length) {
      event.preventDefault();
      return;
    }

    // For Enter key navigation to search page, save the search term and navigate smoothly
    const searchQuery = this.features.search.getQuery();
    if (searchQuery.length) {
      // Set submitting flag to prevent focus events from firing
      this.features.search.isSubmitting = true;

      // Apply filter after setting the flag to prevent focus issues
      this.features.productTypeFilter.applyFilter();

      // Save to recent searches before navigating
      this.#saveRecentSearch(searchQuery);
      // Allow form to submit naturally - don't close search UI
      // The navigation will happen and the search UI will remain open until page unloads
    }
  }

  /**
   * Save search query to recent searches
   * @param {string} query - Search query to save
   * @private
   */
  #saveRecentSearch(query) {
    if (!query || typeof query !== 'string') return;
    
    const cleanQuery = query.trim();
    if (!cleanQuery) return;

    try {
      let recentSearches = JSON.parse(localStorage.getItem('recent_searches') || '[]');
      
      // Remove if already exists to avoid duplicates
      recentSearches = recentSearches.filter(search => search !== cleanQuery);
      
      // Add to beginning
      recentSearches.unshift(cleanQuery);
      
      // Keep only last 5 searches
      recentSearches = recentSearches.slice(0, 5);
      
      localStorage.setItem('recent_searches', JSON.stringify(recentSearches));
    } catch (error) {
      // Silently handle error
    }
  }
}

customElements.define("electric-search", PredictiveSearch);
})();
(function () {
/**
 * cart-dynamic – Cart section fetcher for drawer and cart page
 * Extends SectionFetcher; refetches on cart:update (except from quantity-input). Skips popstate.
 */


if (!customElements.get("cart-dynamic")) {
  customElements.define(
    "cart-dynamic",
    class CartDynamic extends SectionFetcher {
      constructor() {
        super();
        this.disablePopEvents = true;
      }

      connectedCallback() {
        super.connectedCallback();
        document.addEventListener("cart:update", (e) => {
          if (e.detail?.source === "quantity-input") return;
          if (e.detail?.pageAlreadyRefreshed) return;
          if (this.closest("drawer-element#cart-drawer")) return;
          const fetchUrl = this.buildFetchUrl(window.location.href);
          this.fetchAndReplaceContent(fetchUrl);
        });
      }

      modified(miliseconds = 1000) {
        this.dataset.modified = true;
        setTimeout(() => {
          this.removeAttribute("data-modified");
        }, miliseconds);
      }
    },
  );
}
})();
(function () {
/**
 * ElectricCartUpsellTabs - Custom web component for cart upsell tab navigation
 *
 * Manages tab switching and visibility for cart upsell recommendations
 * with full keyboard accessibility support. Works when the script loads
 * after the drawer is opened (upgrade) and when content is injected
 * after connect (MutationObserver).
 *
 * @example
 * <electric-cart-upsell-tabs data-section-id="section-id">
 *   <!-- Tab buttons and panels -->
 * </electric-cart-upsell-tabs>
 */
if (!customElements.get('electric-cart-upsell-tabs')) {
  class ElectricCartUpsellTabs extends HTMLElement {
    #abortController = new AbortController();
    #tabButtons = [];
    #tabPanels = [];
    #observer = null;
    #isSetup = false;

    constructor() {
      super();
    }

    connectedCallback() {
      this.#setupOnce();
      if (!this.#isSetup) {
        this.#observeForLateContent();
      }
    }

    /**
     * Public init so drawer can force setup after script load or after innerHTML replace.
     * Safe to call multiple times.
     */
    init() {
      this.#setupOnce();
    }

    disconnectedCallback() {
      this.#abortController.abort();
      this.#abortController = new AbortController();
      this.#observer?.disconnect();
      this.#observer = null;
      this.#isSetup = false;
    }

    /**
     * Run tab setup if buttons and panels exist; safe to call multiple times.
     * @private
     */
    #setupOnce() {
      if (this.#isSetup) return;
      const tabButtons = Array.from(this.querySelectorAll('[data-tab-button]'));
      const tabPanels = Array.from(this.querySelectorAll('[data-tab-panel]'));
      if (tabButtons.length === 0 || tabPanels.length === 0) return;

      try {
        this.#abortController.abort();
        this.#abortController = new AbortController();
        this.#tabButtons = tabButtons;
        this.#tabPanels = tabPanels;
        const { signal } = this.#abortController;

        tabButtons.forEach((button) => {
          button.addEventListener('click', this.#handleTabClick.bind(this), { signal });
          button.addEventListener('keydown', this.#handleKeyDown.bind(this), { signal });
        });

        const firstButton = this.#tabButtons[0];
        if (firstButton) this.#activateTab(firstButton);

        this.#isSetup = true;
        this.#observer?.disconnect();
        this.#observer = null;
      } catch (error) {
        // Initialization error – leave #isSetup false so observer can retry
      }
    }

    /**
     * Watch for [data-tab-button] / [data-tab-panel] added after connect (e.g. cart drawer loads script after open).
     * @private
     */
    #observeForLateContent() {
      if (this.#observer || !this.isConnected) return;
      this.#observer = new MutationObserver(() => {
        if (!this.isConnected) return;
        this.#setupOnce();
      });
      this.#observer.observe(this, { childList: true, subtree: true });
    }

    /**
     * Handle tab button clicks
     * @param {Event} event - Click event
     * @private
     */
    #handleTabClick(event) {
      this.#activateTab(event.currentTarget);
    }

    /**
     * Handle keyboard navigation
     * @param {KeyboardEvent} event - Keyboard event
     * @private
     */
    #handleKeyDown(event) {
      const currentIndex = this.#tabButtons.indexOf(event.currentTarget);
      let targetButton = null;

      // Arrow key navigation
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        event.preventDefault();
        targetButton = this.#tabButtons[(currentIndex + 1) % this.#tabButtons.length];
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        event.preventDefault();
        targetButton = this.#tabButtons[(currentIndex - 1 + this.#tabButtons.length) % this.#tabButtons.length];
      } else if (event.key === 'Home') {
        event.preventDefault();
        targetButton = this.#tabButtons[0];
      } else if (event.key === 'End') {
        event.preventDefault();
        targetButton = this.#tabButtons[this.#tabButtons.length - 1];
      }

      if (targetButton) {
        this.#activateTab(targetButton);
        targetButton.focus();
      }
    }

    /**
     * Activate a specific tab
     * @param {HTMLElement} targetButton - Button to activate
     * @private
     */
    #activateTab(targetButton) {
      const targetPanelId = targetButton.getAttribute('aria-controls');
      const targetPanel = this.#tabPanels.find((p) => p.id === targetPanelId);

      // Update button states
      this.#tabButtons.forEach(btn => {
        const isActive = btn === targetButton;
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      // Update panel visibility (both rebuy sections load eagerly; content is already there)
      this.#tabPanels.forEach(panel => {
        const isActive = panel.id === targetPanelId;
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      // Announce tab change to screen readers
      this.#announceTabChange(targetButton);
    }

    /**
     * Announce tab change to screen readers
     * @param {HTMLElement} activeButton - The activated tab button
     * @private
     */
    #announceTabChange(activeButton) {
      // Create or get the announcer element
      let announcer = this.querySelector('[aria-live]');
      if (!announcer) {
        announcer = document.createElement('div');
        announcer.setAttribute('aria-live', 'polite');
        announcer.setAttribute('aria-atomic', 'true');
        announcer.className = 'sr-only';
        this.appendChild(announcer);
      }

      // Announce the tab change
      const tabText = activeButton.textContent?.trim() || 'Tab';
      announcer.textContent = `Switched to ${tabText} tab`;
    }
  }

  customElements.define('electric-cart-upsell-tabs', ElectricCartUpsellTabs);
}
})();
// Main script file - imports all individual scripts

// Early: pinch-zoom guard must run before sticky/blur/slider layers allocate under scale





// "./electric-property-updater.js";



// Cart section fetcher for drawer and cart page (keep on main so it's ready for section updates)

// Define cart upsell tabs on every page so drawer works after refetch (cart.js loads too late on product page)


// Cart checkout: show spinner on submit (delegation so drawer + cart page both work)
document.addEventListener('submit', (evt) => {
  const form = evt.target;
  const submitter = evt.submitter;
  if (!form || !submitter || submitter.getAttribute('name') !== 'checkout') return;
  if (!form.action || !form.action.includes('/cart')) return;
  submitter.setAttribute('aria-disabled', 'true');
  submitter.setAttribute('data-state', 'loading');
}, true);

if (!customElements.get("pagination-element")) {
  class PaginationElement extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute("data-section-fetcher-target")) return;
      this.sectionFetcherTarget = document.getElementById(
        this.dataset.sectionFetcherTarget,
      );
      this.querySelectorAll("a").forEach((link) => {
        // create new href from a href with sectionFetcherTarget's data-section-id value as a parameter to query key section_id
        const newHref = new URL(link.href);
        newHref.searchParams.set(
          "section_id",
          this.sectionFetcherTarget.dataset.sectionId,
        );
        link.href = newHref.toString();
      });
      delegate(this, "click", "a", this.onLinkClicked.bind(this));
      window.addEventListener("popstate", (event) => {
        this.handlePopState(event);
      });
    }

    handlePopState(event) {
      const page = event.state && event.state.page ? event.state.page : "1";

      const target = this.querySelector(`a[data-page="${page}"]`);

      if (target) {
        this.onLinkClicked(new Event("click"), target, true);
      }
    }

    onLinkClicked(event, target, isPopState = false) {
      event.preventDefault();

      const page = target.getAttribute("data-page");
      const searchParams = new URLSearchParams(window.location.search);
      target.style.position =
        getComputedStyle(target).position === "absolute" ? "" : "relative";
      target.innerHTML += window.icons.spinner;

      if (page === "1") {
        searchParams.delete("page");
      } else {
        searchParams.set("page", page);
      }

      const newUrl = `${window.location.pathname}${
        searchParams.toString() ? "?" + searchParams.toString() : ""
      }`;

      // if isPopState is false and the section fetcher url is the same with our current url, push a new state
      // this is to prevent pushing a new url state if we are on homepage etc.
      const targetPath = getPathWithoutQuery(
        this.sectionFetcherTarget.dataset.url,
      );
      const currentPath = getPathWithoutQuery(window.location.href);
      if (!isPopState && targetPath === currentPath) {
        window.history.pushState({ page: page }, "", newUrl);
      }

      triggerEvent(this, "pagination:page-changed", {
        searchParams: searchParams.toString(),
        sectionFetcherTarget: this.sectionFetcherTarget.id,
      });

      this.sectionFetcherTarget.dataset.skeletonItems =
        target.dataset.nextItems;
      this.sectionFetcherTarget.dataset.url = `${targetPath}${
        searchParams.toString() ? "?" + searchParams.toString() : ""
      }`;
    }
  }

  window.customElements.define("pagination-element", PaginationElement);
}

if (!customElements.get("scroll-top")) {
  customElements.define(
    "scroll-top",
    class extends HTMLElement {
      /** @type {(() => void) | null} */
      #boundToggle = null;

      connectedCallback() {
        if (this.#boundToggle) return;
        this.#boundToggle = this.toggle.bind(this);
        window.addEventListener("scroll", this.#boundToggle, { passive: true });
      }
      disconnectedCallback() {
        if (!this.#boundToggle) return;
        window.removeEventListener("scroll", this.#boundToggle);
        this.#boundToggle = null;
      }
      toggle() {
        this.dataset.fadeIn = window.scrollY > 200 ? "true" : "false";
      }
    },
  );
}

// First section margin and lazy blur images are now handled by electric-dom-ready component
// This functionality has been moved to the web component for better injection compatibility

// document.addEventListener('DOMContentLoaded', function() {
//   gsap.registerPlugin(ScrollTrigger);

//   const heroSection = document.querySelector('.hero-section');
//   const bgImg = document.querySelector('.bg-image');
//   const fgImg = document.querySelector('.parallax-image');

//   if (heroSection && bgImg && fgImg) {
//     // Background image parallax
//     const bgTl = gsap.timeline({
//       scrollTrigger: {
//         trigger: heroSection,
//         start: 'top top',
//         end: 'bottom top',
//         scrub: 0.5,
//         onUpdate: (self) => {}
//       }
//     });

//     bgTl.fromTo(bgImg,
//       { y: 0 },
//       { y: 50, ease: slideEase }
//     );

//     // Foreground image parallax
//     const fgTl = gsap.timeline({
//       scrollTrigger: {
//         trigger: heroSection,
//         start: 'top top',
//         end: 'bottom+=400 top', // extend the end point
//         scrub: 0.5,
//         onUpdate: (self) => {}
//       }
//     });

//     fgTl.fromTo(fgImg,
//       { y: 0 },
//       {
//         y: () => heroSection.offsetHeight * 0.2,
//         ease: 'none',
//         scrollTrigger: {
//           trigger: heroSection,
//           start: 'top bottom',
//           end: 'bottom top',
//           scrub: 1.5,
//           invalidateOnRefresh: true
//         }
//       }
//     );

//     const sectionContents = heroSection.querySelector('.section-contents');
//     const slideEase = 'power1.in';

//     if (sectionContents) {
//       const titleLines = sectionContents.querySelectorAll('h2, .text-solid-sm, a');

//       gsap.set(titleLines, { y: '100%', opacity: 0 });

//       ScrollTrigger.create({
//         trigger: sectionContents,
//         onEnter: () => {
//           gsap.to(titleLines, {
//             y: '0%',
//             opacity: 1,
//             duration: 0.75,
//             stagger: 0.3,
//             ease: slideEase
//           });
//         }
//       });
//     }
//     ScrollTrigger.refresh();
//   }
// });

// Click-on-load functionality is now handled by electric-dom-ready component
// This ensures it works even when scripts are injected after DOM is ready

/**
 * Mobile Popover System
 * 
 * Handles lightweight mobile popovers that appear below trigger elements
 * and disappear when clicking anywhere or clicking the trigger again.
 * Uses CSS-only animations for smooth performance.
 */
class MobilePopoverManager {
  /** @type {HTMLElement | null} Currently open popover */
  #currentPopover = null;
  /** @type {HTMLElement | null} Currently active trigger */
  #currentTrigger = null;
  /** @type {AbortController | null} Event listener controller */
  #abortController = null;

  constructor() {
    this.#initialize();
  }

  /**
   * Initialize the popover system
   * @private
   */
  #initialize() {
    this.#setupEventListeners();
  }

  /**
   * Setup event listeners for popover triggers and document clicks
   * @private
   */
  #setupEventListeners() {
    this.#abortController = new AbortController();
    
    // Handle popover triggers
    document.addEventListener('click', this.#handleTriggerClick.bind(this), {
      signal: this.#abortController.signal
    });
    
    // Handle document clicks to close popovers
    document.addEventListener('click', this.#handleDocumentClick.bind(this), {
      signal: this.#abortController.signal
    });
    
    // Handle escape key to close popovers
    document.addEventListener('keydown', this.#handleKeydown.bind(this), {
      signal: this.#abortController.signal
    });
  }

  /**
   * Handle clicks on popover trigger elements
   * @param {Event} event - Click event
   * @private
   */
  #handleTriggerClick(event) {
    const trigger = event.target.closest('[data-popover-trigger]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    const popoverId = trigger.dataset.popoverTrigger;
    const popover = document.getElementById(popoverId);
    
    if (!popover) return;

    // If clicking the same trigger, toggle the popover
    if (this.#currentTrigger === trigger && this.#currentPopover === popover) {
      this.#closePopover();
      return;
    }

    // Close any existing popover
    this.#closePopover();

    // Open the new popover
    this.#openPopover(popover, trigger);
  }

  /**
   * Handle document clicks to close popovers
   * @param {Event} event - Click event
   * @private
   */
  #handleDocumentClick(event) {
    // Don't close if clicking inside the popover or on the trigger
    if (event.target.closest('[data-popover]') || 
        event.target.closest('[data-popover-trigger]')) {
      return;
    }

    this.#closePopover();
  }

  /**
   * Handle keyboard events (escape key)
   * @param {Event} event - Keydown event
   * @private
   */
  #handleKeydown(event) {
    if (event.key === 'Escape') {
      this.#closePopover();
    }
  }

  /**
   * Open a popover
   * @param {HTMLElement} popover - Popover element to open
   * @param {HTMLElement} trigger - Trigger element that opened the popover
   * @private
   */
  #openPopover(popover, trigger) {
    this.#currentPopover = popover;
    this.#currentTrigger = trigger;

    // Show the popover with animation
    popover.style.opacity = '1';
    popover.style.pointerEvents = 'auto';
    
    // Add active state to trigger
    trigger.setAttribute('aria-expanded', 'true');
    
    // Dispatch custom event
    popover.dispatchEvent(new CustomEvent('popover:opened', {
      detail: { trigger, popover },
      bubbles: true
    }));
  }

  /**
   * Close the currently open popover
   * @private
   */
  #closePopover() {
    if (!this.#currentPopover || !this.#currentTrigger) return;

    // Hide the popover with animation
    this.#currentPopover.style.opacity = '0';
    this.#currentPopover.style.pointerEvents = 'none';
    
    // Remove active state from trigger
    this.#currentTrigger.setAttribute('aria-expanded', 'false');
    
    // Dispatch custom event
    this.#currentPopover.dispatchEvent(new CustomEvent('popover:closed', {
      detail: { trigger: this.#currentTrigger, popover: this.#currentPopover },
      bubbles: true
    }));

    // Clear references
    this.#currentPopover = null;
    this.#currentTrigger = null;
  }

  /**
   * Clean up resources
   */
  destroy() {
    this.#closePopover();
    this.#abortController?.abort();
    this.#abortController = null;
  }
}

// Initialize mobile popover system
const mobilePopoverManager = new MobilePopoverManager();

function playPauseVideo(e) {
  const video = e.target.closest('video-player').querySelector('video');
  if (video.paused) {
    video.play();
  } else {
    video.pause();
    video.currentTime = 0;
  }
}
